webpackJsonp([0,2],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(5)
  , core      = __webpack_require__(40)
  , hide      = __webpack_require__(23)
  , redefine  = __webpack_require__(24)
  , ctx       = __webpack_require__(41)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target)redefine(target, key, out, type & $export.U);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(111)('wks')
  , uid        = __webpack_require__(64)
  , Symbol     = __webpack_require__(5).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(7)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(4)
  , IE8_DOM_DEFINE = __webpack_require__(210)
  , toPrimitive    = __webpack_require__(36)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var START_DATE_CHANGE = exports.START_DATE_CHANGE = 'START_DATE_CHANGE';
var END_DATE_CHANGE = exports.END_DATE_CHANGE = 'END_DATE_CHANGE';

var FILTER_BY_AREA_TYPE = exports.FILTER_BY_AREA_TYPE = 'FILTER_BY_AREA_TYPE';
var FILTER_BY_AREA_IDENTIFIER = exports.FILTER_BY_AREA_IDENTIFIER = 'FILTER_BY_AREA_IDENTIFIER';
var FILTER_BY_AREA_CUSTOM = exports.FILTER_BY_AREA_CUSTOM = 'FILTER_BY_AREA_CUSTOM';

var TOGGLE_CUSTOM_AREA_DRAW = exports.TOGGLE_CUSTOM_AREA_DRAW = 'TOGGLE_CUSTOM_AREA_DRAW';

var FILTER_BY_TYPE_INJURY = exports.FILTER_BY_TYPE_INJURY = 'FILTER_BY_TYPE_INJURY';
var FILTER_BY_TYPE_FATALITY = exports.FILTER_BY_TYPE_FATALITY = 'FILTER_BY_TYPE_FATALITY';
var FILTER_BY_NO_INJURY_FATALITY = exports.FILTER_BY_NO_INJURY_FATALITY = 'FILTER_BY_NO_INJURY_FATALITY';

var FILTER_BY_VEHICLE_CAR = exports.FILTER_BY_VEHICLE_CAR = 'FILTER_BY_VEHICLE_CAR';
var FILTER_BY_VEHICLE_TRUCK = exports.FILTER_BY_VEHICLE_TRUCK = 'FILTER_BY_VEHICLE_TRUCK';
var FILTER_BY_VEHICLE_MOTORCYCLE = exports.FILTER_BY_VEHICLE_MOTORCYCLE = 'FILTER_BY_VEHICLE_MOTORCYCLE';
var FILTER_BY_VEHICLE_BICYCLE = exports.FILTER_BY_VEHICLE_BICYCLE = 'FILTER_BY_VEHICLE_BICYCLE';
var FILTER_BY_VEHICLE_SUV = exports.FILTER_BY_VEHICLE_SUV = 'FILTER_BY_VEHICLE_SUV';
var FILTER_BY_VEHICLE_BUSVAN = exports.FILTER_BY_VEHICLE_BUSVAN = 'FILTER_BY_VEHICLE_BUSVAN';
var FILTER_BY_VEHICLE_SCOOTER = exports.FILTER_BY_VEHICLE_SCOOTER = 'FILTER_BY_VEHICLE_SCOOTER';
var FILTER_BY_VEHICLE_OTHER = exports.FILTER_BY_VEHICLE_OTHER = 'FILTER_BY_VEHICLE_OTHER';

var FILTER_BY_CONTRIBUTING_FACTOR = exports.FILTER_BY_CONTRIBUTING_FACTOR = 'FILTER_BY_CONTRIBUTING_FACTOR';

var CRASHES_ALL_REQUEST = exports.CRASHES_ALL_REQUEST = 'CRASHES_ALL_REQUEST';
var CRASHES_ALL_SUCCESS = exports.CRASHES_ALL_SUCCESS = 'CRASHES_ALL_SUCCESS';
var CRASHES_ALL_ERROR = exports.CRASHES_ALL_ERROR = 'CRASHES_ALL_ERROR';

var CONTRIBUTING_FACTORS_REQUEST = exports.CONTRIBUTING_FACTORS_REQUEST = 'CONTRIBUTING_FACTORS_REQUEST';
var CONTRIBUTING_FACTORS_SUCCESS = exports.CONTRIBUTING_FACTORS_SUCCESS = 'CONTRIBUTING_FACTORS_SUCCESS';
var CONTRIBUTING_FACTORS_ERROR = exports.CONTRIBUTING_FACTORS_ERROR = 'CONTRIBUTING_FACTORS_ERROR';

var CRASHES_YEAR_RANGE_REQUEST = exports.CRASHES_YEAR_RANGE_REQUEST = 'CRASHES_YEAR_RANGE_REQUEST';
var CRASHES_YEAR_RANGE_SUCCESS = exports.CRASHES_YEAR_RANGE_SUCCESS = 'CRASHES_YEAR_RANGE_SUCCESS';
var CRASHES_YEAR_RANGE_ERROR = exports.CRASHES_YEAR_RANGE_ERROR = 'CRASHES_YEAR_RANGE_ERROR';

var CRASHES_DATE_RANGE_REQUEST = exports.CRASHES_DATE_RANGE_REQUEST = 'CRASHES_DATE_RANGE_REQUEST';
var CRASHES_DATE_RANGE_SUCCESS = exports.CRASHES_DATE_RANGE_SUCCESS = 'CRASHES_DATE_RANGE_SUCCESS';
var CRASHES_DATE_RANGE_ERROR = exports.CRASHES_DATE_RANGE_ERROR = 'CRASHES_DATE_RANGE_ERROR';

var CRASHES_MAX_DATE_REQUEST = exports.CRASHES_MAX_DATE_REQUEST = 'CRASHES_MAX_DATE_REQUEST';
var CRASHES_MAX_DATE_RESPONSE = exports.CRASHES_MAX_DATE_RESPONSE = 'CRASHES_MAX_DATE_RESPONSE';
var CRASHES_MAX_DATE_ERROR = exports.CRASHES_MAX_DATE_ERROR = 'CRASHES_MAX_DATE_ERROR';

var GEO_POLYGONS_REQUEST = exports.GEO_POLYGONS_REQUEST = 'GEO_POLYGONS_REQUEST';
var GEO_POLYGONS_SUCCESS = exports.GEO_POLYGONS_SUCCESS = 'GEO_POLYGONS_SUCCESS';
var GEO_POLYGONS_ERROR = exports.GEO_POLYGONS_ERROR = 'GEO_POLYGONS_ERROR';

var MODAL_OPENED = exports.MODAL_OPENED = 'MODAL_OPENED';
var MODAL_CLOSED = exports.MODAL_CLOSED = 'MODAL_CLOSED';

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(49)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(30);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(13)
  , createDesc = __webpack_require__(48);
module.exports = __webpack_require__(12) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(5)
  , hide      = __webpack_require__(23)
  , has       = __webpack_require__(19)
  , SRC       = __webpack_require__(64)('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

__webpack_require__(40).inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  var isFunction = typeof val == 'function';
  if(isFunction)has(val, 'name') || hide(val, 'name', key);
  if(O[key] === val)return;
  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if(O === global){
    O[key] = val;
  } else {
    if(!safe){
      delete O[key];
      hide(O, key, val);
    } else {
      if(O[key])O[key] = val;
      else hide(O, key, val);
    }
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0)
  , fails   = __webpack_require__(7)
  , defined = __webpack_require__(30)
  , quot    = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function(string, tag, attribute, value) {
  var S  = String(defined(string))
    , p1 = '<' + tag;
  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function(NAME, exec){
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function(){
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(87)
  , defined = __webpack_require__(30);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(88)
  , createDesc     = __webpack_require__(48)
  , toIObject      = __webpack_require__(26)
  , toPrimitive    = __webpack_require__(36)
  , has            = __webpack_require__(19)
  , IE8_DOM_DEFINE = __webpack_require__(210)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(12) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(19)
  , toObject    = __webpack_require__(17)
  , IE_PROTO    = __webpack_require__(145)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(7);

module.exports = function(method, arg){
  return !!method && fails(function(){
    arg ? method.call(null, function(){}, 1) : method.call(null);
  });
};

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(41)
  , IObject  = __webpack_require__(87)
  , toObject = __webpack_require__(17)
  , toLength = __webpack_require__(16)
  , asc      = __webpack_require__(481);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0)
  , core    = __webpack_require__(40)
  , fails   = __webpack_require__(7);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(9);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(241);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = exports.openModal = exports.filterByContributingFactor = exports.toggleCustomAreaDraw = exports.filterByAreaCustom = exports.filterByAreaIdentifier = exports.filterByAreaType = exports.filterByVehicleOther = exports.filterByVehicleScooter = exports.filterByVehicleBusVan = exports.filterByVehicleSuv = exports.filterByVehicleBicycle = exports.filterByVehicleMotorcycle = exports.filterByVehicleTruck = exports.filterByVehicleCar = exports.filterByNoInjFat = exports.filterByTypeFatality = exports.filterByTypeInjury = exports.endDateChange = exports.startDateChange = exports.fetchGeoPolygons = exports.fetchCrashesMaxDate = exports.fetchCrashesDateRange = exports.fetchCrashesYearRange = exports.fetchContributingFactors = exports.fetchCrashStatsData = undefined;

var _async_actions = __webpack_require__(413);

Object.defineProperty(exports, 'fetchCrashStatsData', {
  enumerable: true,
  get: function get() {
    return _async_actions.fetchCrashStatsData;
  }
});
Object.defineProperty(exports, 'fetchContributingFactors', {
  enumerable: true,
  get: function get() {
    return _async_actions.fetchContributingFactors;
  }
});
Object.defineProperty(exports, 'fetchCrashesYearRange', {
  enumerable: true,
  get: function get() {
    return _async_actions.fetchCrashesYearRange;
  }
});
Object.defineProperty(exports, 'fetchCrashesDateRange', {
  enumerable: true,
  get: function get() {
    return _async_actions.fetchCrashesDateRange;
  }
});
Object.defineProperty(exports, 'fetchCrashesMaxDate', {
  enumerable: true,
  get: function get() {
    return _async_actions.fetchCrashesMaxDate;
  }
});
Object.defineProperty(exports, 'fetchGeoPolygons', {
  enumerable: true,
  get: function get() {
    return _async_actions.fetchGeoPolygons;
  }
});

var _filter_by_date_actions = __webpack_require__(415);

Object.defineProperty(exports, 'startDateChange', {
  enumerable: true,
  get: function get() {
    return _filter_by_date_actions.startDateChange;
  }
});
Object.defineProperty(exports, 'endDateChange', {
  enumerable: true,
  get: function get() {
    return _filter_by_date_actions.endDateChange;
  }
});

var _filter_by_type_actions = __webpack_require__(416);

Object.defineProperty(exports, 'filterByTypeInjury', {
  enumerable: true,
  get: function get() {
    return _filter_by_type_actions.filterByTypeInjury;
  }
});
Object.defineProperty(exports, 'filterByTypeFatality', {
  enumerable: true,
  get: function get() {
    return _filter_by_type_actions.filterByTypeFatality;
  }
});
Object.defineProperty(exports, 'filterByNoInjFat', {
  enumerable: true,
  get: function get() {
    return _filter_by_type_actions.filterByNoInjFat;
  }
});

var _filter_by_vehicle_actions = __webpack_require__(417);

Object.defineProperty(exports, 'filterByVehicleCar', {
  enumerable: true,
  get: function get() {
    return _filter_by_vehicle_actions.filterByVehicleCar;
  }
});
Object.defineProperty(exports, 'filterByVehicleTruck', {
  enumerable: true,
  get: function get() {
    return _filter_by_vehicle_actions.filterByVehicleTruck;
  }
});
Object.defineProperty(exports, 'filterByVehicleMotorcycle', {
  enumerable: true,
  get: function get() {
    return _filter_by_vehicle_actions.filterByVehicleMotorcycle;
  }
});
Object.defineProperty(exports, 'filterByVehicleBicycle', {
  enumerable: true,
  get: function get() {
    return _filter_by_vehicle_actions.filterByVehicleBicycle;
  }
});
Object.defineProperty(exports, 'filterByVehicleSuv', {
  enumerable: true,
  get: function get() {
    return _filter_by_vehicle_actions.filterByVehicleSuv;
  }
});
Object.defineProperty(exports, 'filterByVehicleBusVan', {
  enumerable: true,
  get: function get() {
    return _filter_by_vehicle_actions.filterByVehicleBusVan;
  }
});
Object.defineProperty(exports, 'filterByVehicleScooter', {
  enumerable: true,
  get: function get() {
    return _filter_by_vehicle_actions.filterByVehicleScooter;
  }
});
Object.defineProperty(exports, 'filterByVehicleOther', {
  enumerable: true,
  get: function get() {
    return _filter_by_vehicle_actions.filterByVehicleOther;
  }
});

var _filter_by_area_actions = __webpack_require__(414);

Object.defineProperty(exports, 'filterByAreaType', {
  enumerable: true,
  get: function get() {
    return _filter_by_area_actions.filterByAreaType;
  }
});
Object.defineProperty(exports, 'filterByAreaIdentifier', {
  enumerable: true,
  get: function get() {
    return _filter_by_area_actions.filterByAreaIdentifier;
  }
});
Object.defineProperty(exports, 'filterByAreaCustom', {
  enumerable: true,
  get: function get() {
    return _filter_by_area_actions.filterByAreaCustom;
  }
});
Object.defineProperty(exports, 'toggleCustomAreaDraw', {
  enumerable: true,
  get: function get() {
    return _filter_by_area_actions.toggleCustomAreaDraw;
  }
});

var _modal_actions = __webpack_require__(419);

Object.defineProperty(exports, 'openModal', {
  enumerable: true,
  get: function get() {
    return _modal_actions.openModal;
  }
});
Object.defineProperty(exports, 'closeModal', {
  enumerable: true,
  get: function get() {
    return _modal_actions.closeModal;
  }
});

var _filter_contributing_factor_actions = __webpack_require__(418);

var _filter_contributing_factor_actions2 = _interopRequireDefault(_filter_contributing_factor_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.filterByContributingFactor = _filter_contributing_factor_actions2.default;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(22);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var Map     = __webpack_require__(226)
  , $export = __webpack_require__(0)
  , shared  = __webpack_require__(111)('metadata')
  , store   = shared.store || (shared.store = new (__webpack_require__(229)));

var getOrCreateMetadataMap = function(target, targetKey, create){
  var targetMetadata = store.get(target);
  if(!targetMetadata){
    if(!create)return undefined;
    store.set(target, targetMetadata = new Map);
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if(!keyMetadata){
    if(!create)return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map);
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function(target, targetKey){
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
    , keys        = [];
  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
  return keys;
};
var toMetaKey = function(it){
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function(O){
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if(__webpack_require__(12)){
  var LIBRARY             = __webpack_require__(57)
    , global              = __webpack_require__(5)
    , fails               = __webpack_require__(7)
    , $export             = __webpack_require__(0)
    , $typed              = __webpack_require__(112)
    , $buffer             = __webpack_require__(152)
    , ctx                 = __webpack_require__(41)
    , anInstance          = __webpack_require__(56)
    , propertyDesc        = __webpack_require__(48)
    , hide                = __webpack_require__(23)
    , redefineAll         = __webpack_require__(61)
    , toInteger           = __webpack_require__(49)
    , toLength            = __webpack_require__(16)
    , toIndex             = __webpack_require__(63)
    , toPrimitive         = __webpack_require__(36)
    , has                 = __webpack_require__(19)
    , same                = __webpack_require__(223)
    , classof             = __webpack_require__(86)
    , isObject            = __webpack_require__(9)
    , toObject            = __webpack_require__(17)
    , isArrayIter         = __webpack_require__(137)
    , create              = __webpack_require__(58)
    , getPrototypeOf      = __webpack_require__(28)
    , gOPN                = __webpack_require__(59).f
    , getIterFn           = __webpack_require__(154)
    , uid                 = __webpack_require__(64)
    , wks                 = __webpack_require__(10)
    , createArrayMethod   = __webpack_require__(34)
    , createArrayIncludes = __webpack_require__(102)
    , speciesConstructor  = __webpack_require__(146)
    , ArrayIterators      = __webpack_require__(155)
    , Iterators           = __webpack_require__(71)
    , $iterDetect         = __webpack_require__(108)
    , setSpecies          = __webpack_require__(62)
    , arrayFill           = __webpack_require__(130)
    , arrayCopyWithin     = __webpack_require__(203)
    , $DP                 = __webpack_require__(13)
    , $GOPD               = __webpack_require__(27)
    , dP                  = $DP.f
    , gOPD                = $GOPD.f
    , RangeError          = global.RangeError
    , TypeError           = global.TypeError
    , Uint8Array          = global.Uint8Array
    , ARRAY_BUFFER        = 'ArrayBuffer'
    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
    , PROTOTYPE           = 'prototype'
    , ArrayProto          = Array[PROTOTYPE]
    , $ArrayBuffer        = $buffer.ArrayBuffer
    , $DataView           = $buffer.DataView
    , arrayForEach        = createArrayMethod(0)
    , arrayFilter         = createArrayMethod(2)
    , arraySome           = createArrayMethod(3)
    , arrayEvery          = createArrayMethod(4)
    , arrayFind           = createArrayMethod(5)
    , arrayFindIndex      = createArrayMethod(6)
    , arrayIncludes       = createArrayIncludes(true)
    , arrayIndexOf        = createArrayIncludes(false)
    , arrayValues         = ArrayIterators.values
    , arrayKeys           = ArrayIterators.keys
    , arrayEntries        = ArrayIterators.entries
    , arrayLastIndexOf    = ArrayProto.lastIndexOf
    , arrayReduce         = ArrayProto.reduce
    , arrayReduceRight    = ArrayProto.reduceRight
    , arrayJoin           = ArrayProto.join
    , arraySort           = ArrayProto.sort
    , arraySlice          = ArrayProto.slice
    , arrayToString       = ArrayProto.toString
    , arrayToLocaleString = ArrayProto.toLocaleString
    , ITERATOR            = wks('iterator')
    , TAG                 = wks('toStringTag')
    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
    , DEF_CONSTRUCTOR     = uid('def_constructor')
    , ALL_CONSTRUCTORS    = $typed.CONSTR
    , TYPED_ARRAY         = $typed.TYPED
    , VIEW                = $typed.VIEW
    , WRONG_LENGTH        = 'Wrong length!';

  var $map = createArrayMethod(1, function(O, length){
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function(){
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
    new Uint8Array(1).set({});
  });

  var strictToLength = function(it, SAME){
    if(it === undefined)throw TypeError(WRONG_LENGTH);
    var number = +it
      , length = toLength(it);
    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
    return length;
  };

  var toOffset = function(it, BYTES){
    var offset = toInteger(it);
    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function(it){
    if(isObject(it) && TYPED_ARRAY in it)return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function(C, length){
    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function(O, list){
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function(C, list){
    var index  = 0
      , length = list.length
      , result = allocate(C, length);
    while(length > index)result[index] = list[index++];
    return result;
  };

  var addGetter = function(it, key, internal){
    dP(it, key, {get: function(){ return this._d[internal]; }});
  };

  var $from = function from(source /*, mapfn, thisArg */){
    var O       = toObject(source)
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , iterFn  = getIterFn(O)
      , i, length, values, result, step, iterator;
    if(iterFn != undefined && !isArrayIter(iterFn)){
      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
        values.push(step.value);
      } O = values;
    }
    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/*...items*/){
    var index  = 0
      , length = arguments.length
      , result = allocate(this, length);
    while(length > index)result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString(){
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /*, end */){
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /*, thisArg */){
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /*, thisArg */){
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /*, thisArg */){
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /*, thisArg */){
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /*, thisArg */){
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /*, fromIndex */){
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /*, fromIndex */){
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator){ // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /*, thisArg */){
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse(){
      var that   = this
        , length = validate(that).length
        , middle = Math.floor(length / 2)
        , index  = 0
        , value;
      while(index < middle){
        value         = that[index];
        that[index++] = that[--length];
        that[length]  = value;
      } return that;
    },
    some: function some(callbackfn /*, thisArg */){
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn){
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end){
      var O      = validate(this)
        , length = O.length
        , $begin = toIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end){
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /*, offset */){
    validate(this);
    var offset = toOffset(arguments[1], 1)
      , length = this.length
      , src    = toObject(arrayLike)
      , len    = toLength(src.length)
      , index  = 0;
    if(len + offset > length)throw RangeError(WRONG_LENGTH);
    while(index < len)this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries(){
      return arrayEntries.call(validate(this));
    },
    keys: function keys(){
      return arrayKeys.call(validate(this));
    },
    values: function values(){
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function(target, key){
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key){
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc){
    if(isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ){
      target[key] = desc.value;
      return target;
    } else return dP(target, key, desc);
  };

  if(!ALL_CONSTRUCTORS){
    $GOPD.f = $getDesc;
    $DP.f   = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty:           $setDesc
  });

  if(fails(function(){ arrayToString.call({}); })){
    arrayToString = arrayToLocaleString = function toString(){
      return arrayJoin.call(this);
    }
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice:          $slice,
    set:            $set,
    constructor:    function(){ /* noop */ },
    toString:       arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function(){ return this[TYPED_ARRAY]; }
  });

  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
    CLAMPED = !!CLAMPED;
    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
      , ISNT_UINT8 = NAME != 'Uint8Array'
      , GETTER     = 'get' + KEY
      , SETTER     = 'set' + KEY
      , TypedArray = global[NAME]
      , Base       = TypedArray || {}
      , TAC        = TypedArray && getPrototypeOf(TypedArray)
      , FORCED     = !TypedArray || !$typed.ABV
      , O          = {}
      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function(that, index){
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function(that, index, value){
      var data = that._d;
      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function(that, index){
      dP(that, index, {
        get: function(){
          return getter(this, index);
        },
        set: function(value){
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if(FORCED){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME, '_d');
        var index  = 0
          , offset = 0
          , buffer, byteLength, length, klass;
        if(!isObject(data)){
          length     = strictToLength(data, true)
          byteLength = length * BYTES;
          buffer     = new $ArrayBuffer(byteLength);
        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if($length === undefined){
            if($len % BYTES)throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if(TYPED_ARRAY in data){
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while(index < length)addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if(!$iterDetect(function(iter){
      // V8 works with iterators, but fails in many other cases
      // https://code.google.com/p/v8/issues/detail?id=4552
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
      , $iterator         = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
      dP(TypedArrayPrototype, TAG, {
        get: function(){ return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES,
      from: $from,
      of: $of
    });

    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});

    $export($export.P + $export.F * fails(function(){
      new TypedArray(1).slice();
    }), NAME, {slice: $slice});

    $export($export.P + $export.F * (fails(function(){
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
    }) || !fails(function(){
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, {toLocaleString: $toLocaleString});

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function(){ /* empty */ };

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(64)('meta')
  , isObject = __webpack_require__(9)
  , has      = __webpack_require__(19)
  , setDesc  = __webpack_require__(13).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(7)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crashDataChanged = exports.configureLayerSource = exports.makeDefaultState = exports.boroughs = exports.geos = exports.momentize = exports.dateStringFormatView = exports.dateStringFormatModel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _queryString = __webpack_require__(98);

var _queryString2 = _interopRequireDefault(_queryString);

var _isEqual = __webpack_require__(755);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _app_config = __webpack_require__(68);

var _filter_by_area_reducer = __webpack_require__(201);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateStringFormatModel = exports.dateStringFormatModel = 'YYYY-MM';
var dateStringFormatView = exports.dateStringFormatView = 'MMM, YYYY';

var momentize = exports.momentize = function momentize(dateString) {
  return (0, _moment2.default)(dateString, dateStringFormatModel, true);
};

// Names for Filter by Boundary
var geos = exports.geos = ['citywide', 'borough', 'community_board', 'city_council', 'neighborhood', 'assembly', 'senate', 'nypd_precinct', 'intersection', 'custom'];

// Borough Names mapped to array index position
var boroughs = exports.boroughs = [undefined, 'Manhattan', 'Bronx', 'Brooklyn', 'Queens', 'Staten Island'];

// creates default app state using any available params from window.location.hash
var makeDefaultState = exports.makeDefaultState = function makeDefaultState() {
  var hash = window.location.hash;
  var qString = hash.substring(3, hash.length);
  var q = _queryString2.default.parse(qString);
  var p = {};

  var isJsonString = function isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  var isBool = function isBool(val) {
    return typeof val === 'boolean';
  };

  var isValidMomentObj = function isValidMomentObj(dateString) {
    var m = dateString ? momentize(dateString) : undefined;
    if (m && m.isValid()) {
      return m;
    }
    // fallback to last month, which is more likely to have data then the current month
    // e.g. if the current date is the first week of the month,
    // then data may not exist for that month yet
    var m2 = (0, _moment2.default)().subtract(1, 'month');
    var defaultYearMonth = m2.year() + '-' + m2.format('MM');
    return momentize(defaultYearMonth);
  };

  var isValidGeo = function isValidGeo(geo) {
    if (geos.indexOf(geo) !== -1) {
      return geo;
    }
    return geos[0];
  };

  // parse query params, with compatibility hack issue 97 to accept Chart View identifier
  // which is really the full string name with a borough prefix
  Object.keys(q).forEach(function (key) {
    var decoded = decodeURIComponent(q[key]);
    if (isJsonString(decoded)) {
      p[key] = JSON.parse(decoded);
    } else {
      p[key] = decoded;
    }
  });
  if (p.identifier && typeof p.identifier === 'string') {
    if (p.identifier.indexOf(',') !== -1) {
      p.identifier = p.identifier.split(',')[1];
    }
    p.identifier = p.identifier.trim();

    var identifierEndsInNumber = p.identifier.match(/(\d+)$/);
    if (identifierEndsInNumber) {
      p.identifier = identifierEndsInNumber[1];
    }
  }

  return {
    filterDate: {
      startDate: isValidMomentObj(p.startDate),
      endDate: isValidMomentObj(p.endDate)
    },
    filterArea: _extends({}, _filter_by_area_reducer.defaultState, {
      geo: isValidGeo(p.geo),
      identifier: p.identifier || undefined,
      lngLats: p.lngLats || []
    }),
    // filterTypes default to true for all injury & fatality
    // except for noInjuryFatality which defaults to false
    filterType: {
      injury: {
        cyclist: isBool(p.cinj) ? p.cinj : true,
        motorist: isBool(p.minj) ? p.minj : true,
        pedestrian: isBool(p.pinj) ? p.pinj : true
      },
      fatality: {
        cyclist: isBool(p.cfat) ? p.cfat : true,
        motorist: isBool(p.mfat) ? p.mfat : true,
        pedestrian: isBool(p.pfat) ? p.pfat : true
      },
      noInjuryFatality: isBool(p.noInjFat) ? p.noInjFat : false
    },
    filterVehicle: {
      vehicle: {
        car: isBool(p.vcar) ? p.vcar : true,
        truck: isBool(p.vtruck) ? p.vtruck : true,
        motorcycle: isBool(p.vmotorcycle) ? p.vmotorcycle : true,
        bicycle: isBool(p.vbicycle) ? p.vbicycle : true,
        suv: isBool(p.vsuv) ? p.vsuv : true,
        busvan: isBool(p.vbusvan) ? p.vbusvan : true,
        scooter: isBool(p.vscooter) ? p.vscooter : true,
        other: isBool(p.vother) ? p.vother : true
      }
    },
    filterContributingFactor: p.contrFactor || 'ALL',
    modal: {
      showModal: false,
      modalType: ''
    }
  };
};

// configures Carto crashes map layer's SQL
var configureLayerSource = exports.configureLayerSource = function configureLayerSource(sql) {
  _app_config.cartoLayerSource.sublayers[0].sql = sql;
  return _app_config.cartoLayerSource;
};

// Should the component fetch new crash data?
// also used in App.js to determine whether to update URL params
// @param {object} curProps; the component's this.props
// @param {object} nextProps; the component's nextProps in componentWillReceiveProps
var crashDataChanged = exports.crashDataChanged = function crashDataChanged(curProps, nextProps) {
  var endDate = nextProps.endDate,
      startDate = nextProps.startDate,
      filterType = nextProps.filterType,
      identifier = nextProps.identifier,
      geo = nextProps.geo,
      lngLats = nextProps.lngLats;
  var injury = filterType.injury,
      fatality = filterType.fatality,
      noInjuryFatality = filterType.noInjuryFatality;
  var filterVehicle = nextProps.filterVehicle;


  if (!startDate.isSame(curProps.startDate) || !endDate.isSame(curProps.endDate) || !(0, _isEqual2.default)(injury, curProps.filterType.injury) || !(0, _isEqual2.default)(fatality, curProps.filterType.fatality) || noInjuryFatality !== curProps.filterType.noInjuryFatality || !(0, _isEqual2.default)(filterVehicle.vehicle, curProps.filterVehicle.vehicle) || geo === 'citywide' && curProps.geo !== 'citywide' || identifier && identifier !== curProps.identifier || lngLats && lngLats.length && !(0, _isEqual2.default)(lngLats, curProps.lngLats)) {
    return true;
  }
  return false;
};

/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = false;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(4)
  , dPs         = __webpack_require__(216)
  , enumBugKeys = __webpack_require__(133)
  , IE_PROTO    = __webpack_require__(145)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(132)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(135).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(218)
  , hiddenKeys = __webpack_require__(133).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(218)
  , enumBugKeys = __webpack_require__(133);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(24);
module.exports = function(target, src, safe){
  for(var key in src)redefine(target, key, src[key], safe);
  return target;
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(5)
  , dP          = __webpack_require__(13)
  , DESCRIPTORS = __webpack_require__(12)
  , SPECIES     = __webpack_require__(10)('species');

module.exports = function(KEY){
  var C = global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(55);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterButton = function FilterButton(props) {
  var label = props.label,
      btnSize = props.btnSize,
      id = props.id,
      handleClick = props.handleClick,
      isActive = props.isActive,
      preventRetrigger = props.preventRetrigger;


  var btnClasses = (0, _classnames2.default)(btnSize, {
    'filter-options-button': true,
    'roboto-medium': true,
    active: isActive
  });

  function a() {
    if (preventRetrigger) {
      if (!isActive) {
        handleClick(id);
      }
    } else {
      handleClick(id);
    }
  }

  return _react2.default.createElement(
    'button',
    {
      className: btnClasses,
      onClick: function onClick() {
        return a();
      }
    },
    label
  );
};

FilterButton.defaultProps = {
  btnSize: 'wide',
  isActive: false,
  preventRetrigger: false
};

FilterButton.propTypes = {
  btnSize: _react.PropTypes.string,
  label: _react.PropTypes.string.isRequired,
  handleClick: _react.PropTypes.func.isRequired,
  id: _react.PropTypes.string.isRequired,
  isActive: _react.PropTypes.bool,
  preventRetrigger: _react.PropTypes.bool
};

exports.default = FilterButton;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labelFormats = exports.basemapURL = exports.cartoLayerSource = exports.crashDataFieldNames = exports.cartoTables = exports.cartoSQLQuery = exports.cartoUser = undefined;

var _cartocss = __webpack_require__(456);

var _cartocss2 = _interopRequireDefault(_cartocss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// CARTO account name
var cartoUser = exports.cartoUser = 'chekpeds';

// CARTO SQL API endpoint
var cartoSQLQuery = exports.cartoSQLQuery = function cartoSQLQuery(query, format) {
  return 'https://' + cartoUser + '.carto.com/api/v2/sql?' + (format === 'geojson' ? 'format=GeoJSON&' : '') + 'q=' + query;
};

// CARTO table names lookup
var cartoTables = exports.cartoTables = {
  nyc_borough: 'nyc_borough',
  nyc_city_council: 'nyc_city_council',
  nyc_community_board: 'nyc_community_board',
  nyc_neighborhood: 'nyc_neighborhood',
  nyc_nypd_precinct: 'nyc_nypd_precinct',
  nyc_assembly: 'nyc_assembly',
  nyc_senate: 'nyc_senate',
  nyc_intersections: 'nyc_highcrash_intersections',
  nyc_crashes: 'crashes_all_prod'
};

var crashDataFieldNames = exports.crashDataFieldNames = ['total_crashes', 'cyclist_injured', 'cyclist_killed', 'motorist_injured', 'motorist_killed', 'pedestrian_injured', 'pedestrian_killed', 'persons_killed', 'persons_injured', 'on_street_name', 'cross_street_name'];

var cartoLayerSource = exports.cartoLayerSource = {
  user_name: cartoUser,
  type: 'cartodb',
  sublayers: [{
    sql: '',
    cartocss: _cartocss2.default,
    interactivity: crashDataFieldNames.join(',')
  }]
};

// basemap for Leaflet
var basemapURL = exports.basemapURL = 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png?key=cb1_28tn_1_d559135955be8e5b0256c672';

// mapping of selectable area types onto a format string, for labels and tooltips
// "NYPD Precinct 107" is nicer than "107"
// use {} as the placeholder for the one value to be passed: the identifier
var labelFormats = exports.labelFormats = {
  borough: '{}',
  city_council: 'City Council District {}',
  community_board: 'Community Board {}',
  assembly: 'Assembly District {}',
  senate: 'Senate District {}',
  neighborhood: '{}',
  nypd_precinct: 'NYPD Precinct {}',
  intersection: '{}'
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(10)('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(23)(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(41)
  , call        = __webpack_require__(212)
  , isArrayIter = __webpack_require__(137)
  , anObject    = __webpack_require__(4)
  , toLength    = __webpack_require__(16)
  , getIterFn   = __webpack_require__(154)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(13).f
  , has = __webpack_require__(19)
  , TAG = __webpack_require__(10)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0)
  , defined = __webpack_require__(30)
  , fails   = __webpack_require__(7)
  , spaces  = __webpack_require__(150)
  , space   = '[' + spaces + ']'
  , non     = '\u200b\u0085'
  , ltrim   = RegExp('^' + space + space + '*')
  , rtrim   = RegExp(space + space + '*$');

var exporter = function(KEY, exec, ALIAS){
  var exp   = {};
  var FORCE = fails(function(){
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if(ALIAS)exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function(string, TYPE){
  string = String(defined(string));
  if(TYPE & 1)string = string.replace(ltrim, '');
  if(TYPE & 2)string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

/***/ }),
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(707),
    getValue = __webpack_require__(720);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(29)
  , TAG = __webpack_require__(10)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(29);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 88 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 89 */,
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(162),
    getRawTag = __webpack_require__(717),
    objectToString = __webpack_require__(743);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 91 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(26)
  , toLength  = __webpack_require__(16)
  , toIndex   = __webpack_require__(63);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global            = __webpack_require__(5)
  , $export           = __webpack_require__(0)
  , redefine          = __webpack_require__(24)
  , redefineAll       = __webpack_require__(61)
  , meta              = __webpack_require__(47)
  , forOf             = __webpack_require__(70)
  , anInstance        = __webpack_require__(56)
  , isObject          = __webpack_require__(9)
  , fails             = __webpack_require__(7)
  , $iterDetect       = __webpack_require__(108)
  , setToStringTag    = __webpack_require__(72)
  , inheritIfRequired = __webpack_require__(136);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  var fixMethod = function(KEY){
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a){
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance             = new C
      // early implementations not supports chaining
      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
      // most early implementations doesn't supports iterables, most modern - not close it correctly
      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
      // for early implementations -0 and +0 not the same
      , BUGGY_ZERO = !IS_WEAK && fails(function(){
        // V8 ~ Chromium 42- fails only with 5+ elements
        var $instance = new C()
          , index     = 5;
        while(index--)$instance[ADDER](index, index);
        return !$instance.has(-0);
      });
    if(!ACCEPT_ITERABLES){ 
      C = wrapper(function(target, iterable){
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base, target, C);
        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
    // weak collections should not contains .clear method
    if(IS_WEAK && proto.clear)delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide     = __webpack_require__(23)
  , redefine = __webpack_require__(24)
  , fails    = __webpack_require__(7)
  , defined  = __webpack_require__(30)
  , wks      = __webpack_require__(10);

module.exports = function(KEY, length, exec){
  var SYMBOL   = wks(KEY)
    , fns      = exec(defined, SYMBOL, ''[KEY])
    , strfn    = fns[0]
    , rxfn     = fns[1];
  if(fails(function(){
    var O = {};
    O[SYMBOL] = function(){ return 7; };
    return ''[KEY](O) != 7;
  })){
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function(string, arg){ return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function(string){ return rxfn.call(string, this); }
    );
  }
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(4);
module.exports = function(){
  var that   = anObject(this)
    , result = '';
  if(that.global)     result += 'g';
  if(that.ignoreCase) result += 'i';
  if(that.multiline)  result += 'm';
  if(that.unicode)    result += 'u';
  if(that.sticky)     result += 'y';
  return result;
};

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(9)
  , cof      = __webpack_require__(29)
  , MATCH    = __webpack_require__(10)('match');
module.exports = function(it){
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(10)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(57)|| !__webpack_require__(7)(function(){
  var K = Math.random();
  // In FF throws only define methods
  __defineSetter__.call(null, K, function(){ /* empty */});
  delete __webpack_require__(5)[K];
});

/***/ }),
/* 110 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5)
  , hide   = __webpack_require__(23)
  , uid    = __webpack_require__(64)
  , TYPED  = uid('typed_array')
  , VIEW   = uid('view')
  , ABV    = !!(global.ArrayBuffer && global.DataView)
  , CONSTR = ABV
  , i = 0, l = 9, Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while(i < l){
  if(Typed = global[TypedArrayConstructors[i++]]){
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV:    ABV,
  CONSTR: CONSTR,
  TYPED:  TYPED,
  VIEW:   VIEW
};

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(730),
    listCacheDelete = __webpack_require__(731),
    listCacheGet = __webpack_require__(732),
    listCacheHas = __webpack_require__(733),
    listCacheSet = __webpack_require__(734);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(243);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(727);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(75);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureDownloadDataSQL = exports.configureFactorsSQL = exports.configureStatsSQL = exports.configureMapSQL = exports.filterAreaBtnTableMap = exports.crashesMaxDate = exports.minMaxDateRange = exports.crashesYearRangeSQL = exports.filterByAreaSQL = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    SELECT DISTINCT\n      identifier,\n      ST_Collect(the_geom) as the_geom\n    FROM\n      ', '\n    GROUP BY\n      identifier\n  '], ['\n    SELECT DISTINCT\n      identifier,\n      ST_Collect(the_geom) as the_geom\n    FROM\n      ', '\n    GROUP BY\n      identifier\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    SELECT\n      CONCAT(UPPER(borough), \', \', name, \'|\', cartodb_id) AS identifier,\n      the_geom\n    FROM\n      ', '\n    WHERE crashcount IS NOT NULL AND borough != \'\'\n    ORDER BY crashcount DESC\n    LIMIT 500\n  '], ['\n    SELECT\n      CONCAT(UPPER(borough), \', \', name, \'|\', cartodb_id) AS identifier,\n      the_geom\n    FROM\n      ', '\n    WHERE crashcount IS NOT NULL AND borough != \'\'\n    ORDER BY crashcount DESC\n    LIMIT 500\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  SELECT DISTINCT year\n  FROM ', '\n  ORDER BY year DESC\n'], ['\n  SELECT DISTINCT year\n  FROM ', '\n  ORDER BY year DESC\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  SELECT\n  min(year::text || \'-\' || LPAD(month::text, 2, \'0\')),\n  max(year::text || \'-\' || LPAD(month::text, 2, \'0\'))\n  FROM ', '\n'], ['\n  SELECT\n  min(year::text || \'-\' || LPAD(month::text, 2, \'0\')),\n  max(year::text || \'-\' || LPAD(month::text, 2, \'0\'))\n  FROM ', '\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  SELECT max(date_val) as max_date\n  FROM ', '\n'], ['\n  SELECT max(date_val) as max_date\n  FROM ', '\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n      (\n        year::text || LPAD(month::text, 2, \'0\') <=\n        \'', '\' || LPAD(', '::text, 2, \'0\')\n      )\n    AND\n      (\n        year::text || LPAD(month::text, 2, \'0\') >=\n        \'', '\' || LPAD(', '::text, 2, \'0\')\n      )\n  '], ['\n      (\n        year::text || LPAD(month::text, 2, \'0\') <=\n        \'', '\' || LPAD(', '::text, 2, \'0\')\n      )\n    AND\n      (\n        year::text || LPAD(month::text, 2, \'0\') >=\n        \'', '\' || LPAD(', '::text, 2, \'0\')\n      )\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['AND\n      number_of_cyclist_injured = 0 AND\n      number_of_cyclist_killed = 0 AND\n      number_of_motorist_injured = 0 AND\n      number_of_motorist_killed = 0 AND\n      number_of_pedestrian_injured = 0 AND\n      number_of_pedestrian_killed = 0 AND\n      number_of_persons_injured = 0 AND\n      number_of_persons_killed = 0\n    '], ['AND\n      number_of_cyclist_injured = 0 AND\n      number_of_cyclist_killed = 0 AND\n      number_of_motorist_injured = 0 AND\n      number_of_motorist_killed = 0 AND\n      number_of_pedestrian_injured = 0 AND\n      number_of_pedestrian_killed = 0 AND\n      number_of_persons_injured = 0 AND\n      number_of_persons_killed = 0\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n      hasvehicle_other OR (\n        NOT hasvehicle_car AND\n        NOT hasvehicle_truck AND\n        NOT hasvehicle_motorcycle AND\n        NOT hasvehicle_bicycle AND\n        NOT hasvehicle_suv AND\n        NOT hasvehicle_busvan AND\n        NOT hasvehicle_scooter AND\n        NOT hasvehicle_other\n      )\n    '], ['\n      hasvehicle_other OR (\n        NOT hasvehicle_car AND\n        NOT hasvehicle_truck AND\n        NOT hasvehicle_motorcycle AND\n        NOT hasvehicle_bicycle AND\n        NOT hasvehicle_suv AND\n        NOT hasvehicle_busvan AND\n        NOT hasvehicle_scooter AND\n        NOT hasvehicle_other\n      )\n    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n      JOIN ', ' a\n      ON ST_Within(c.the_geom, a.the_geom)\n    '], ['\n      JOIN ', ' a\n      ON ST_Within(c.the_geom, a.the_geom)\n    ']),
    _templateObject10 = _taggedTemplateLiteral(['\n      AND\n        ST_Contains(\n          ST_GeomFromText(\n            \'POLYGON(( ', ' ))\',\n          4326),\n          c.the_geom\n        )\n    '], ['\n      AND\n        ST_Contains(\n          ST_GeomFromText(\n            \'POLYGON(( ', ' ))\',\n          4326),\n          c.the_geom\n        )\n    ']),
    _templateObject11 = _taggedTemplateLiteral(['\n    SELECT * FROM\n    (\n      SELECT\n        c.the_geom as the_geom,\n        c.the_geom_webmercator as the_geom_webmercator,\n        c.on_street_name as on_street_name,\n        c.cross_street_name as cross_street_name,\n        COUNT(c.crash_count) as total_crashes,\n        SUM(c.number_of_cyclist_injured) as cyclist_injured,\n        SUM(c.number_of_cyclist_killed) as cyclist_killed,\n        SUM(c.number_of_motorist_injured) as motorist_injured,\n        SUM(c.number_of_motorist_killed) as motorist_killed,\n        SUM(c.number_of_pedestrian_injured) as pedestrian_injured,\n        SUM(c.number_of_pedestrian_killed) as pedestrian_killed,\n        SUM(c.number_of_persons_injured - (c.number_of_pedestrian_injured + c.number_of_cyclist_injured + c.number_of_motorist_injured)) as other_injured,\n        SUM(c.number_of_persons_killed - (c.number_of_pedestrian_killed + c.number_of_cyclist_killed + c.number_of_motorist_killed)) as other_killed,\n        SUM(c.number_of_persons_injured) as persons_injured,\n        SUM(c.number_of_persons_killed) as persons_killed\n      FROM\n        ', ' c\n      ', '\n      WHERE\n      ', '\n      ', '\n      ', '\n      ', '\n      ', '\n      AND\n        c.the_geom IS NOT NULL\n      GROUP BY\n        c.the_geom, c.the_geom_webmercator, c.on_street_name, c.cross_street_name\n    ) _\n    ORDER BY\n    CASE WHEN (persons_killed > 0) THEN 3\n    WHEN (persons_injured > 0) THEN 2\n    WHEN (total_crashes > 11) THEN 1\n    ELSE 0\n    END\n  '], ['\n    SELECT * FROM\n    (\n      SELECT\n        c.the_geom as the_geom,\n        c.the_geom_webmercator as the_geom_webmercator,\n        c.on_street_name as on_street_name,\n        c.cross_street_name as cross_street_name,\n        COUNT(c.crash_count) as total_crashes,\n        SUM(c.number_of_cyclist_injured) as cyclist_injured,\n        SUM(c.number_of_cyclist_killed) as cyclist_killed,\n        SUM(c.number_of_motorist_injured) as motorist_injured,\n        SUM(c.number_of_motorist_killed) as motorist_killed,\n        SUM(c.number_of_pedestrian_injured) as pedestrian_injured,\n        SUM(c.number_of_pedestrian_killed) as pedestrian_killed,\n        SUM(c.number_of_persons_injured - (c.number_of_pedestrian_injured + c.number_of_cyclist_injured + c.number_of_motorist_injured)) as other_injured,\n        SUM(c.number_of_persons_killed - (c.number_of_pedestrian_killed + c.number_of_cyclist_killed + c.number_of_motorist_killed)) as other_killed,\n        SUM(c.number_of_persons_injured) as persons_injured,\n        SUM(c.number_of_persons_killed) as persons_killed\n      FROM\n        ', ' c\n      ', '\n      WHERE\n      ', '\n      ', '\n      ', '\n      ', '\n      ', '\n      AND\n        c.the_geom IS NOT NULL\n      GROUP BY\n        c.the_geom, c.the_geom_webmercator, c.on_street_name, c.cross_street_name\n    ) _\n    ORDER BY\n    CASE WHEN (persons_killed > 0) THEN 3\n    WHEN (persons_injured > 0) THEN 2\n    WHEN (total_crashes > 11) THEN 1\n    ELSE 0\n    END\n  ']),
    _templateObject12 = _taggedTemplateLiteral(['\n    SELECT\n      COUNT(c.cartodb_id) as total_crashes,\n      SUM(c.number_of_cyclist_injured) as cyclist_injured,\n      SUM(c.number_of_cyclist_killed) as cyclist_killed,\n      SUM(c.number_of_motorist_injured) as motorist_injured,\n      SUM(c.number_of_motorist_killed) as motorist_killed,\n      SUM(c.number_of_pedestrian_injured) as pedestrian_injured,\n      SUM(c.number_of_pedestrian_killed) as pedestrian_killed,\n      SUM(c.number_of_persons_injured - (c.number_of_pedestrian_injured + c.number_of_cyclist_injured + c.number_of_motorist_injured)) as other_injured,\n      SUM(c.number_of_persons_killed - (c.number_of_pedestrian_killed + c.number_of_cyclist_killed + c.number_of_motorist_killed)) as other_killed,\n      SUM(c.number_of_persons_injured) as persons_injured,\n      SUM(c.number_of_persons_killed) as persons_killed\n    FROM\n      ', ' c\n    ', '\n    WHERE\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n  '], ['\n    SELECT\n      COUNT(c.cartodb_id) as total_crashes,\n      SUM(c.number_of_cyclist_injured) as cyclist_injured,\n      SUM(c.number_of_cyclist_killed) as cyclist_killed,\n      SUM(c.number_of_motorist_injured) as motorist_injured,\n      SUM(c.number_of_motorist_killed) as motorist_killed,\n      SUM(c.number_of_pedestrian_injured) as pedestrian_injured,\n      SUM(c.number_of_pedestrian_killed) as pedestrian_killed,\n      SUM(c.number_of_persons_injured - (c.number_of_pedestrian_injured + c.number_of_cyclist_injured + c.number_of_motorist_injured)) as other_injured,\n      SUM(c.number_of_persons_killed - (c.number_of_pedestrian_killed + c.number_of_cyclist_killed + c.number_of_motorist_killed)) as other_killed,\n      SUM(c.number_of_persons_injured) as persons_injured,\n      SUM(c.number_of_persons_killed) as persons_killed\n    FROM\n      ', ' c\n    ', '\n    WHERE\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n  ']),
    _templateObject13 = _taggedTemplateLiteral(['\n    WITH all_factors as (\n      SELECT\n        unnest(c.contributing_factor) as factor\n      FROM\n      ', ' c\n      ', '\n      WHERE\n      ', '\n      ', '\n      ', '\n      ', '\n      ', '\n    )\n    SELECT\n     COUNT(af.factor) as count_factor,\n     af.factor\n    FROM\n      all_factors af\n    GROUP BY\n      af.factor\n    ORDER BY\n      count_factor desc\n  '], ['\n    WITH all_factors as (\n      SELECT\n        unnest(c.contributing_factor) as factor\n      FROM\n      ', ' c\n      ', '\n      WHERE\n      ', '\n      ', '\n      ', '\n      ', '\n      ', '\n    )\n    SELECT\n     COUNT(af.factor) as count_factor,\n     af.factor\n    FROM\n      all_factors af\n    GROUP BY\n      af.factor\n    ORDER BY\n      count_factor desc\n  ']),
    _templateObject14 = _taggedTemplateLiteral(['\n    SELECT\n      c.cartodb_id,\n      c.socrata_id,\n      c.the_geom,\n      c.on_street_name,\n      c.cross_street_name,\n      c.date_val AS date_time,\n      c.latitude,\n      c.longitude,\n      c.borough,\n      c.zip_code,\n      c.crash_count,\n      c.number_of_cyclist_injured,\n      c.number_of_cyclist_killed,\n      c.number_of_motorist_injured,\n      c.number_of_motorist_killed,\n      c.number_of_pedestrian_injured,\n      c.number_of_pedestrian_killed,\n      c.number_of_persons_injured,\n      c.number_of_persons_killed,\n      array_to_string(c.contributing_factor, \',\') as contributing_factors,\n      array_to_string(c.vehicle_type, \',\') as vehicle_types\n    FROM ', ' c\n    ', '\n    WHERE\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n  '], ['\n    SELECT\n      c.cartodb_id,\n      c.socrata_id,\n      c.the_geom,\n      c.on_street_name,\n      c.cross_street_name,\n      c.date_val AS date_time,\n      c.latitude,\n      c.longitude,\n      c.borough,\n      c.zip_code,\n      c.crash_count,\n      c.number_of_cyclist_injured,\n      c.number_of_cyclist_killed,\n      c.number_of_motorist_injured,\n      c.number_of_motorist_killed,\n      c.number_of_pedestrian_injured,\n      c.number_of_pedestrian_killed,\n      c.number_of_persons_injured,\n      c.number_of_persons_killed,\n      array_to_string(c.contributing_factor, \',\') as contributing_factors,\n      array_to_string(c.vehicle_type, \',\') as vehicle_types\n    FROM ', ' c\n    ', '\n    WHERE\n    ', '\n    ', '\n    ', '\n    ', '\n    ', '\n  ']);

var _singleLineString = __webpack_require__(100);

var _singleLineString2 = _interopRequireDefault(_singleLineString);

var _app_config = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var nyc_borough = _app_config.cartoTables.nyc_borough,
    nyc_city_council = _app_config.cartoTables.nyc_city_council,
    nyc_community_board = _app_config.cartoTables.nyc_community_board,
    nyc_neighborhood = _app_config.cartoTables.nyc_neighborhood,
    nyc_nypd_precinct = _app_config.cartoTables.nyc_nypd_precinct,
    nyc_senate = _app_config.cartoTables.nyc_senate,
    nyc_assembly = _app_config.cartoTables.nyc_assembly,
    nyc_intersections = _app_config.cartoTables.nyc_intersections,
    nyc_crashes = _app_config.cartoTables.nyc_crashes;

// Links each boundary filter name to a SQL query

var filterByAreaSQL = exports.filterByAreaSQL = {
  borough: (0, _singleLineString2.default)(_templateObject, nyc_borough),

  city_council: (0, _singleLineString2.default)(_templateObject, nyc_city_council),

  community_board: (0, _singleLineString2.default)(_templateObject, nyc_community_board),

  neighborhood: (0, _singleLineString2.default)(_templateObject, nyc_neighborhood),

  nypd_precinct: (0, _singleLineString2.default)(_templateObject, nyc_nypd_precinct),

  assembly: (0, _singleLineString2.default)(_templateObject, nyc_assembly),

  senate: (0, _singleLineString2.default)(_templateObject, nyc_senate),

  intersection: (0, _singleLineString2.default)(_templateObject2, nyc_intersections)
};

// TO DO: Use a single Query for the following 3 date queries
// selects all years for crash data, used by MonthYearSelector.js component
var crashesYearRangeSQL = exports.crashesYearRangeSQL = function crashesYearRangeSQL() {
  return (0, _singleLineString2.default)(_templateObject3, nyc_crashes);
};

// selects min and max year-month formatted like "YYYY-MM"
// used by MonthYearSelector.js component
var minMaxDateRange = exports.minMaxDateRange = function minMaxDateRange() {
  return (0, _singleLineString2.default)(_templateObject4, nyc_crashes);
};

// selects max date, used for DownloadData.js component's "last updated on" msg
var crashesMaxDate = exports.crashesMaxDate = function crashesMaxDate() {
  return (0, _singleLineString2.default)(_templateObject5, nyc_crashes);
};

/*
***************************** SQL HELPERS **************************************
*/

// Generates the SQL WHERE clause for "Filter by Date Range"
// @param {object} startDate, a moment.js object
// @param {object} endDate, a moment.js object
var filterByDateWhereClause = function filterByDateWhereClause(startDate, endDate) {
  return (0, _singleLineString2.default)(_templateObject6, endDate.year(), endDate.month() + 1, startDate.year(), startDate.month() + 1);
};

// Generates the SQL WHERE clause for "Filter by Type"
// @param {object} the store.filterType piece of state
var filterByTypeWhereClause = function filterByTypeWhereClause(filterType) {
  var injury = filterType.injury,
      fatality = filterType.fatality,
      noInjuryFatality = filterType.noInjuryFatality;

  var whereClause = '';

  var mapTypes = function mapTypes(personTypes, harmType) {
    return Object.keys(personTypes).filter(function (type) {
      var val = personTypes[type];
      if (val) return type;
      return false;
    }).map(function (type) {
      var hurtTerm = harmType === 'injury' ? 'injured' : 'killed';
      return ' number_of_' + type + '_' + hurtTerm + ' > 0 ';
    }).join('OR');
  };

  var typesInjuredSelected = Object.values(injury).filter(function (i) {
    return i;
  }).length;
  var typesKilledSelected = Object.values(fatality).filter(function (i) {
    return i;
  }).length;

  var typesInjuredMapped = mapTypes(injury, 'injury');
  var typesKilledMapped = mapTypes(fatality, 'fatality');

  if (typesInjuredSelected === 3 && typesKilledSelected === 3) {
    whereClause += 'AND (number_of_persons_injured > 0 OR number_of_persons_killed > 0)';
  } else if (typesInjuredSelected > 0 && typesKilledSelected === 3) {
    whereClause += 'AND (' + typesInjuredMapped + ' OR number_of_persons_killed > 0)';
  } else if (typesInjuredSelected === 3 && typesKilledSelected > 0) {
    whereClause += 'AND (number_of_persons_injured > 0 OR ' + typesKilledMapped + ')';
  } else if (typesInjuredMapped.length > 0 && typesKilledMapped.length > 0) {
    whereClause += 'AND (' + typesInjuredMapped + ' OR ' + typesKilledMapped + ')';
  } else if (typesInjuredMapped.length > 0) {
    whereClause += 'AND (' + typesInjuredMapped + ')';
  } else if (typesKilledMapped.length > 0) {
    whereClause += 'AND (' + typesKilledMapped + ')';
  } else if (noInjuryFatality) {
    whereClause += (0, _singleLineString2.default)(_templateObject7);
  }

  return whereClause;
};

// Generates the SQL WHERE clause for "Filter by Type"
// @param {object} the store.filterType piece of state
var filterByVehicleWhereClause = function filterByVehicleWhereClause(filterVehicle) {
  var vehicle = filterVehicle.vehicle;


  var anyofthese = [];
  if (vehicle.car) anyofthese.push('hasvehicle_car');
  if (vehicle.truck) anyofthese.push('hasvehicle_truck');
  if (vehicle.motorcycle) anyofthese.push('hasvehicle_motorcycle');
  if (vehicle.bicycle) anyofthese.push('hasvehicle_bicycle');
  if (vehicle.suv) anyofthese.push('hasvehicle_suv');
  if (vehicle.busvan) anyofthese.push('hasvehicle_busvan');
  if (vehicle.scooter) anyofthese.push('hasvehicle_scooter');

  // other is really other OR unknown/unmatched
  if (vehicle.other) {
    anyofthese.push((0, _singleLineString2.default)(_templateObject8));
  }

  var whereClause = anyofthese.length ? 'AND (' + anyofthese.join(' OR ') + ')' : '';
  console.debug(whereClause); // eslint-disable-line

  return whereClause;
};

// Links the Filter by Boundary button name to corresponding Carto table name
// NOTE: Deliberately not using Borough, because when > 1 year of data is selected
// the spatial join will time out on Borough polygons
var filterAreaBtnTableMap = exports.filterAreaBtnTableMap = {
  borough: undefined,
  community_board: nyc_community_board,
  city_council: nyc_city_council,
  neighborhood: nyc_neighborhood,
  assembly: nyc_assembly,
  senate: nyc_senate,
  nypd_precinct: nyc_nypd_precinct,
  intersection: nyc_intersections
};

// Creates the spatial join clause with a boundary table geom
// @param {string} areaName, name of boundary, eg 'Borough' or 'City Council Districts'
var joinToGeoTableClause = function joinToGeoTableClause(areaName) {
  var geoTable = filterAreaBtnTableMap[areaName];
  if (geoTable) {
    return (0, _singleLineString2.default)(_templateObject9, geoTable);
  }
  return '';
};

// Creates the WHERE clause for boundary table identifier
// NOTE: Deliberately not using Borough, because when > 1 year of data is selected
// the spatial join will time out on Borough polygons
// @param {number || string} identifier, unique id of boundary polygon
// @param {string} geo, name of boundary table identifier column belongs to
var filterByIdentifierWhereClause = function filterByIdentifierWhereClause(identifier, geo) {
  if (geo === 'borough' && identifier) {
    return 'AND c.borough ilike \'%' + identifier + '%\'';
  } else if (geo === 'intersection' && identifier) {
    var cartodb_id = identifier.split('|')[1];
    return 'AND a.cartodb_id = ' + cartodb_id;
  } else if (geo !== 'borough' && identifier) {
    return 'AND a.identifier = $$' + identifier + '$$';
  }
  return '';
};

// Creates the PostGIS query for selecting crash data by custom area created by Leaflet.Draw
// @param {array} lonLatArray, an array of longitude, latitude arrays that form an enclosed polygon
var filterByCustomAreaClause = function filterByCustomAreaClause(lonLatArray) {
  if (lonLatArray && lonLatArray.length) {
    // PostGIS GeomFromText expects lon lat coords like (-73.91 40.74, -73.89 40.73, ...)
    var coordinates = lonLatArray.map(function (lonLat) {
      return lonLat.join(' ');
    });
    return (0, _singleLineString2.default)(_templateObject10, coordinates);
  }
  return '';
};

/*
 ********************************** MAP ****************************************
 */

// Generates the SQL query for the Carto layer based on filter params & app element
// @param {object} params: key values associated with filters derived from app state
// @param {string} startDate: min date; required
// @param {string} endDate: max date; required
// @param {string} harm: crash type, one of 'ALL', 'cyclist', 'motorist', 'ped'
// @param {string} persona: crash type, of of 'ALL', 'fatality', 'injury', 'no inj/fat'
var configureMapSQL = exports.configureMapSQL = function configureMapSQL(params) {
  var startDate = params.startDate,
      endDate = params.endDate,
      filterType = params.filterType,
      filterVehicle = params.filterVehicle,
      geo = params.geo,
      identifier = params.identifier,
      lngLats = params.lngLats;


  return (0, _singleLineString2.default)(_templateObject11, nyc_crashes, joinToGeoTableClause(geo), filterByDateWhereClause(startDate, endDate), filterByCustomAreaClause(lngLats), filterByTypeWhereClause(filterType), filterByVehicleWhereClause(filterVehicle), filterByIdentifierWhereClause(identifier, geo));
};

/*
 ******************************* STATS *****************************************
 */

var configureStatsSQL = exports.configureStatsSQL = function configureStatsSQL(params) {
  var startDate = params.startDate,
      endDate = params.endDate,
      filterType = params.filterType,
      filterVehicle = params.filterVehicle,
      geo = params.geo,
      identifier = params.identifier,
      lngLats = params.lngLats;


  return (0, _singleLineString2.default)(_templateObject12, nyc_crashes, joinToGeoTableClause(geo), filterByDateWhereClause(startDate, endDate), filterByCustomAreaClause(lngLats), filterByTypeWhereClause(filterType), filterByVehicleWhereClause(filterVehicle), filterByIdentifierWhereClause(identifier, geo));
};

/*
 *************************** CONTRIBUTING FACTORS ******************************
*/

var configureFactorsSQL = exports.configureFactorsSQL = function configureFactorsSQL(params) {
  var startDate = params.startDate,
      endDate = params.endDate,
      filterType = params.filterType,
      filterVehicle = params.filterVehicle,
      geo = params.geo,
      identifier = params.identifier,
      lngLats = params.lngLats;


  return (0, _singleLineString2.default)(_templateObject13, nyc_crashes, joinToGeoTableClause(geo), filterByDateWhereClause(startDate, endDate), filterByCustomAreaClause(lngLats), filterByTypeWhereClause(filterType), filterByVehicleWhereClause(filterVehicle), filterByIdentifierWhereClause(identifier, geo));
};

/*
 ******************************* Download Data *********************************
*/

// Creates the SQL query for "Download Data" buttons
var configureDownloadDataSQL = exports.configureDownloadDataSQL = function configureDownloadDataSQL(params) {
  var startDate = params.startDate,
      endDate = params.endDate,
      filterArea = params.filterArea,
      filterType = params.filterType,
      filterVehicle = params.filterVehicle;
  var geo = filterArea.geo,
      lngLats = filterArea.lngLats,
      identifier = filterArea.identifier;


  return (0, _singleLineString2.default)(_templateObject14, nyc_crashes, joinToGeoTableClause(geo), filterByDateWhereClause(startDate, endDate), filterByCustomAreaClause(lngLats), filterByTypeWhereClause(filterType), filterByVehicleWhereClause(filterVehicle), filterByIdentifierWhereClause(identifier, geo));
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(17)
  , toIndex  = __webpack_require__(63)
  , toLength = __webpack_require__(16);
module.exports = function fill(value /*, start = 0, end = @length */){
  var O      = toObject(this)
    , length = toLength(O.length)
    , aLen   = arguments.length
    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
    , end    = aLen > 2 ? arguments[2] : undefined
    , endPos = end === undefined ? length : toIndex(end, length);
  while(endPos > index)O[index++] = value;
  return O;
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(13)
  , createDesc      = __webpack_require__(48);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9)
  , document = __webpack_require__(5).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(10)('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5).document && document.documentElement;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var isObject       = __webpack_require__(9)
  , setPrototypeOf = __webpack_require__(144).set;
module.exports = function(that, target, C){
  var P, S = target.constructor;
  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
    setPrototypeOf(that, P);
  } return that;
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(71)
  , ITERATOR   = __webpack_require__(10)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(29);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(58)
  , descriptor     = __webpack_require__(48)
  , setToStringTag = __webpack_require__(72)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(23)(IteratorPrototype, __webpack_require__(10)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(57)
  , $export        = __webpack_require__(0)
  , redefine       = __webpack_require__(24)
  , hide           = __webpack_require__(23)
  , has            = __webpack_require__(19)
  , Iterators      = __webpack_require__(71)
  , $iterCreate    = __webpack_require__(139)
  , setToStringTag = __webpack_require__(72)
  , getPrototypeOf = __webpack_require__(28)
  , ITERATOR       = __webpack_require__(10)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x){
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x){
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(5)
  , macrotask = __webpack_require__(151).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(29)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(9)
  , anObject = __webpack_require__(4);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(41)(Function.call, __webpack_require__(27).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(111)('keys')
  , uid    = __webpack_require__(64);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(4)
  , aFunction = __webpack_require__(22)
  , SPECIES   = __webpack_require__(10)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49)
  , defined   = __webpack_require__(30);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(107)
  , defined  = __webpack_require__(30);

module.exports = function(that, searchString, NAME){
  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(49)
  , defined   = __webpack_require__(30);

module.exports = function repeat(count){
  var str = String(defined(this))
    , res = ''
    , n   = toInteger(count);
  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
  return res;
};

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(41)
  , invoke             = __webpack_require__(106)
  , html               = __webpack_require__(135)
  , cel                = __webpack_require__(132)
  , global             = __webpack_require__(5)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(29)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(5)
  , DESCRIPTORS    = __webpack_require__(12)
  , LIBRARY        = __webpack_require__(57)
  , $typed         = __webpack_require__(112)
  , hide           = __webpack_require__(23)
  , redefineAll    = __webpack_require__(61)
  , fails          = __webpack_require__(7)
  , anInstance     = __webpack_require__(56)
  , toInteger      = __webpack_require__(49)
  , toLength       = __webpack_require__(16)
  , gOPN           = __webpack_require__(59).f
  , dP             = __webpack_require__(13).f
  , arrayFill      = __webpack_require__(130)
  , setToStringTag = __webpack_require__(72)
  , ARRAY_BUFFER   = 'ArrayBuffer'
  , DATA_VIEW      = 'DataView'
  , PROTOTYPE      = 'prototype'
  , WRONG_LENGTH   = 'Wrong length!'
  , WRONG_INDEX    = 'Wrong index!'
  , $ArrayBuffer   = global[ARRAY_BUFFER]
  , $DataView      = global[DATA_VIEW]
  , Math           = global.Math
  , RangeError     = global.RangeError
  , Infinity       = global.Infinity
  , BaseBuffer     = $ArrayBuffer
  , abs            = Math.abs
  , pow            = Math.pow
  , floor          = Math.floor
  , log            = Math.log
  , LN2            = Math.LN2
  , BUFFER         = 'buffer'
  , BYTE_LENGTH    = 'byteLength'
  , BYTE_OFFSET    = 'byteOffset'
  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
var packIEEE754 = function(value, mLen, nBytes){
  var buffer = Array(nBytes)
    , eLen   = nBytes * 8 - mLen - 1
    , eMax   = (1 << eLen) - 1
    , eBias  = eMax >> 1
    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
    , i      = 0
    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
    , e, m, c;
  value = abs(value)
  if(value != value || value === Infinity){
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if(value * (c = pow(2, -e)) < 1){
      e--;
      c *= 2;
    }
    if(e + eBias >= 1){
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if(value * c >= 2){
      e++;
      c /= 2;
    }
    if(e + eBias >= eMax){
      m = 0;
      e = eMax;
    } else if(e + eBias >= 1){
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
};
var unpackIEEE754 = function(buffer, mLen, nBytes){
  var eLen  = nBytes * 8 - mLen - 1
    , eMax  = (1 << eLen) - 1
    , eBias = eMax >> 1
    , nBits = eLen - 7
    , i     = nBytes - 1
    , s     = buffer[i--]
    , e     = s & 127
    , m;
  s >>= 7;
  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if(e === 0){
    e = 1 - eBias;
  } else if(e === eMax){
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
};

var unpackI32 = function(bytes){
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
};
var packI8 = function(it){
  return [it & 0xff];
};
var packI16 = function(it){
  return [it & 0xff, it >> 8 & 0xff];
};
var packI32 = function(it){
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
};
var packF64 = function(it){
  return packIEEE754(it, 52, 8);
};
var packF32 = function(it){
  return packIEEE754(it, 23, 4);
};

var addGetter = function(C, key, internal){
  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
};

var get = function(view, bytes, index, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
};
var set = function(view, bytes, index, conversion, value, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = conversion(+value);
  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
};

var validateArrayBufferArguments = function(that, length){
  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
  var numberLength = +length
    , byteLength   = toLength(numberLength);
  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
  return byteLength;
};

if(!$typed.ABV){
  $ArrayBuffer = function ArrayBuffer(length){
    var byteLength = validateArrayBufferArguments(this, length);
    this._b       = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength){
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH]
      , offset       = toInteger(byteOffset);
    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if(DESCRIPTORS){
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset){
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset){
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if(!fails(function(){
    new $ArrayBuffer;     // eslint-disable-line no-new
  }) || !fails(function(){
    new $ArrayBuffer(.5); // eslint-disable-line no-new
  })){
    $ArrayBuffer = function ArrayBuffer(length){
      return new BaseBuffer(validateArrayBufferArguments(this, length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
    };
    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2))
    , $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(5)
  , core           = __webpack_require__(40)
  , LIBRARY        = __webpack_require__(57)
  , wksExt         = __webpack_require__(225)
  , defineProperty = __webpack_require__(13).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(86)
  , ITERATOR  = __webpack_require__(10)('iterator')
  , Iterators = __webpack_require__(71);
module.exports = __webpack_require__(40).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(69)
  , step             = __webpack_require__(213)
  , Iterators        = __webpack_require__(71)
  , toIObject        = __webpack_require__(26);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(140)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(75),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(37);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AboutCopy = function AboutCopy() {
  return _react2.default.createElement(
    'div',
    { className: 'about-crash-mapper' },
    _react2.default.createElement(
      'h6',
      null,
      'TAKE ACTION'
    ),
    _react2.default.createElement(
      'ul',
      null,
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Start a',
          ' ',
          _react2.default.createElement(
            'a',
            { href: 'https://campaigns.transalt.org/new' },
            _react2.default.createElement(
              'strong',
              null,
              'PETITION'
            )
          ),
          ' ',
          'to raise the profile of your traffic problems'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Start a',
          ' ',
          _react2.default.createElement(
            'a',
            { href: 'https://www.transalt.org/organize' },
            _react2.default.createElement(
              'strong',
              null,
              'CAMPAIGN'
            )
          ),
          ' ',
          'to obtain the installation of traffic safety features in your area'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Get traffic safety',
          ' ',
          _react2.default.createElement(
            'a',
            { href: 'http://visionheroinc.org' },
            _react2.default.createElement(
              'strong',
              null,
              'EDUCATION'
            )
          ),
          ' ',
          'for your school'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'a',
            { href: 'https://www.transalt.org/familiesforsafestreets' },
            _react2.default.createElement(
              'strong',
              null,
              'JOIN'
            )
          ),
          ' ',
          'families of other victims to seek traffic justice'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Report a crash to the',
          ' ',
          _react2.default.createElement(
            'a',
            { href: 'mailto:tips@streetsblog.org' },
            _react2.default.createElement(
              'strong',
              null,
              'PRESS'
            )
          ),
          '.'
        )
      )
    ),
    _react2.default.createElement(
      'h6',
      null,
      'GET MORE INFORMATION'
    ),
    _react2.default.createElement(
      'ul',
      null,
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'a',
            { href: 'http://www.nycvzv.info' },
            _react2.default.createElement(
              'strong',
              null,
              'TRAFFIC CALMING'
            )
          ),
          ' ',
          'features installed in your neighborhood'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Vision Zero (zero traffic deaths) Pedestrian Safety Action',
          ' ',
          _react2.default.createElement(
            'a',
            { href: 'http://www.nyc.gov/html/dot/html/pedestrians/ped-safety-action-plan.shtml' },
            _react2.default.createElement(
              'strong',
              null,
              'PLANS'
            )
          )
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Vision Zero',
          ' ',
          _react2.default.createElement(
            'a',
            { href: 'http://www1.nyc.gov/site/visionzero/initiatives/initiatives.page' },
            _react2.default.createElement(
              'strong',
              null,
              'REPORT CARDS'
            )
          )
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'a',
            { href: 'http://www.nyc.gov/html/dot/html/contact/contact-form.shtml' },
            _react2.default.createElement(
              'strong',
              null,
              'CONTACT'
            )
          ),
          ' ',
          'the Department of Transportation'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Get',
          ' ',
          _react2.default.createElement(
            'a',
            { href: 'mailto:excom@chekpeds.com?subject=NYC%20Crash%20Mapper' },
            _react2.default.createElement(
              'strong',
              null,
              'ANSWERS'
            )
          ),
          ' ',
          'to any question on NYC Crash Mapper'
        )
      )
    ),
    _react2.default.createElement(
      'h6',
      null,
      'ABOUT CRASH MAPPER'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'strong',
        null,
        'MAPPING WITH CUSTOMIZED FILTERING'
      ),
      ': The map allows a user to create a customized filter of any area and track it over time. This is particularly helpful to see the impact of Vision Zero improvements on a corridor, a slow zone, a school zone, etc. This is in addition to other more traditional filters like Borough, Community Boards, NYPD Precincts and more. Any active filters may easily be shared with others using the website\'s URL.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'strong',
        null,
        'ANALYZING:'
      ),
      ' TREND allows you to compare two selected areas\u2019 performance against each other and to a citywide or borough-wide reference, while filtering by date range or type of crash. COMPARE lets you compare two time periods for a given area. RANK shows where one area or intersection ranks in terms of safety in the context of all similar areas over the most recent two-year period.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'strong',
        null,
        'ENHANCED DATA'
      ),
      ': Collision data is updated from the NYC Open Data Portal daily or as soon as new data becomes available, with a sweep back one month to catch recently updated data. NYC Crash Mapper uses vehicle collision data for New York City from August 2011 to the present. The data was aggregated and normalized from the NYC Open Data Portal',
      ' ',
      _react2.default.createElement(
        'a',
        { href: 'https://data.cityofnewyork.us/Public-Safety/NYPD-Motor-Vehicle-Collisions/h9gi-nx95' },
        _react2.default.createElement(
          'strong',
          null,
          'NYPD Motor Vehicle Collisions'
        )
      ),
      ' ',
      'and',
      ' ',
      _react2.default.createElement(
        'a',
        { href: 'https://github.com/talos/nypd-crash-data-bandaid' },
        _react2.default.createElement(
          'strong',
          null,
          'John Krauss\'s NYPD Crash Data Bandaid'
        )
      ),
      '.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'As a result of some of the source data not being geocoded, the statistics (total crashes, fatalities, and injuries) displayed in the bottom of the map view may differ from what is shown on the map when Filter By Boundary is set to "Citywide." When a Filter By Boundary other than "Citywide" is used, such as a "Community Board", the stats will only display counts for crashes that have been geocoded and are located within a selected boundary.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'In the NYPD motor vehicles collisions dataset, some injuries and fatalities do not have a role/vehicle ascribed to them. \u201COther\u201D includes crashes in the source data that are not labeled by category (pedestrian, cyclists or motorists). In our experience they include mostly crashes where the victims are e-bike users.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'NYPD captures up to five (5) vehicles included in a crash. As long as any one of these vehicles matches the filter selected, the related injuries and fatalities will be counted \u2013 even if the vehicle is potentially not directly responsible for the fatalities/injuries.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'strong',
        null,
        'NYC CRASH MAPPER'
      ),
      ' was made possible by',
      ' ',
      _react2.default.createElement(
        'a',
        { href: 'https://carto.com/' },
        _react2.default.createElement(
          'strong',
          null,
          'CARTO'
        )
      ),
      ' ',
      'for hosting the data and making the creation of this tool possible through their Grants For Good program; by The Lily Auchincloss and PEPSI foundations, the Manhattan Borough President and the New York City Council. The',
      ' ',
      _react2.default.createElement(
        'a',
        { href: 'https://lilynyc.org/' },
        _react2.default.createElement(
          'strong',
          null,
          'LILY AUCHINCLOSS FOUNDATION'
        )
      ),
      ' ',
      'generous grant helped to write the vehicular analysis modules.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'This application is the result of four iterations of a mapping initiative started by Transportation Alternatives in 2006 and continued by John Kraus.The current version of the application with charts was built in 2017 by Chris Henrick and ',
      ' ',
      _react2.default.createElement(
        'a',
        { href: 'https://greeninfo.org' },
        _react2.default.createElement(
          'strong',
          null,
          'GreenInfo Network'
        )
      ),
      '.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'a',
        { href: 'http://chekpeds.com/' },
        _react2.default.createElement(
          'strong',
          null,
          'CHECKPEDS'
        ),
        ' '
      ),
      'is a 501(c)(3) non-profit organization founded in 2005 that advocates for pedestrian safety, primarily focusing on the west side of Manhattan. Data has played a critical role in the coalition\'s success in highlighting the concentration of fatalities and injuries to the authorities. This resulted in the DOT installing traffic calming features in the area, including bike lanes, protected pedestrian crossings and traffic calming measures. It is CHEKPEDS\u2019 hope that this easy-to-use tool will empower many other activists and individuals in New York City to gain an understanding of how dangerous their streets are and obtain the installation of safety features.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'You may',
      ' ',
      _react2.default.createElement(
        'a',
        { href: 'mailto:excom@chekpeds.com?subject=NYC%20Crash%20Mapper' },
        _react2.default.createElement(
          'strong',
          null,
          'email CHEKPEDS'
        )
      ),
      ' ',
      'regarding any questions or concerns about NYC Crash Mapper.'
    )
  );
};

exports.default = AboutCopy;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__(15);

var defaultState = exports.defaultState = {
  _isFetching: false,
  geo: 'citywide',
  geojson: {
    type: '',
    features: [],
    geoName: ''
  },
  identifier: undefined,
  lngLats: [],
  drawEnabeled: false
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];

  switch (action.type) {
    case _action_types.FILTER_BY_AREA_TYPE:
      return _extends({}, state, {
        geo: action.geo,
        identifier: undefined,
        lngLats: [],
        drawEnabeled: action.geo === 'custom'
      });

    case _action_types.FILTER_BY_AREA_IDENTIFIER:
      return _extends({}, state, {
        identifier: action.identifier
      });

    case _action_types.FILTER_BY_AREA_CUSTOM:
      return _extends({}, state, {
        lngLats: action.lngLats,
        drawEnabeled: false
      });

    case _action_types.TOGGLE_CUSTOM_AREA_DRAW:
      return _extends({}, state, {
        drawEnabeled: !state.drawEnabeled
      });

    case _action_types.GEO_POLYGONS_REQUEST:
      return _extends({}, state, {
        _isFetching: true
      });

    case _action_types.GEO_POLYGONS_SUCCESS:
      return _extends({}, state, {
        _isFetching: false,
        geojson: action.geojson
      });

    case _action_types.GEO_POLYGONS_ERROR:
      return _extends({}, state, {
        _isFetching: false,
        error: action.error
      });

    default:
      return state;
  }
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(29);
module.exports = function(it, msg){
  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
  return +it;
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(17)
  , toIndex  = __webpack_require__(63)
  , toLength = __webpack_require__(16);

module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
  var O     = toObject(this)
    , len   = toLength(O.length)
    , to    = toIndex(target, len)
    , from  = toIndex(start, len)
    , end   = arguments.length > 2 ? arguments[2] : undefined
    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
    , inc   = 1;
  if(from < to && to < from + count){
    inc  = -1;
    from += count - 1;
    to   += count - 1;
  }
  while(count-- > 0){
    if(from in O)O[to] = O[from];
    else delete O[to];
    to   += inc;
    from += inc;
  } return O;
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(70);

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(22)
  , toObject  = __webpack_require__(17)
  , IObject   = __webpack_require__(87)
  , toLength  = __webpack_require__(16);

module.exports = function(that, callbackfn, aLen, memo, isRight){
  aFunction(callbackfn);
  var O      = toObject(that)
    , self   = IObject(O)
    , length = toLength(O.length)
    , index  = isRight ? length - 1 : 0
    , i      = isRight ? -1 : 1;
  if(aLen < 2)for(;;){
    if(index in self){
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if(isRight ? index < 0 : length <= index){
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction  = __webpack_require__(22)
  , isObject   = __webpack_require__(9)
  , invoke     = __webpack_require__(106)
  , arraySlice = [].slice
  , factories  = {};

var construct = function(F, len, args){
  if(!(len in factories)){
    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /*, args... */){
  var fn       = aFunction(this)
    , partArgs = arraySlice.call(arguments, 1);
  var bound = function(/* args... */){
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if(isObject(fn.prototype))bound.prototype = fn.prototype;
  return bound;
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP          = __webpack_require__(13).f
  , create      = __webpack_require__(58)
  , redefineAll = __webpack_require__(61)
  , ctx         = __webpack_require__(41)
  , anInstance  = __webpack_require__(56)
  , defined     = __webpack_require__(30)
  , forOf       = __webpack_require__(70)
  , $iterDefine = __webpack_require__(140)
  , step        = __webpack_require__(213)
  , setSpecies  = __webpack_require__(62)
  , DESCRIPTORS = __webpack_require__(12)
  , fastKey     = __webpack_require__(47).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(86)
  , from    = __webpack_require__(204);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll       = __webpack_require__(61)
  , getWeak           = __webpack_require__(47).getWeak
  , anObject          = __webpack_require__(4)
  , isObject          = __webpack_require__(9)
  , anInstance        = __webpack_require__(56)
  , forOf             = __webpack_require__(70)
  , createArrayMethod = __webpack_require__(34)
  , $has              = __webpack_require__(19)
  , arrayFind         = createArrayMethod(5)
  , arrayFindIndex    = createArrayMethod(6)
  , id                = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function(that){
  return that._l || (that._l = new UncaughtFrozenStore);
};
var UncaughtFrozenStore = function(){
  this.a = [];
};
var findUncaughtFrozen = function(store, key){
  return arrayFind(store.a, function(it){
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function(key){
    var entry = findUncaughtFrozen(this, key);
    if(entry)return entry[1];
  },
  has: function(key){
    return !!findUncaughtFrozen(this, key);
  },
  set: function(key, value){
    var entry = findUncaughtFrozen(this, key);
    if(entry)entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function(key){
    var index = arrayFindIndex(this.a, function(it){
      return it[0] === key;
    });
    if(~index)this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var data = getWeak(anObject(key), true);
    if(data === true)uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(12) && !__webpack_require__(7)(function(){
  return Object.defineProperty(__webpack_require__(132)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(9)
  , floor    = Math.floor;
module.exports = function isInteger(it){
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(4);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x){
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(60)
  , gOPS     = __webpack_require__(110)
  , pIE      = __webpack_require__(88)
  , toObject = __webpack_require__(17)
  , IObject  = __webpack_require__(87)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(7)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(13)
  , anObject = __webpack_require__(4)
  , getKeys  = __webpack_require__(60);

module.exports = __webpack_require__(12) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(26)
  , gOPN      = __webpack_require__(59).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(19)
  , toIObject    = __webpack_require__(26)
  , arrayIndexOf = __webpack_require__(102)(false)
  , IE_PROTO     = __webpack_require__(145)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(60)
  , toIObject = __webpack_require__(26)
  , isEnum    = __webpack_require__(88).f;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN     = __webpack_require__(59)
  , gOPS     = __webpack_require__(110)
  , anObject = __webpack_require__(4)
  , Reflect  = __webpack_require__(5).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
  var keys       = gOPN.f(anObject(it))
    , getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(5).parseFloat
  , $trim       = __webpack_require__(73).trim;

module.exports = 1 / $parseFloat(__webpack_require__(150) + '-0') !== -Infinity ? function parseFloat(str){
  var string = $trim(String(str), 3)
    , result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(5).parseInt
  , $trim     = __webpack_require__(73).trim
  , ws        = __webpack_require__(150)
  , hex       = /^[\-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(16)
  , repeat   = __webpack_require__(149)
  , defined  = __webpack_require__(30);

module.exports = function(that, maxLength, fillString, left){
  var S            = String(defined(that))
    , stringLength = S.length
    , fillStr      = fillString === undefined ? ' ' : String(fillString)
    , intMaxLength = toLength(maxLength);
  if(intMaxLength <= stringLength || fillStr == '')return S;
  var fillLen = intMaxLength - stringLength
    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(10);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(207);

// 23.1 Map Objects
module.exports = __webpack_require__(103)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if(__webpack_require__(12) && /./g.flags != 'g')__webpack_require__(13).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(105)
});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(207);

// 23.2 Set Objects
module.exports = __webpack_require__(103)('Set', function(get){
  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value){
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each         = __webpack_require__(34)(0)
  , redefine     = __webpack_require__(24)
  , meta         = __webpack_require__(47)
  , assign       = __webpack_require__(215)
  , weak         = __webpack_require__(209)
  , isObject     = __webpack_require__(9)
  , getWeak      = meta.getWeak
  , isExtensible = Object.isExtensible
  , uncaughtFrozenStore = weak.ufstore
  , tmp          = {}
  , InternalMap;

var wrapper = function(get){
  return function WeakMap(){
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key){
    if(isObject(key)){
      var data = getWeak(key);
      if(data === true)return uncaughtFrozenStore(this).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value){
    return weak.def(this, key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(103)('WeakMap', wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
  InternalMap = weak.getConstructor(wrapper);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function(key){
    var proto  = $WeakMap.prototype
      , method = proto[key];
    redefine(proto, key, function(a, b){
      // store frozen objects on internal weakmap shim
      if(isObject(a) && !isExtensible(a)){
        if(!this._f)this._f = new InternalMap;
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(735),
    mapCacheDelete = __webpack_require__(736),
    mapCacheGet = __webpack_require__(737),
    mapCacheHas = __webpack_require__(738),
    mapCacheSet = __webpack_require__(739);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(695),
    arraySome = __webpack_require__(702),
    cacheHas = __webpack_require__(712);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)))

/***/ }),
/* 242 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 243 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(37),
    stubFalse = __webpack_require__(760);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)(module)))

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(90),
    isObject = __webpack_require__(120);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 246 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(708),
    baseUnary = __webpack_require__(711),
    nodeUtil = __webpack_require__(742);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */
/***/ (function(module, exports) {

/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  return (/input|select|textarea|button|object/.test(nodeName) ?
    !element.disabled :
    "a" === nodeName ?
      element.href || isTabIndexNotNaN :
      isTabIndexNotNaN) && visible(element);
}

function hidden(el) {
  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
    el.style.display === 'none';
}

function visible(element) {
  while (element) {
    if (element === document.body) break;
    if (hidden(element)) return false;
    element = element.parentNode;
  }
  return true;
}

function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
    return tabbable(el);
  });
}

module.exports = findTabbableDescendants;



/***/ }),
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(21);

var _actions = __webpack_require__(39);

var _App = __webpack_require__(420);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
  var browser = _ref.browser,
      filterDate = _ref.filterDate,
      filterType = _ref.filterType,
      filterVehicle = _ref.filterVehicle,
      filterArea = _ref.filterArea;
  var startDate = filterDate.startDate,
      endDate = filterDate.endDate;
  var identifier = filterArea.identifier,
      geo = filterArea.geo,
      lngLats = filterArea.lngLats;
  var height = browser.height,
      width = browser.width;

  return {
    startDate: startDate,
    endDate: endDate,
    filterType: filterType,
    filterVehicle: filterVehicle,
    identifier: identifier,
    geo: geo,
    lngLats: lngLats,
    height: height,
    width: width
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchCrashStatsData: _actions.fetchCrashStatsData,
  fetchCrashesDateRange: _actions.fetchCrashesDateRange,
  fetchCrashesMaxDate: _actions.fetchCrashesMaxDate,
  fetchCrashesYearRange: _actions.fetchCrashesYearRange,
  fetchContributingFactors: _actions.fetchContributingFactors,
  openModal: _actions.openModal
})(_App2.default);

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeStore;

var _redux = __webpack_require__(99);

var _reduxResponsive = __webpack_require__(85);

var _reducers = __webpack_require__(474);

var _reducers2 = _interopRequireDefault(_reducers);

var _middleware = __webpack_require__(466);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function makeStore(initialState) {
  var store = (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.compose)((0, _reduxResponsive.createResponsiveStoreEnhancer)(500), // throttle time
  _redux.applyMiddleware.apply(undefined, _toConsumableArray(_middleware2.default))));

  if (false) {
    // enable hot module replacement
    module.hot.accept('./reducers/index.js', function () {
      var nextReducer = System.import('./reducers/index.js');
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(659);

__webpack_require__(896);

__webpack_require__(479);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)))

/***/ }),
/* 409 */,
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */,
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(120),
    now = __webpack_require__(758),
    toNumber = __webpack_require__(761);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchGeoPolygons = exports.fetchCrashesMaxDate = exports.fetchCrashesDateRange = exports.fetchCrashesYearRange = exports.fetchContributingFactors = exports.fetchCrashStatsData = undefined;

var _es6Promise = __webpack_require__(192);

var _isomorphicFetch = __webpack_require__(193);

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _app_config = __webpack_require__(68);

var _action_types = __webpack_require__(15);

var actions = _interopRequireWildcard(_action_types);

var _sql_queries = __webpack_require__(129);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _es6Promise.polyfill)();

var requestCrashStatsData = function requestCrashStatsData() {
  return {
    type: actions.CRASHES_ALL_REQUEST
  };
};

var receiveCrashStatsData = function receiveCrashStatsData(json) {
  return {
    type: actions.CRASHES_ALL_SUCCESS,
    json: json
  };
};

var receiveCrashStatsError = function receiveCrashStatsError(error) {
  return {
    type: actions.CRASHES_ALL_ERROR,
    error: error
  };
};

var fetchCrashStatsData = exports.fetchCrashStatsData = function fetchCrashStatsData(params) {
  var query = encodeURIComponent((0, _sql_queries.configureStatsSQL)(params));
  var url = (0, _app_config.cartoSQLQuery)(query);
  return function (dispatch) {
    dispatch(requestCrashStatsData());
    return (0, _isomorphicFetch2.default)(url).then(function (res) {
      return res.json();
    }).then(function (json) {
      return dispatch(receiveCrashStatsData(json.rows[0]));
    }).catch(function (error) {
      return dispatch(receiveCrashStatsError(error));
    });
  };
};

var requestContributingFactors = function requestContributingFactors() {
  return {
    type: actions.CONTRIBUTING_FACTORS_REQUEST
  };
};

var receiveContributingFactors = function receiveContributingFactors(json) {
  return {
    type: actions.CONTRIBUTING_FACTORS_SUCCESS,
    json: json
  };
};

var receiveContributingFactorsError = function receiveContributingFactorsError(error) {
  return {
    type: actions.CONTRIBUTING_FACTORS_ERROR,
    error: error
  };
};

var fetchContributingFactors = exports.fetchContributingFactors = function fetchContributingFactors(params) {
  var query = encodeURIComponent((0, _sql_queries.configureFactorsSQL)(params));
  var url = (0, _app_config.cartoSQLQuery)(query);
  return function (dispatch) {
    dispatch(requestContributingFactors());
    return (0, _isomorphicFetch2.default)(url).then(function (res) {
      return res.json();
    }).then(function (json) {
      return dispatch(receiveContributingFactors(json.rows));
    }).catch(function (error) {
      return dispatch(receiveContributingFactorsError(error));
    });
  };
};

var requestCrashesYearRange = function requestCrashesYearRange() {
  return {
    type: actions.CRASHES_YEAR_RANGE_REQUEST
  };
};

var receiveCrashesYearRange = function receiveCrashesYearRange(json) {
  return {
    type: actions.CRASHES_YEAR_RANGE_SUCCESS,
    json: json
  };
};

var receiveCrashesYearRangeError = function receiveCrashesYearRangeError(error) {
  return {
    type: actions.CRASHES_YEAR_RANGE_ERROR,
    error: error
  };
};

var fetchCrashesYearRange = exports.fetchCrashesYearRange = function fetchCrashesYearRange() {
  var query = encodeURIComponent((0, _sql_queries.crashesYearRangeSQL)());
  var url = (0, _app_config.cartoSQLQuery)(query);
  return function (dispatch) {
    dispatch(requestCrashesYearRange());
    return (0, _isomorphicFetch2.default)(url).then(function (res) {
      return res.json();
    }).then(function (json) {
      return dispatch(receiveCrashesYearRange(json.rows));
    }).catch(function (error) {
      return dispatch(receiveCrashesYearRangeError(error));
    });
  };
};

var requestCrashesDateRange = function requestCrashesDateRange() {
  return {
    type: actions.CRASHES_DATE_RANGE_REQUEST
  };
};

var receiveCrashesDateRange = function receiveCrashesDateRange(json) {
  return {
    type: actions.CRASHES_DATE_RANGE_SUCCESS,
    json: json
  };
};

var receiveCrashesDateRangeError = function receiveCrashesDateRangeError(error) {
  return {
    type: actions.CRASHES_DATE_RANGE_ERROR,
    error: error
  };
};

var fetchCrashesDateRange = exports.fetchCrashesDateRange = function fetchCrashesDateRange() {
  var query = encodeURIComponent((0, _sql_queries.minMaxDateRange)());
  var url = (0, _app_config.cartoSQLQuery)(query);
  return function (dispatch) {
    dispatch(requestCrashesDateRange());
    return (0, _isomorphicFetch2.default)(url).then(function (res) {
      return res.json();
    }).then(function (json) {
      return dispatch(receiveCrashesDateRange(json.rows));
    }).catch(function (error) {
      return dispatch(receiveCrashesDateRangeError(error));
    });
  };
};

var requestCrashesMaxDate = function requestCrashesMaxDate() {
  return {
    type: actions.CRASHES_MAX_DATE_REQUEST
  };
};

var receiveCrashesMaxDate = function receiveCrashesMaxDate(json) {
  return {
    type: actions.CRASHES_MAX_DATE_RESPONSE,
    json: json
  };
};

var receiveCrashesMaxDateError = function receiveCrashesMaxDateError(error) {
  return {
    type: actions.CRASHES_MAX_DATE_ERROR,
    error: error
  };
};

var fetchCrashesMaxDate = exports.fetchCrashesMaxDate = function fetchCrashesMaxDate() {
  var query = encodeURIComponent((0, _sql_queries.crashesMaxDate)());
  var url = (0, _app_config.cartoSQLQuery)(query);
  return function (dispatch) {
    dispatch(requestCrashesMaxDate());
    return (0, _isomorphicFetch2.default)(url).then(function (res) {
      return res.json();
    }).then(function (json) {
      return dispatch(receiveCrashesMaxDate(json.rows));
    }).catch(function (error) {
      return dispatch(receiveCrashesMaxDateError(error));
    });
  };
};

var requestGeoPolygons = function requestGeoPolygons() {
  return {
    type: actions.GEO_POLYGONS_REQUEST
  };
};

var receiveGeoPolygons = function receiveGeoPolygons(geojson) {
  return {
    type: actions.GEO_POLYGONS_SUCCESS,
    geojson: geojson
  };
};

var receiveGeoPolygonsError = function receiveGeoPolygonsError(error) {
  return {
    type: actions.GEO_POLYGONS_ERROR,
    error: error
  };
};

var fetchGeoPolygons = exports.fetchGeoPolygons = function fetchGeoPolygons(geo) {
  var query = encodeURIComponent(_sql_queries.filterByAreaSQL[geo]);
  var url = (0, _app_config.cartoSQLQuery)(query, 'geojson');
  return function (dispatch) {
    dispatch(requestGeoPolygons());
    return (0, _isomorphicFetch2.default)(url).then(function (res) {
      return res.json();
    }).then(function (json) {
      // tack on the geography name so that it may be diff'd in LeafletMap propTypes
      json.geoName = geo;
      return dispatch(receiveGeoPolygons(json));
    }).catch(function (error) {
      return dispatch(receiveGeoPolygonsError(error));
    });
  };
};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterByAreaCustom = exports.toggleCustomAreaDraw = exports.filterByAreaIdentifier = exports.filterByAreaType = undefined;

var _action_types = __webpack_require__(15);

var filterByAreaType = exports.filterByAreaType = function filterByAreaType() {
  var geo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'citywide';
  return {
    type: _action_types.FILTER_BY_AREA_TYPE,
    geo: geo
  };
};

var filterByAreaIdentifier = exports.filterByAreaIdentifier = function filterByAreaIdentifier(identifier) {
  return {
    type: _action_types.FILTER_BY_AREA_IDENTIFIER,
    identifier: identifier
  };
};

var toggleCustomAreaDraw = exports.toggleCustomAreaDraw = function toggleCustomAreaDraw() {
  return {
    type: _action_types.TOGGLE_CUSTOM_AREA_DRAW
  };
};

var filterByAreaCustom = exports.filterByAreaCustom = function filterByAreaCustom(lngLats) {
  return {
    type: _action_types.FILTER_BY_AREA_CUSTOM,
    lngLats: lngLats
  };
};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.endDateChange = exports.startDateChange = undefined;

var _action_types = __webpack_require__(15);

var startDateChange = exports.startDateChange = function startDateChange() {
  var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    type: _action_types.START_DATE_CHANGE,
    startDate: startDate
  };
};

var endDateChange = exports.endDateChange = function endDateChange() {
  var endDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    type: _action_types.END_DATE_CHANGE,
    endDate: endDate
  };
};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterByNoInjFat = exports.filterByTypeFatality = exports.filterByTypeInjury = undefined;

var _action_types = __webpack_require__(15);

var filterByTypeInjury = exports.filterByTypeInjury = function filterByTypeInjury(personType) {
  return {
    type: _action_types.FILTER_BY_TYPE_INJURY,
    personType: personType
  };
};

var filterByTypeFatality = exports.filterByTypeFatality = function filterByTypeFatality(personType) {
  return {
    type: _action_types.FILTER_BY_TYPE_FATALITY,
    personType: personType
  };
};

var filterByNoInjFat = exports.filterByNoInjFat = function filterByNoInjFat() {
  return {
    type: _action_types.FILTER_BY_NO_INJURY_FATALITY
  };
};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterByVehicleOther = exports.filterByVehicleScooter = exports.filterByVehicleBusVan = exports.filterByVehicleSuv = exports.filterByVehicleBicycle = exports.filterByVehicleMotorcycle = exports.filterByVehicleTruck = exports.filterByVehicleCar = undefined;

var _action_types = __webpack_require__(15);

var filterByVehicleCar = exports.filterByVehicleCar = function filterByVehicleCar() {
  return {
    type: _action_types.FILTER_BY_VEHICLE_CAR
  };
};

var filterByVehicleTruck = exports.filterByVehicleTruck = function filterByVehicleTruck() {
  return {
    type: _action_types.FILTER_BY_VEHICLE_TRUCK
  };
};

var filterByVehicleMotorcycle = exports.filterByVehicleMotorcycle = function filterByVehicleMotorcycle() {
  return {
    type: _action_types.FILTER_BY_VEHICLE_MOTORCYCLE
  };
};

var filterByVehicleBicycle = exports.filterByVehicleBicycle = function filterByVehicleBicycle() {
  return {
    type: _action_types.FILTER_BY_VEHICLE_BICYCLE
  };
};

var filterByVehicleSuv = exports.filterByVehicleSuv = function filterByVehicleSuv() {
  return {
    type: _action_types.FILTER_BY_VEHICLE_SUV
  };
};

var filterByVehicleBusVan = exports.filterByVehicleBusVan = function filterByVehicleBusVan() {
  return {
    type: _action_types.FILTER_BY_VEHICLE_BUSVAN
  };
};

var filterByVehicleScooter = exports.filterByVehicleScooter = function filterByVehicleScooter() {
  return {
    type: _action_types.FILTER_BY_VEHICLE_SCOOTER
  };
};

var filterByVehicleOther = exports.filterByVehicleOther = function filterByVehicleOther() {
  return {
    type: _action_types.FILTER_BY_VEHICLE_OTHER
  };
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _action_types = __webpack_require__(15);

exports.default = function () {
  var factor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    type: _action_types.FILTER_BY_CONTRIBUTING_FACTOR,
    factor: factor
  };
};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = exports.openModal = undefined;

var _action_types = __webpack_require__(15);

var openModal = exports.openModal = function openModal(modalType) {
  return {
    type: _action_types.MODAL_OPENED,
    modalType: modalType
  };
};

var closeModal = exports.closeModal = function closeModal() {
  return {
    type: _action_types.MODAL_CLOSED
  };
};

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactMomentProptypes = __webpack_require__(46);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _queryString = __webpack_require__(98);

var _queryString2 = _interopRequireDefault(_queryString);

var _api = __webpack_require__(54);

var _AppHeader = __webpack_require__(421);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _LeafletMapConnected = __webpack_require__(461);

var _LeafletMapConnected2 = _interopRequireDefault(_LeafletMapConnected);

var _StatsLegendConnected = __webpack_require__(465);

var _StatsLegendConnected2 = _interopRequireDefault(_StatsLegendConnected);

var _OptionsFiltersConnected = __webpack_require__(464);

var _OptionsFiltersConnected2 = _interopRequireDefault(_OptionsFiltersConnected);

var _ModalConnected = __webpack_require__(463);

var _ModalConnected2 = _interopRequireDefault(_ModalConnected);

var _SmallDeviceMessage = __webpack_require__(449);

var _SmallDeviceMessage2 = _interopRequireDefault(_SmallDeviceMessage);

var _LoadingIndicator = __webpack_require__(426);

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));

    _this.state = {
      isLoading: false
    };
    _this.dataLoading = _this.dataLoading.bind(_this);
    _this.onMapMoved = _this.onMapMoved.bind(_this);
    return _this;
  }

  _createClass(App, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // async calls for UI dependent on data
      this.props.fetchCrashesYearRange().then(this.props.fetchCrashesDateRange()).then(this.props.fetchCrashesMaxDate()).then(this.props.fetchCrashStatsData(this.props)).then(this.props.fetchContributingFactors(this.props)).catch(function (error) {
        throw error;
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _api.crashDataChanged)(this.props, nextProps)) {
        var query = this.props.location.query;

        this.updateQueryParams(_extends({}, query, nextProps));

        this.props.fetchCrashStatsData(nextProps).then(this.props.fetchContributingFactors(nextProps)).catch(function (error) {
          throw error;
        });
      }
    }
  }, {
    key: 'onMapMoved',
    value: function onMapMoved(event) {
      // update the url query params with map center & zoom
      if (event && event.target) {
        var query = {};
        query.zoom = event.target.getZoom();
        query.lat = event.target.getCenter().lat;
        query.lng = event.target.getCenter().lng;
        this.updateQueryParams(_extends({}, query, this.props));
      }
    }
  }, {
    key: 'updateQueryParams',
    value: function updateQueryParams(params) {
      // updates the URL location query with app state filters & map zoom & center
      // this allows for "stateful URLs" so that when app loads, it will load
      // with the same filters & map zoom & center last viewed, enabling sharing
      // of unique views of the data via the URL between users
      var lat = params.lat,
          lng = params.lng,
          zoom = params.zoom,
          startDate = params.startDate,
          endDate = params.endDate,
          identifier = params.identifier,
          geo = params.geo,
          lngLats = params.lngLats;
      var filterType = params.filterType,
          filterVehicle = params.filterVehicle;
      var injury = filterType.injury,
          fatality = filterType.fatality,
          noInjuryFatality = filterType.noInjuryFatality;
      var vehicle = filterVehicle.vehicle;


      var newQueryParams = {
        lat: lat,
        lng: lng,
        zoom: zoom,
        startDate: startDate.format(_api.dateStringFormatModel),
        endDate: endDate.format(_api.dateStringFormatModel),
        identifier: identifier,
        geo: geo,
        lngLats: encodeURIComponent(JSON.stringify(lngLats)),
        noInjFat: noInjuryFatality,
        cinj: injury.cyclist,
        minj: injury.motorist,
        pinj: injury.pedestrian,
        cfat: fatality.cyclist,
        mfat: fatality.motorist,
        pfat: fatality.pedestrian,
        vcar: vehicle.car,
        vtruck: vehicle.truck,
        vmotorcycle: vehicle.motorcycle,
        vbicycle: vehicle.bicycle,
        vsuv: vehicle.suv,
        vbusvan: vehicle.busvan,
        vscooter: vehicle.scooter,
        vother: vehicle.other
      };

      this.context.router.push('?' + _queryString2.default.stringify(newQueryParams));
    }
  }, {
    key: 'dataLoading',
    value: function dataLoading(bool) {
      this.setState({ isLoading: bool });
    }
  }, {
    key: 'render',
    value: function render() {
      var isLoading = this.state.isLoading;
      var _props = this.props,
          location = _props.location,
          openModal = _props.openModal,
          height = _props.height,
          width = _props.width;


      return _react2.default.createElement(
        'div',
        { className: 'App' },
        /* hide app to mobile users for now */
        width < 768 || height < 416 ? _react2.default.createElement(_SmallDeviceMessage2.default, null) : [_react2.default.createElement(_AppHeader2.default, { key: 'app-header', openModal: openModal }), _react2.default.createElement(_LeafletMapConnected2.default, {
          key: 'leaflet-map',
          location: location,
          dataLoading: this.dataLoading,
          isLoading: isLoading,
          onMapMoved: this.onMapMoved
        }), _react2.default.createElement(_LoadingIndicator2.default, { key: 'loading-indicator', isLoading: isLoading }), _react2.default.createElement(_StatsLegendConnected2.default, { key: 'stats-legend' }), _react2.default.createElement(_OptionsFiltersConnected2.default, { key: 'options-filters' }), _react2.default.createElement(_ModalConnected2.default, { key: 'modal' })]
      );
    }
  }]);

  return App;
}(_react.Component);

App.defaultProps = {
  identifier: '',
  geo: '',
  lngLats: []
};

App.propTypes = {
  fetchContributingFactors: _react.PropTypes.func.isRequired,
  fetchCrashesDateRange: _react.PropTypes.func.isRequired,
  fetchCrashStatsData: _react.PropTypes.func.isRequired,
  fetchCrashesMaxDate: _react.PropTypes.func.isRequired,
  fetchCrashesYearRange: _react.PropTypes.func.isRequired,
  openModal: _react.PropTypes.func.isRequired,
  location: _react.PropTypes.shape({
    query: _react.PropTypes.object.isRequired
  }).isRequired,
  startDate: _reactMomentProptypes2.default.momentObj.isRequired,
  endDate: _reactMomentProptypes2.default.momentObj.isRequired,
  filterType: _react.PropTypes.shape({
    noInjuryFatality: _react.PropTypes.bool,
    injury: _react.PropTypes.shape({
      cyclist: _react.PropTypes.bool,
      motorist: _react.PropTypes.bool,
      pedestrian: _react.PropTypes.bool
    }),
    fatality: _react.PropTypes.shape({
      cyclist: _react.PropTypes.bool,
      motorist: _react.PropTypes.bool,
      pedestrian: _react.PropTypes.bool
    })
  }).isRequired,
  filterVehicle: _react.PropTypes.shape({
    vehicle: _react.PropTypes.shape({
      car: _react.PropTypes.bool.isRequired,
      truck: _react.PropTypes.bool.isRequired,
      motorcycle: _react.PropTypes.bool.isRequired,
      bicycle: _react.PropTypes.bool.isRequired,
      suv: _react.PropTypes.bool.isRequired,
      busvan: _react.PropTypes.bool.isRequired,
      scooter: _react.PropTypes.bool.isRequired,
      other: _react.PropTypes.bool.isRequired
    }).isRequired
  }).isRequired,
  identifier: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  geo: _react.PropTypes.string,
  lngLats: _react.PropTypes.arrayOf(_react.PropTypes.arrayOf(_react.PropTypes.number)),
  height: _react.PropTypes.number.isRequired,
  width: _react.PropTypes.number.isRequired
};

App.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};

exports.default = App;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _MenuConnected = __webpack_require__(462);

var _MenuConnected2 = _interopRequireDefault(_MenuConnected);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppHeader = function AppHeader() {
  return _react2.default.createElement(
    'div',
    { className: 'app-header' },
    _react2.default.createElement(
      'div',
      { className: 'header-logo-title' },
      _react2.default.createElement(
        'div',
        { className: 'logo-chekpeds' },
        _react2.default.createElement(
          'a',
          { href: 'http://chekpeds.com', target: 'blank', rel: 'noopener noreferrer' },
          _react2.default.createElement('img', { alt: 'chekpeds logo', src: 'img/checkpeds_logo@2x.jpg' })
        )
      ),
      _react2.default.createElement(
        'h2',
        { className: 'header-title' },
        'NYC Crash Mapper'
      )
    ),
    _react2.default.createElement(_MenuConnected2.default, null)
  );
};

AppHeader.propTypes = {
  openModal: _react.PropTypes.func.isRequired
};

exports.default = AppHeader;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpCopy = function HelpCopy() {
  return _react2.default.createElement(
    "div",
    { className: "help-panel" },
    _react2.default.createElement(
      "table",
      null,
      _react2.default.createElement(
        "tbody",
        null,
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement("iframe", {
              title: "Help-Navigation",
              src: "https://player.vimeo.com/video/254240475",
              width: "480",
              height: "270",
              frameBorder: "0",
              allowFullScreen: true
            })
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "h6",
              null,
              "Crashmapper Navigation"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Analyze crash data like a pro. With a few clicks, master the information contained in the NYC Open Data Collision dataset, collected by NYPD. Choose a data view, filter by dates, geographies and crash type and get maps, charts and information summaries. Share with others."
            )
          )
        ),
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement("iframe", {
              title: "Help-CustomMap",
              src: "https://player.vimeo.com/video/255986407",
              width: "480",
              height: "270",
              frameBorder: "0",
              allowFullScreen: true
            })
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "h6",
              null,
              "Crashmapper Custom Map"
            ),
            _react2.default.createElement(
              "p",
              null,
              "How is my area of focus (corridor, school zone, business improvement district) faring in terms of traffic safety?"
            )
          )
        ),
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement("iframe", {
              title: "Help-Trend",
              src: "https://player.vimeo.com/video/255986627",
              width: "480",
              height: "270",
              frameBorder: "0",
              allowFullScreen: true
            })
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "h6",
              null,
              "Crashmapper Trend"
            ),
            _react2.default.createElement(
              "p",
              null,
              "How does my neighborhood compare to others and to the borough in terms of traffic safety?"
            )
          )
        ),
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement("iframe", {
              title: "Help-Compare",
              src: "https://player.vimeo.com/video/255986283",
              width: "480",
              height: "270",
              frameBorder: "0",
              allowFullScreen: true
            })
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "h6",
              null,
              "Crashmapper Compare"
            ),
            _react2.default.createElement(
              "p",
              null,
              "How has traffic safety changed in my neighborhood since a past period? Are the traffic calming measures working?"
            )
          )
        ),
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement("iframe", {
              title: "Help-Rank",
              src: "https://player.vimeo.com/video/255986528",
              width: "480",
              height: "270",
              frameBorder: "0",
              allowFullScreen: true
            })
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "h6",
              null,
              "Crashmapper Rank"
            ),
            _react2.default.createElement(
              "p",
              null,
              "How is this dangerous intersection ranked in the district, borough or city overall? Are we concentrating our efforts on the most dangerous intersections?"
            )
          )
        ),
        _react2.default.createElement(
          "tr",
          null,
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement("iframe", {
              title: "Help-Rank",
              src: "https://player.vimeo.com/video/414577873",
              width: "480",
              height: "270",
              frameBorder: "0",
              allowFullScreen: true
            })
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "h6",
              null,
              "Crashmapper Vehicle Filter"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Do many crashes involve certain type of vehicles? Is there a category of vehicles more dangerous to vulnerable users as they cause more fatalities and injuries? Is it specific to an area when enforcement should be increased?"
            )
          )
        )
      )
    )
  );
};

exports.default = HelpCopy;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ZoomControls = function ZoomControls(props) {
  var handleZoomIn = props.handleZoomIn,
      handleZoomOut = props.handleZoomOut;


  return _react2.default.createElement(
    "div",
    { className: "ui zoom-controls" },
    _react2.default.createElement(
      "button",
      { className: "zoom-in", onClick: function onClick() {
          return handleZoomIn();
        } },
      "+"
    ),
    _react2.default.createElement(
      "button",
      { className: "zoom-out", onClick: function onClick() {
          return handleZoomOut();
        } },
      "\u2013"
    )
  );
};

ZoomControls.propTypes = {
  handleZoomIn: _react.PropTypes.func.isRequired,
  handleZoomOut: _react.PropTypes.func.isRequired
};

exports.default = ZoomControls;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CustomFilter = function () {
  function CustomFilter() {
    _classCallCheck(this, CustomFilter);

    this.map = undefined;
    this.drawnItems = L.featureGroup();
    this.customLayer = undefined;
    this.poly = undefined;
    this.polyStyle = {};
    this.onLayerCreatedCB = function () {};
  }

  _createClass(CustomFilter, [{
    key: 'initCustomFilterLayer',
    value: function initCustomFilterLayer() {
      var self = this;
      this.customLayer = this.map.addLayer(self.drawnItems);
    }
  }, {
    key: 'initDrawPolygon',
    value: function initDrawPolygon() {
      var self = this;
      this.poly = new L.Draw.Polygon(self.map, {
        shapeOptions: self.polyStyle
      });
    }
  }, {
    key: 'onLayerCreated',
    value: function onLayerCreated() {
      var self = this;

      this.map.on(L.Draw.Event.CREATED, function (e) {
        var type = e.layerType;
        var layer = e.layer;

        if (type === 'polygon') {
          var geoJson = layer.toGeoJSON();
          var coordinates = geoJson.geometry.coordinates[0];
          self.onLayerCreatedCB(coordinates);
        }

        self.drawnItems.addLayer(layer);
      });
    }
  }, {
    key: 'startDraw',
    value: function startDraw() {
      this.poly.enable();
    }
  }, {
    key: 'cancelDraw',
    value: function cancelDraw() {
      this.poly.disable();
    }
  }, {
    key: 'mapInstance',
    set: function set(obj) {
      this.map = obj;
    }
  }, {
    key: 'layerCreatedCallback',
    set: function set(func) {
      if (func && typeof func === 'function') {
        this.onLayerCreatedCB = func;
      }
    }
  }, {
    key: 'polyOverlayStyle',
    set: function set(obj) {
      this.polyStyle = obj;
    }
  }, {
    key: 'drawLayer',
    get: function get() {
      return this.drawnItems;
    }
  }]);

  return CustomFilter;
}();

exports.default = CustomFilter;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n      <div class="cartodb-tooltip-content-wrapper crashes-layer">\n        <p><span class="roboto-bold">Total Crashes</span>: {{total_crashes}}</p>\n        <p><span class="roboto-bold">Total Persons Injured</span>: {{persons_injured}}</p>\n        <p><span class="roboto-bold">Total Persons Killed</span>: {{persons_killed}}</p>\n        <p>(Click for details)</p>\n      </div>\n    '], ['\n      <div class="cartodb-tooltip-content-wrapper crashes-layer">\n        <p><span class="roboto-bold">Total Crashes</span>: {{total_crashes}}</p>\n        <p><span class="roboto-bold">Total Persons Injured</span>: {{persons_injured}}</p>\n        <p><span class="roboto-bold">Total Persons Killed</span>: {{persons_killed}}</p>\n        <p>(Click for details)</p>\n      </div>\n    ']);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactMomentProptypes = __webpack_require__(46);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _singleLineString = __webpack_require__(100);

var _singleLineString2 = _interopRequireDefault(_singleLineString);

var _sql_queries = __webpack_require__(129);

var _app_config = __webpack_require__(68);

var _api = __webpack_require__(54);

var _ZoomControls = __webpack_require__(423);

var _ZoomControls2 = _interopRequireDefault(_ZoomControls);

var _customFilter = __webpack_require__(424);

var _customFilter2 = _interopRequireDefault(_customFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeafletMap = function (_Component) {
  _inherits(LeafletMap, _Component);

  function LeafletMap() {
    _classCallCheck(this, LeafletMap);

    var _this = _possibleConstructorReturn(this, (LeafletMap.__proto__ || Object.getPrototypeOf(LeafletMap)).call(this));

    _this.mapBounds = [[40.91553, -73.70002], [40.49613, -74.25559]];
    _this.fitBoundsOptions = {
      paddingTopLeft: [60, 100],
      paddingBottomRight: [300, 120],
      maxZoom: 18
    };
    // styles to apply to custom draw poly overlay
    _this.customDrawStyle = {
      color: '#17838f',
      fillOpacity: 0,
      weight: 2
    };
    _this.mapDiv = undefined; // div Leaflet mounts to
    _this.map = undefined; // instance of L.map
    _this.filterPolygons = undefined; // L.geoJson for selecting an geo area to filter by
    _this.filterAreaTooltip = undefined; // div for tooltip for filter area polygons
    _this.mapStatsDisclaimer = undefined;
    _this.customDraw = undefined;
    _this.cartoLayer = undefined;
    _this.cartoSubLayer = undefined;
    _this.cartodbSQL = undefined;
    _this.cartoSubLayerTooltip = undefined;
    _this.cartoInfowindow = undefined;
    _this.handleZoomIn = _this.handleZoomIn.bind(_this);
    _this.handleZoomOut = _this.handleZoomOut.bind(_this);
    return _this;
  }

  _createClass(LeafletMap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          lngLats = _props.lngLats,
          geo = _props.geo,
          identifier = _props.identifier;

      this.cartodbSQL = new cartodb.SQL({ user: _app_config.cartoUser });
      this.initMap();
      this.initCustomFilter();

      // if app loaded with an existing polygon from query params, add it to the drawlayer feat group
      if (lngLats && lngLats.length) {
        // reverse the coordinates [lng, lat] -> [lat, lng], because Leaflet :)
        var reversed = lngLats.reduce(function (acc, cur) {
          acc.push([cur[1], cur[0]]);
          return acc;
        }, []);
        var poly = L.polygon(reversed, this.customDrawStyle);
        this.customDraw.drawLayer.addLayer(poly);
      }

      // if loading a geo but no identifier, fetch geo-polygons to start up
      // if loading both/neither, that's already handled by standard props updates
      if (geo && geo !== 'citywide' && !identifier) {
        this.props.fetchGeoPolygons(geo);
      } else if (geo && identifier) {
        var sql = (0, _sql_queries.configureMapSQL)(this.props);
        this.fitMapBounds(sql);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var geo = nextProps.geo,
          geojson = nextProps.geojson,
          identifier = nextProps.identifier,
          drawEnabeled = nextProps.drawEnabeled;


      if (identifier !== this.props.identifier) {
        // user filtered by a specific geography, so hide the GeoJSON boundary overlay
        if (identifier) {
          this.map.removeLayer(this.filterPolygons);
        } else {
          this.updateCartoSubLayer(nextProps);
        }
      }

      // user deselected a geo identifier, having had one selected previously
      // and is keeping the same geography type
      if (!identifier && this.props.identifier && geo === this.props.geo) {
        if (geojson.features.length) {
          this.renderFilterPolygons(geo, geojson);
        } else {
          this.props.fetchGeoPolygons(geo);
        }
      }

      if ((0, _api.crashDataChanged)(this.props, nextProps)) {
        // if boundary filters were changed by user, update map data
        this.updateCartoSubLayer(nextProps);
      }

      if (geo === 'citywide' && this.props.geo !== 'citywide') {
        // user selected or deselected citywide filter, hide & show relevant overlays
        this.showMapStatsDisclaimer();
        this.hideFilterAreaPolygons();
        this.customFilterClearPoly();
      } else if (geo !== 'citywide') {
        this.hideMapStatsDisclaimer();
      }

      if (geo && geo !== this.props.geo && geo !== 'citywide' && geo !== 'custom') {
        // cancel custom draw in case it was enabled
        this.customFilterCancelDraw();
        // clear custom area layer if it was drawn
        this.customFilterClearPoly();
        // make an API call for GeoJSON of boundary polygons
        this.props.fetchGeoPolygons(geo);
      }

      if (geojson && geojson.features && geojson.features.length) {
        if (geojson.geoName !== this.props.geojson.geoName || geo !== 'citywide' && this.props.geo === 'citywide' || geo !== 'custom' && this.props.geo === 'custom') {
          // show the user polygons for filter by area / boundary
          this.renderFilterPolygons(geo, geojson);
        }
      }

      if (geo === 'custom' && this.props.geo !== 'custom') {
        this.customFilterClearPoly();
        this.customFilterEnableDraw();
      }

      if (!drawEnabeled && this.props.drawEnabeled) {
        this.customFilterCancelDraw();
      } else if (drawEnabeled && !this.props.drawEnabeled) {
        // clear any existing custom drawn polygon before drawing another one
        this.customFilterClearPoly();
        this.customFilterEnableDraw();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      // let Leaflet have control over this part of the DOM, not React.
      return false;
    }
  }, {
    key: 'handleZoomIn',
    value: function handleZoomIn() {
      this.map.zoomIn();
    }
  }, {
    key: 'handleZoomOut',
    value: function handleZoomOut() {
      this.map.zoomOut();
    }
  }, {
    key: 'initMap',
    value: function initMap() {
      var self = this;
      var _props2 = this.props,
          zoom = _props2.zoom,
          lat = _props2.lat,
          lng = _props2.lng,
          onMapMoved = _props2.onMapMoved;

      this.map = L.map(this.mapDiv, {
        doubleClickZoom: false,
        center: [lat, lng],
        zoom: zoom,
        maxZoom: 18,
        zoomControl: false,
        scrollWheelZoom: false
      });

      L.tileLayer(_app_config.basemapURL, {
        maxZoom: 18,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(self.map);

      // update the URL query params with map zoom & center
      this.map.on('moveend', onMapMoved);

      this.initCartoLayer();
    }
  }, {
    key: 'initCartoLayer',
    value: function initCartoLayer() {
      var self = this;
      var layerSource = (0, _api.configureLayerSource)((0, _sql_queries.configureMapSQL)(this.props));
      // const layerSource = 'https://chekpeds.carto.com/api/v2/viz/acf2c4f6-e987-11e6-bfb2-0e233c30368f/viz.json';
      var options = {
        https: true,
        infowindow: true,
        legends: false
      };

      // `cartodb` is a global var, refers to CARTO.JS: https://carto.com/docs/carto-engine/carto-js/
      // this creates the crash data tile layer & utf grid for Leaflet
      cartodb.createLayer(self.map, layerSource, options).addTo(self.map).on('done', function (layer) {
        self.cartoLayer = layer;
        layer.on('error', function (error) {
          throw error;
        });
        layer.on('loading', function () {
          return self.props.dataLoading(true);
        });
        layer.on('load', function () {
          return self.props.dataLoading(false);
        });
        // store a reference to the Carto SubLayer so we can act upon it later,
        // mainly to update the SQL query based on filters applied by the user
        self.cartoSubLayer = layer.getSubLayer(0);
        // add tooltips to sublayer
        self.initCartoSubLayerTooltips();
        // add infowindows to sublayer
        self.initCartoSubLayerInfowindows();
      }).on('error', function (error) {
        throw error;
      });
    }
  }, {
    key: 'initCartoSubLayerTooltips',
    value: function initCartoSubLayerTooltips() {
      var self = this;
      var template = (0, _singleLineString2.default)(_templateObject);

      // add the tooltip to the crashes sublayer
      self.cartoSubLayerTooltip = this.cartoLayer.leafletMap.viz.addOverlay({
        type: 'tooltip',
        layer: self.cartoSubLayer,
        template: template,
        position: 'bottom|right',
        fields: [{ total_crashes: 'Total Crashes' }, { persons_injured: 'persons injured' }, { persons_killed: 'persons killed' }]
      });
    }
  }, {
    key: 'initCartoSubLayerInfowindows',
    value: function initCartoSubLayerInfowindows() {
      var self = this;
      var infowindowTemplate = document.getElementById('infowindow_template').innerHTML;
      self.cartoInfowindow = cdb.vis.Vis.addInfowindow(self.map, self.cartoSubLayer, _app_config.crashDataFieldNames, {
        infowindowTemplate: infowindowTemplate,
        templateType: 'mustache'
      });
    }
  }, {
    key: 'hideCartoTooltips',
    value: function hideCartoTooltips() {
      this.cartoSubLayerTooltip.hide();
    }
  }, {
    key: 'hideCartoInfowindow',
    value: function hideCartoInfowindow() {
      this.cartoInfowindow._closeInfowindow();
    }
  }, {
    key: 'fitMapBounds',
    value: function fitMapBounds(sql) {
      // sets the map center & zoom to bounding box of crash data
      // returned by the current SQL query
      var self = this;
      self.cartodbSQL.getBounds(sql).done(function (bounds) {
        self.map.fitBounds(bounds, self.fitBoundsOptions);
      });
    }
  }, {
    key: 'updateCartoSubLayer',
    value: function updateCartoSubLayer(nextProps) {
      // create the new sql query string
      var sql = (0, _sql_queries.configureMapSQL)(nextProps);
      // hide any visible tooltips
      this.hideFilterAreaTooltip();
      this.hideCartoTooltips();
      // hide any open infowindow
      this.hideCartoInfowindow();
      // fit the map extent to the queried data, unless that's Everything
      if (nextProps.geo && nextProps.identifier) {
        this.fitMapBounds(sql);
      }
      // set the cartoSubLayer to be interactive
      this.cartoSubLayer.setInteraction(true);
      // update the cartoLayer SQL using new props, such as start and end dates
      this.cartoSubLayer.setSQL(sql);
    }
  }, {
    key: 'initCustomFilter',
    value: function initCustomFilter() {
      var filterByAreaCustom = this.props.filterByAreaCustom;

      this.customDraw = new _customFilter2.default();
      this.customDraw.mapInstance = this.map;
      this.customDraw.layerCreatedCallback = filterByAreaCustom;
      this.customDraw.polyStyle = this.customDrawStyle;
      this.customDraw.onLayerCreated();
      this.customDraw.initCustomFilterLayer();
      this.customDraw.initDrawPolygon();
    }
  }, {
    key: 'customFilterEnableDraw',
    value: function customFilterEnableDraw() {
      this.cartoSubLayer.setInteraction(false);
      this.hideFilterAreaPolygons();
      this.hideFilterAreaTooltip();
      this.hideCartoTooltips();
      this.hideCartoInfowindow();
      this.customDraw.startDraw();
    }
  }, {
    key: 'customFilterCancelDraw',
    value: function customFilterCancelDraw() {
      this.customDraw.cancelDraw();
      this.cartoSubLayer.setInteraction(true);
    }
  }, {
    key: 'customFilterClearPoly',
    value: function customFilterClearPoly() {
      this.customDraw.drawLayer.clearLayers();
    }
  }, {
    key: 'showMapStatsDisclaimer',
    value: function showMapStatsDisclaimer() {
      this.mapStatsDisclaimer.style.display = '';
    }
  }, {
    key: 'hideMapStatsDisclaimer',
    value: function hideMapStatsDisclaimer() {
      this.mapStatsDisclaimer.style.display = 'none';
    }
  }, {
    key: 'revealFilterAreaTooltip',
    value: function revealFilterAreaTooltip(geo, event) {
      var containerPoint = event.containerPoint,
          target = event.target;
      var x = containerPoint.x,
          y = containerPoint.y;

      var identifier = target.feature.properties.identifier;
      var p = this.filterAreaTooltip.children[0];

      this.filterAreaTooltip.style.cssText = 'display: initial; top: ' + (y - 25) + 'px; left: ' + (x + 10) + 'px;';

      // intersections have the ID|Name thing to split out
      // boroughs have a special lookup table for their label
      // and they all map onto a format string to make the labels read nicely
      var label = identifier;
      if (geo === 'borough') {
        label = _api.boroughs[identifier];
      } else if (geo === 'intersection') {
        label = identifier.split('|')[0].split(', ')[1]; // see sql_queries.js where we concat the borough,ID|name
      }
      label = _app_config.labelFormats[geo].replace('{}', label);

      p.textContent = label;
    }
  }, {
    key: 'hideFilterAreaTooltip',
    value: function hideFilterAreaTooltip() {
      this.filterAreaTooltip.style.display = 'none';
    }
  }, {
    key: 'hideFilterAreaPolygons',
    value: function hideFilterAreaPolygons() {
      // clear any existing geojson polygons that may be visible
      if (this.filterPolygons) {
        this.map.removeLayer(this.filterPolygons);
      }
    }
  }, {
    key: 'renderFilterPolygons',
    value: function renderFilterPolygons(geo, geojson) {
      var self = this;

      // functions to pass to L.geoJson.options.onEachFeature
      function handleMouseover(e) {
        var layer = e.target;

        layer.setStyle({
          fillColor: '#105b63',
          fillOpacity: 1
        });

        self.revealFilterAreaTooltip(geo, e);

        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
          layer.bringToFront();
        }
      }

      function handleMouseout(e) {
        self.filterPolygons.resetStyle(e.target);
        self.hideFilterAreaTooltip();
      }

      function handleMousemove(e) {
        self.revealFilterAreaTooltip(geo, e);
      }

      function handleClick(e) {
        var target = e.target;
        var identifier = target.feature.properties.identifier;
        // use borough name string as the identifier, not number
        if (geo === 'borough') {
          identifier = _api.boroughs[identifier];
        }
        self.cartoSubLayer.setInteraction(true);
        self.props.filterByAreaIdentifier(identifier);
      }

      function onEachFeature(feature, layer) {
        layer.on({
          mouseover: handleMouseover,
          mouseout: handleMouseout,
          mousemove: handleMousemove,
          click: handleClick
        });
      }

      // sets the default polygon style for filterPolygons
      function style() {
        return {
          fillColor: '#17838f',
          weight: 1,
          opacity: 1,
          color: '#fff',
          fillOpacity: 0.7
        };
      }

      /* disabled behavior; visually jarring to have the map jump around
      if (geo !== 'custom') {
        // for filter area polygons, fit map bounds to all of NYC
        this.map.fitBounds(this.mapBounds, this.mapBoundsOptions);
      }
      */

      // hide Carto sublayer tooltips / info windows & prevent interaction
      this.hideCartoTooltips();
      this.hideCartoInfowindow();
      this.cartoSubLayer.setInteraction(false);

      // clear any existing geojson polygons that may be visible
      this.hideFilterAreaPolygons();

      // set the geojson layer, store it, and add it to the map
      this.filterPolygons = L.geoJson(geojson, {
        onEachFeature: onEachFeature,
        style: style
      }).addTo(this.map);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'leaflet-map' },
        _react2.default.createElement(_ZoomControls2.default, {
          handleZoomIn: this.handleZoomIn,
          handleZoomOut: this.handleZoomOut
        }),
        _react2.default.createElement(
          'div',
          { ref: function ref(_) {
              _this2.mapStatsDisclaimer = _;
            }, className: 'map-stats-disclaimer' },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'Note:'
            ),
            ' Map data may differ from stats below due to lack of location information provided by the NYPD.'
          )
        ),
        _react2.default.createElement(
          'div',
          { ref: function ref(_) {
              _this2.filterAreaTooltip = _;
            }, className: 'filter-area-tooltip' },
          _react2.default.createElement('p', null)
        ),
        _react2.default.createElement('div', { ref: function ref(_) {
            _this2.mapDiv = _;
          }, id: 'map' })
      );
    }
  }]);

  return LeafletMap;
}(_react.Component);

LeafletMap.defaultProps = {
  zoom: 12,
  lat: 40.687,
  lng: -73.982,
  identifier: '',
  lngLats: [],
  geojson: {}
};

LeafletMap.propTypes = {
  onMapMoved: _react.PropTypes.func.isRequired,
  dataLoading: _react.PropTypes.func.isRequired,
  filterByAreaIdentifier: _react.PropTypes.func.isRequired,
  filterByAreaCustom: _react.PropTypes.func.isRequired,
  fetchGeoPolygons: _react.PropTypes.func.isRequired,
  zoom: _react.PropTypes.number,
  lat: _react.PropTypes.number,
  lng: _react.PropTypes.number,
  geo: _react.PropTypes.string.isRequired,
  geojson: _react.PropTypes.shape({
    type: _react.PropTypes.string,
    features: _react.PropTypes.array,
    geoName: _react.PropTypes.string
  }),
  identifier: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  lngLats: _react.PropTypes.arrayOf(_react.PropTypes.arrayOf(_react.PropTypes.number)),
  drawEnabeled: _react.PropTypes.bool.isRequired,
  startDate: _reactMomentProptypes2.default.momentObj.isRequired,
  endDate: _reactMomentProptypes2.default.momentObj.isRequired,
  filterType: _react.PropTypes.shape({
    fatality: _react.PropTypes.shape({
      cyclist: _react.PropTypes.bool.isRequired,
      motorist: _react.PropTypes.bool.isRequired,
      pedestrian: _react.PropTypes.bool.isRequired
    }).isRequired,
    injury: _react.PropTypes.shape({
      cyclist: _react.PropTypes.bool.isRequired,
      motorist: _react.PropTypes.bool.isRequired,
      pedestrian: _react.PropTypes.bool.isRequired
    }).isRequired,
    noInjuryFatality: _react.PropTypes.bool.isRequired
  }).isRequired
};

exports.default = LeafletMap;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _spin = __webpack_require__(897);

var _spin2 = _interopRequireDefault(_spin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingIndicator = function (_Component) {
  _inherits(LoadingIndicator, _Component);

  function LoadingIndicator() {
    _classCallCheck(this, LoadingIndicator);

    var _this = _possibleConstructorReturn(this, (LoadingIndicator.__proto__ || Object.getPrototypeOf(LoadingIndicator)).call(this));

    _this.el = undefined;
    _this.spinner = undefined;
    _this.opts = {
      color: '#17838f', // scss/_variables.$marine-light
      lines: 11,
      length: 7,
      width: 3,
      radius: 6,
      scale: 1,
      shadow: false
    };
    return _this;
  }

  _createClass(LoadingIndicator, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.spinner = new _spin2.default(this.opts).spin(this.el);
      window.spinner = this.spinner;
      window.el = this.el;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isLoading = nextProps.isLoading;


      if (isLoading) {
        this.spinner.spin(this.el);
      } else {
        this.spinner.stop();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', { ref: function ref(_) {
          _this2.el = _;
        }, className: 'loading-indicator' });
    }
  }]);

  return LoadingIndicator;
}(_react.Component);

LoadingIndicator.propTypes = {
  isLoading: _react.PropTypes.bool.isRequired
};

exports.default = LoadingIndicator;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _queryString = __webpack_require__(98);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Renders the nav menu items in the header
var Menu = function Menu(props) {
  var openModal = props.openModal,
      rest = _objectWithoutProperties(props, ['openModal']);

  var queryString = _queryString2.default.stringify(rest);

  var hostname =  true ? 'vis.crashmapper.org' : 'localhost:8889';

  var items = [{ type: null, value: 'map', label: 'Map' }, { type: 'link', value: 'trend', label: 'Trend' }, { type: 'link', value: 'vehicle', label: 'Vehicle' }, { type: 'link', value: 'compare', label: 'Compare' }, { type: 'link', value: 'rank', label: 'Rank' }, { type: 'modal', value: 'about', label: 'About' }, { type: 'modal', value: 'help', label: 'Help' }];

  var mapTypeToElement = function mapTypeToElement(item) {
    var label = item.label,
        type = item.type,
        value = item.value;


    switch (type) {
      case 'link':
        return _react2.default.createElement(
          'a',
          { href: 'http://' + hostname + '?view=' + value + '&' + queryString },
          label
        );

      case 'modal':
        return _react2.default.createElement(
          'button',
          { onClick: function onClick() {
              return openModal(value);
            } },
          label
        );

      default:
        return _react2.default.createElement(
          'button',
          {
            className: value === 'map' ? 'active' : null,
            onClick: function onClick() {}
          },
          item.label
        );
    }
  };

  return _react2.default.createElement(
    'ul',
    { className: 'Menu' },
    items.map(function (item) {
      return _react2.default.createElement(
        'li',
        { key: item.label },
        mapTypeToElement(item)
      );
    })
  );
};

Menu.propTypes = {
  openModal: _react.PropTypes.func.isRequired,
  p1start: _react.PropTypes.string.isRequired,
  p1end: _react.PropTypes.string.isRequired,
  geo: _react.PropTypes.string.isRequired,
  primary: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  pinj: _react.PropTypes.bool.isRequired,
  pfat: _react.PropTypes.bool.isRequired,
  cinj: _react.PropTypes.bool.isRequired,
  cfat: _react.PropTypes.bool.isRequired,
  minj: _react.PropTypes.bool.isRequired,
  mfat: _react.PropTypes.bool.isRequired
};

Menu.defaultProps = {
  primary: null
};

exports.default = Menu;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _AboutCopy = __webpack_require__(200);

var _AboutCopy2 = _interopRequireDefault(_AboutCopy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'div',
    { className: 'modal-about' },
    _react2.default.createElement(_AboutCopy2.default, null)
  );
};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var year = new Date().getFullYear();

  return _react2.default.createElement(
    "div",
    { className: "modal-copyright" },
    _react2.default.createElement(
      "p",
      null,
      "NYC Crash Mapper \xA9 CHECKPEDS ",
      year
    )
  );
};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    "div",
    { className: "modal-disclaimer" },
    _react2.default.createElement(
      "p",
      null,
      "Crash Mapper has no legal bearing and is intended for informational purposes only."
    )
  );
};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactMomentProptypes = __webpack_require__(46);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _sql_queries = __webpack_require__(129);

var _app_config = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TO DO: fix props validation for start & end dates
var DownloadData = function DownloadData(props) {
  var startDate = props.startDate,
      endDate = props.endDate,
      closeModal = props.closeModal;

  var sql = (0, _sql_queries.configureDownloadDataSQL)(_extends({
    startDate: startDate,
    endDate: endDate
  }, props));
  var sqlEncoded = window.encodeURIComponent(sql);
  var urlPartial = 'https://' + _app_config.cartoUser + '.carto.com/api/v2/sql?q=' + sqlEncoded + '&format=';
  var dataTypes = ['CSV', 'GeoJSON', 'Shapefile', 'KML'];
  var renderButton = function renderButton(name) {
    return _react2.default.createElement(
      'a',
      {
        key: name,
        className: 'button dl-data-btn',
        rel: 'noopener noreferrer',
        target: '_blank',
        href: '' + urlPartial + (name === 'Shapefile' ? 'shp' : name),
        onClick: function onClick() {
          return closeModal();
        }
      },
      name
    );
  };

  return _react2.default.createElement(
    'div',
    { className: 'modal-download-data' },
    _react2.default.createElement(
      'p',
      { className: 'roboto-bold' },
      'Any active filters will be applied to your download.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Choose from one of the following data formats:'
    ),
    _react2.default.createElement(
      'div',
      { className: 'download-data-btns' },
      dataTypes.map(function (d) {
        return renderButton(d);
      })
    )
  );
};

exports.default = DownloadData;


DownloadData.propTypes = {
  closeModal: _react.PropTypes.func.isRequired,
  startDate: _reactMomentProptypes2.default.momentObj.isRequired,
  endDate: _reactMomentProptypes2.default.momentObj.isRequired,
  filterVehicle: _react.PropTypes.shape({
    vehicle: _react.PropTypes.shape({
      car: _react.PropTypes.bool.isRequired,
      truck: _react.PropTypes.bool.isRequired,
      motorcycle: _react.PropTypes.bool.isRequired,
      bicycle: _react.PropTypes.bool.isRequired,
      suv: _react.PropTypes.bool.isRequired,
      busvan: _react.PropTypes.bool.isRequired,
      scooter: _react.PropTypes.bool.isRequired,
      other: _react.PropTypes.bool.isRequired
    }).isRequired
  }).isRequired
};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _HelpCopy = __webpack_require__(422);

var _HelpCopy2 = _interopRequireDefault(_HelpCopy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'div',
    { className: 'modal-help' },
    _react2.default.createElement(_HelpCopy2.default, null)
  );
};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Higher Order Component (HOC) that wraps modal content's children
// see https://facebook.github.io/react/docs/higher-order-components.html
var ModalContent = function ModalContent(WrappedComponent, config) {
  var modalType = config.modalType,
      closeModal = config.closeModal;


  return function (_Component) {
    _inherits(MC, _Component);

    function MC() {
      _classCallCheck(this, MC);

      return _possibleConstructorReturn(this, (MC.__proto__ || Object.getPrototypeOf(MC)).apply(this, arguments));
    }

    _createClass(MC, [{
      key: 'render',
      value: function render() {
        var title = {
          about: 'About NYC Crash Mapper',
          help: 'How to Use Crash Mapper',
          copyright: 'Copyright',
          disclaimer: 'Disclaimer',
          'download-data': 'Download Data',
          'share-fb': 'Share on Facebook',
          'share-tw': 'Share on Twitter',
          'share-url': 'Share URL'
        };

        // wraps the child component with a title and close button
        // passes closeModal action creator in case child needs to call it,
        // e.g. DownloadData buttons
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('button', { className: 'btn-modal-close', onClick: function onClick() {
              return closeModal();
            } }),
          _react2.default.createElement(
            'h5',
            { className: 'modal-title' },
            title[modalType]
          ),
          _react2.default.createElement(WrappedComponent, _extends({}, this.props, { closeModal: closeModal }))
        );
      }
    }]);

    return MC;
  }(_react.Component);
};

exports.default = ModalContent;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Placeholder
exports.default = function () {
  var location = window.encodeURIComponent(window.location.href);
  var url = "https://www.facebook.com/sharer/sharer.php?u=" + location;

  return _react2.default.createElement(
    "div",
    { className: "modal-share-fb" },
    _react2.default.createElement(
      "p",
      null,
      _react2.default.createElement(
        "a",
        { rel: "noopener noreferrer", target: "_blank", href: url },
        "Share NYC Crash Mapper on Facebook"
      )
    )
  );
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Placeholder
exports.default = function () {
  // including the query string would make the tweet more than 150 chars
  var href = window.location.href;
  var arr = href.split('/');
  var location = window.encodeURIComponent(arr[0] + '//' + arr[2] + '/' + arr[3]);
  var url = 'https://twitter.com/home?status=' + location;

  return _react2.default.createElement(
    'div',
    { className: 'modal-share-twitter' },
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'a',
        { rel: 'noopener noreferrer', target: '_blank', href: url },
        'Share NYC Crash Mapper on Twitter'
      )
    )
  );
};

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactCopyToClipboard = __webpack_require__(195);

var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TO DO: create dl button using URL & SQL API query, e.g.
// https://username.cartodb.com/api/v2/sql?q=SELECT%20*%20FROM%20table_name&format=CSV
var ShareURL = function (_Component) {
  _inherits(ShareURL, _Component);

  function ShareURL() {
    _classCallCheck(this, ShareURL);

    var _this = _possibleConstructorReturn(this, (ShareURL.__proto__ || Object.getPrototypeOf(ShareURL)).call(this));

    _this.state = {
      copied: false,
      value: window.location.href
    };
    return _this;
  }

  _createClass(ShareURL, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          value = _state.value,
          copied = _state.copied;


      return _react2.default.createElement(
        'div',
        { className: 'modal-share-url' },
        _react2.default.createElement(
          'p',
          null,
          'The current map view and any active filters may be shared using this URL:'
        ),
        _react2.default.createElement('input', { type: 'text', value: value, onFocus: function onFocus(e) {
            return e.target.select();
          }, readOnly: true }),
        _react2.default.createElement(
          _reactCopyToClipboard2.default,
          { text: value, onCopy: function onCopy() {
              return _this2.setState({ copied: true });
            } },
          _react2.default.createElement(
            'button',
            null,
            'Copy'
          )
        ),
        _react2.default.createElement(
          'span',
          { className: 'copied' },
          copied ? 'Copied!' : ''
        )
      );
    }
  }]);

  return ShareURL;
}(_react.Component);

exports.default = ShareURL;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactMomentProptypes = __webpack_require__(46);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _reactModal = __webpack_require__(836);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _ModalContent = __webpack_require__(433);

var _ModalContent2 = _interopRequireDefault(_ModalContent);

var _About = __webpack_require__(428);

var _About2 = _interopRequireDefault(_About);

var _Help = __webpack_require__(432);

var _Help2 = _interopRequireDefault(_Help);

var _DownloadData = __webpack_require__(431);

var _DownloadData2 = _interopRequireDefault(_DownloadData);

var _ShareURL = __webpack_require__(436);

var _ShareURL2 = _interopRequireDefault(_ShareURL);

var _ShareFB = __webpack_require__(434);

var _ShareFB2 = _interopRequireDefault(_ShareFB);

var _ShareTwitter = __webpack_require__(435);

var _ShareTwitter2 = _interopRequireDefault(_ShareTwitter);

var _Disclaimer = __webpack_require__(430);

var _Disclaimer2 = _interopRequireDefault(_Disclaimer);

var _Copyright = __webpack_require__(429);

var _Copyright2 = _interopRequireDefault(_Copyright);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalWrapper = function (_Component) {
  _inherits(ModalWrapper, _Component);

  function ModalWrapper() {
    _classCallCheck(this, ModalWrapper);

    var _this = _possibleConstructorReturn(this, (ModalWrapper.__proto__ || Object.getPrototypeOf(ModalWrapper)).call(this));

    _this.handleModalType = _this.handleModalType.bind(_this);
    return _this;
  }

  _createClass(ModalWrapper, [{
    key: 'handleModalType',
    value: function handleModalType() {
      var _props = this.props,
          modalType = _props.modalType,
          closeModal = _props.closeModal;
      var _props2 = this.props,
          startDate = _props2.startDate,
          endDate = _props2.endDate;
      var _props3 = this.props,
          filterType = _props3.filterType,
          filterArea = _props3.filterArea,
          filterVehicle = _props3.filterVehicle;

      var modalTypes = {
        about: _About2.default,
        help: _Help2.default,
        copyright: _Copyright2.default,
        disclaimer: _Disclaimer2.default,
        'download-data': _DownloadData2.default,
        'share-fb': _ShareFB2.default,
        'share-tw': _ShareTwitter2.default,
        'share-url': _ShareURL2.default
      };
      var hocConfig = { modalType: modalType, closeModal: closeModal };
      var HOC = (0, _ModalContent2.default)(modalTypes[modalType], hocConfig);

      return _react2.default.createElement(HOC, { filterType: filterType, filterArea: filterArea, filterVehicle: filterVehicle, startDate: startDate, endDate: endDate });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          closeModal = _props4.closeModal,
          showModal = _props4.showModal,
          modalType = _props4.modalType;

      var contentLabel = modalType + ' modal';

      return _react2.default.createElement(
        _reactModal2.default,
        {
          isOpen: showModal,
          onRequestClose: function onRequestClose() {
            return closeModal();
          },
          contentLabel: contentLabel,
          className: 'Modal',
          overlayClassName: 'Overlay'
        },
        this.handleModalType()
      );
    }
  }]);

  return ModalWrapper;
}(_react.Component);

ModalWrapper.defaultProps = {
  modalType: ''
};

ModalWrapper.propTypes = {
  closeModal: _react.PropTypes.func.isRequired,
  showModal: _react.PropTypes.bool.isRequired,
  modalType: _react.PropTypes.string,
  filterType: _react.PropTypes.shape({}).isRequired,
  filterArea: _react.PropTypes.shape({}).isRequired,
  filterVehicle: _react.PropTypes.shape({
    vehicle: _react.PropTypes.shape({
      car: _react.PropTypes.bool.isRequired,
      truck: _react.PropTypes.bool.isRequired,
      motorcycle: _react.PropTypes.bool.isRequired,
      bicycle: _react.PropTypes.bool.isRequired,
      suv: _react.PropTypes.bool.isRequired,
      busvan: _react.PropTypes.bool.isRequired,
      scooter: _react.PropTypes.bool.isRequired,
      other: _react.PropTypes.bool.isRequired
    }).isRequired
  }).isRequired,
  startDate: _reactMomentProptypes2.default.momentObj.isRequired,
  endDate: _reactMomentProptypes2.default.momentObj.isRequired
};

exports.default = ModalWrapper;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _FilterButton = __webpack_require__(67);

var _FilterButton2 = _interopRequireDefault(_FilterButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadData = function DownloadData(props) {
  var lastUpdated = props.lastUpdated,
      openModal = props.openModal;

  return _react2.default.createElement(
    'div',
    { className: 'download-data' },
    _react2.default.createElement(_FilterButton2.default, {
      label: 'Download Data',
      id: 'download-data',
      btnSize: 'auto',
      handleClick: openModal
    }),
    _react2.default.createElement(
      'div',
      { className: 'data-last-updated' },
      _react2.default.createElement(
        'p',
        null,
        'Data last updated on:'
      ),
      _react2.default.createElement(
        'p',
        null,
        lastUpdated
      )
    )
  );
};

DownloadData.propTypes = {
  openModal: _react.PropTypes.func.isRequired,
  lastUpdated: _react.PropTypes.string.isRequired
};

exports.default = DownloadData;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _FilterButton = __webpack_require__(67);

var _FilterButton2 = _interopRequireDefault(_FilterButton);

var _app_config = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterByBoundary = function FilterByBoundary(props) {
  var filterByAreaType = props.filterByAreaType,
      filterByAreaIdentifier = props.filterByAreaIdentifier,
      toggleCustomAreaDraw = props.toggleCustomAreaDraw,
      drawEnabeled = props.drawEnabeled,
      geo = props.geo,
      identifier = props.identifier;


  var showIdentifier = function showIdentifier(name) {
    if (geo === name && identifier) {
      var label = identifier;
      if (geo === 'intersection') label = label.split('|')[0].split(', ')[1];

      var tooltip = _app_config.labelFormats[geo].replace('{}', label);

      if (label.length > 12) {
        label = label.substring(0, 12) + '...';
      }

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'p',
          { className: 'identifier-label', title: tooltip },
          label
        ),
        _react2.default.createElement(
          'button',
          {
            className: 'deselect-identifier',
            onClick: function onClick() {
              return filterByAreaIdentifier(undefined);
            }
          },
          '✕'
        )
      );
    }
    return null;
  };

  return _react2.default.createElement(
    'ul',
    { className: 'filter-by-boundary filter-list' },
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(_FilterButton2.default, {
        label: 'Citywide',
        id: 'citywide',
        isActive: geo === 'citywide',
        handleClick: filterByAreaType,
        preventRetrigger: true
      })
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(_FilterButton2.default, {
        label: 'Borough',
        id: 'borough',
        isActive: geo === 'borough',
        handleClick: filterByAreaType,
        preventRetrigger: true
      }),
      showIdentifier('borough')
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(_FilterButton2.default, {
        label: 'Community Board',
        id: 'community_board',
        isActive: geo === 'community_board',
        handleClick: filterByAreaType,
        preventRetrigger: true
      }),
      showIdentifier('community_board')
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(_FilterButton2.default, {
        label: 'City Council District',
        id: 'city_council',
        isActive: geo === 'city_council',
        handleClick: filterByAreaType,
        preventRetrigger: true
      }),
      showIdentifier('city_council')
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(_FilterButton2.default, {
        label: 'Neighborhood (NTA)',
        id: 'neighborhood',
        isActive: geo === 'neighborhood',
        handleClick: filterByAreaType,
        preventRetrigger: true
      }),
      showIdentifier('neighborhood')
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(_FilterButton2.default, {
        label: 'NYPD Precinct',
        id: 'nypd_precinct',
        isActive: geo === 'nypd_precinct',
        handleClick: filterByAreaType,
        preventRetrigger: true
      }),
      showIdentifier('nypd_precinct')
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(_FilterButton2.default, {
        label: 'Assembly District',
        id: 'assembly',
        isActive: geo === 'assembly',
        handleClick: filterByAreaType,
        preventRetrigger: true
      }),
      showIdentifier('assembly')
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(_FilterButton2.default, {
        label: 'Senate District',
        id: 'senate',
        isActive: geo === 'senate',
        handleClick: filterByAreaType,
        preventRetrigger: true
      }),
      showIdentifier('senate')
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(_FilterButton2.default, {
        label: 'Intersection',
        id: 'intersection',
        isActive: geo === 'intersection',
        handleClick: filterByAreaType,
        preventRetrigger: true
      }),
      showIdentifier('intersection')
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(_FilterButton2.default, {
        label: 'Custom',
        id: 'custom',
        isActive: geo === 'custom',
        handleClick: filterByAreaType,
        preventRetrigger: true
      }),
      geo === 'custom' && !drawEnabeled ? _react2.default.createElement(
        'button',
        { className: 'draw-again', onClick: function onClick() {
            return toggleCustomAreaDraw();
          } },
        'Draw Again'
      ) : null,
      geo === 'custom' && drawEnabeled ? _react2.default.createElement(
        'button',
        { className: 'cancel-drawing', onClick: function onClick() {
            return toggleCustomAreaDraw();
          } },
        'Cancel Draw'
      ) : null
    )
  );
};

FilterByBoundary.defaultProps = {
  identifier: '',
  lngLats: []
};

FilterByBoundary.propTypes = {
  filterByAreaType: _react.PropTypes.func.isRequired,
  filterByAreaIdentifier: _react.PropTypes.func.isRequired,
  toggleCustomAreaDraw: _react.PropTypes.func.isRequired,
  drawEnabeled: _react.PropTypes.bool.isRequired,
  geo: _react.PropTypes.string.isRequired,
  identifier: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
};

exports.default = FilterByBoundary;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterByAreaMessage = function FilterByAreaMessage(props) {
  var geo = props.geo;

  // the stock message... or maybe not

  var message = 'Choose a boundary type, then click an area on the map to filter crashes within that area.';

  switch (geo) {
    case 'custom':
      message = 'Draw a custom area on the map.';
      break;
    case 'intersection':
      message = 'The 500 most dangerous intersections over last 2 years. Zoom in to see 90-foot radius for each.';
      break;
    default:
      break;
  }

  return _react2.default.createElement(
    'p',
    { className: 'filter-by-boundary-message' },
    message
  );
};

FilterByAreaMessage.defaultProps = {};

FilterByAreaMessage.propTypes = {
  geo: _react.PropTypes.string.isRequired
};

exports.default = FilterByAreaMessage;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactMomentProptypes = __webpack_require__(46);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _api = __webpack_require__(54);

var _MonthYearSelector = __webpack_require__(445);

var _MonthYearSelector2 = _interopRequireDefault(_MonthYearSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilterByDate = function (_Component) {
  _inherits(FilterByDate, _Component);

  function FilterByDate() {
    _classCallCheck(this, FilterByDate);

    var _this = _possibleConstructorReturn(this, (FilterByDate.__proto__ || Object.getPrototypeOf(FilterByDate)).call(this));

    _this.handleStartDateChange = _this.handleStartDateChange.bind(_this);
    _this.handleEndDateChange = _this.handleEndDateChange.bind(_this);
    return _this;
  }

  _createClass(FilterByDate, [{
    key: 'handleStartDateChange',
    value: function handleStartDateChange(year, month) {
      // validates the new start date before updating the redux store & selecting new data
      var _props = this.props,
          endDate = _props.endDate,
          minDate = _props.crashesDateRange.minDate;

      // don't allow a user to select a month before the begining of the dataset

      if (year === minDate.year() && month < minDate.month() + 1) {
        month = minDate.month() + 1;
      }

      var mm = month < 10 ? '0' + month : month;
      var startMoment = (0, _api.momentize)(year + '-' + mm);

      if (startMoment.isSameOrBefore(endDate)) {
        this.props.startDateChange(startMoment);
      } else {
        // if the user attempts to select a startDate greater than the current endDate
        // set the new startDate to the current endDate
        this.props.startDateChange(endDate);
      }
    }
  }, {
    key: 'handleEndDateChange',
    value: function handleEndDateChange(year, month) {
      // validates the new end date before updating the redux store & selecting new data
      var _props2 = this.props,
          startDate = _props2.startDate,
          maxDate = _props2.crashesDateRange.maxDate;

      // don't allow a user to select a month after the end of the dataset

      if (year === maxDate.year() && month > maxDate.month() + 1) {
        month = maxDate.month() + 1;
      }

      var mm = month < 10 ? '0' + month : month;
      var endMoment = (0, _api.momentize)(year + '-' + mm);

      if (endMoment.isSameOrAfter(startDate)) {
        this.props.endDateChange(endMoment);
      } else {
        // if the user attempts to select an endDate earlier than the current startDate
        // set the new endDate to the current startDate
        this.props.endDateChange(startDate);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          crashesDateRange = _props3.crashesDateRange,
          startDate = _props3.startDate,
          endDate = _props3.endDate,
          years = _props3.years;
      // months in moment.js are zero based

      var startMonth = startDate.month() + 1;
      var startYear = startDate.year();
      var endMonth = endDate.month() + 1;
      var endYear = endDate.year();

      return _react2.default.createElement(
        'div',
        { className: 'filter-by-date' },
        _react2.default.createElement(
          'p',
          { className: 'filter-by-date-message filter-by-date-alert' },
          'Attention: Data for May 2026 and later are known to be incomplete. NYC OpenData is working on it.'
        ),
        _react2.default.createElement(
          'ul',
          { className: 'filter-list' },
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_MonthYearSelector2.default, {
              handleChange: this.handleStartDateChange,
              years: years,
              curMonth: startMonth,
              curYear: startYear,
              prefix: 'Start',
              crashesDateRange: crashesDateRange
            })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_MonthYearSelector2.default, {
              handleChange: this.handleEndDateChange,
              years: years,
              curMonth: endMonth,
              curYear: endYear,
              prefix: 'End',
              crashesDateRange: crashesDateRange
            })
          )
        )
      );
    }
  }]);

  return FilterByDate;
}(_react.Component);

// react-datepicker requires dates to be moment objects


FilterByDate.propTypes = {
  crashesDateRange: _react.PropTypes.shape({
    minDate: _reactMomentProptypes2.default.momentObj,
    maxDate: _reactMomentProptypes2.default.momentObj
  }).isRequired,
  startDateChange: _react.PropTypes.func.isRequired,
  endDateChange: _react.PropTypes.func.isRequired,
  startDate: _reactMomentProptypes2.default.momentObj.isRequired,
  endDate: _reactMomentProptypes2.default.momentObj.isRequired,
  years: _react.PropTypes.arrayOf(_react.PropTypes.number).isRequired
};

exports.default = FilterByDate;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _FilterButton = __webpack_require__(67);

var _FilterButton2 = _interopRequireDefault(_FilterButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilterByType = function (_Component) {
  _inherits(FilterByType, _Component);

  function FilterByType() {
    _classCallCheck(this, FilterByType);

    return _possibleConstructorReturn(this, (FilterByType.__proto__ || Object.getPrototypeOf(FilterByType)).apply(this, arguments));
  }

  _createClass(FilterByType, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          filterByTypeFatality = _props.filterByTypeFatality,
          filterByTypeInjury = _props.filterByTypeInjury,
          filterByNoInjFat = _props.filterByNoInjFat,
          injury = _props.injury,
          fatality = _props.fatality,
          noInjuryFatality = _props.noInjuryFatality;


      return _react2.default.createElement(
        'div',
        { className: 'filter-by-type' },
        _react2.default.createElement(
          'ul',
          { className: 'filter-list' },
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'cyclist fatality',
              id: 'cyclist',
              handleClick: filterByTypeFatality,
              btnSize: 'med',
              isActive: fatality.cyclist
            })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'motorist fatality',
              id: 'motorist',
              handleClick: filterByTypeFatality,
              btnSize: 'med',
              isActive: fatality.motorist
            })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'pedestrian fatality',
              id: 'pedestrian',
              handleClick: filterByTypeFatality,
              btnSize: 'med',
              isActive: fatality.pedestrian
            })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'No Injury / Fatality',
              id: '',
              handleClick: filterByNoInjFat,
              btnSize: 'med',
              isActive: noInjuryFatality
            })
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: 'filter-list' },
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'cyclist injury',
              id: 'cyclist',
              handleClick: filterByTypeInjury,
              btnSize: 'med',
              isActive: injury.cyclist
            })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'motorist injury',
              id: 'motorist',
              handleClick: filterByTypeInjury,
              btnSize: 'med',
              isActive: injury.motorist
            })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'pedestrian injury',
              id: 'pedestrian',
              handleClick: filterByTypeInjury,
              btnSize: 'med',
              isActive: injury.pedestrian
            })
          )
        )
      );
    }
  }]);

  return FilterByType;
}(_react.Component);

FilterByType.propTypes = {
  filterByTypeInjury: _react.PropTypes.func.isRequired,
  filterByTypeFatality: _react.PropTypes.func.isRequired,
  filterByNoInjFat: _react.PropTypes.func.isRequired,
  fatality: _react.PropTypes.shape({
    cyclist: _react.PropTypes.bool.isRequired,
    motorist: _react.PropTypes.bool.isRequired,
    pedestrian: _react.PropTypes.bool.isRequired
  }).isRequired,
  injury: _react.PropTypes.shape({
    cyclist: _react.PropTypes.bool.isRequired,
    motorist: _react.PropTypes.bool.isRequired,
    pedestrian: _react.PropTypes.bool.isRequired
  }).isRequired,
  noInjuryFatality: _react.PropTypes.bool.isRequired
};

exports.default = FilterByType;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _FilterButton = __webpack_require__(67);

var _FilterButton2 = _interopRequireDefault(_FilterButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilterByVehicle = function (_Component) {
  _inherits(FilterByVehicle, _Component);

  function FilterByVehicle() {
    _classCallCheck(this, FilterByVehicle);

    return _possibleConstructorReturn(this, (FilterByVehicle.__proto__ || Object.getPrototypeOf(FilterByVehicle)).apply(this, arguments));
  }

  _createClass(FilterByVehicle, [{
    key: 'render',
    value: function render() {
      var vehicle = this.props.vehicle;
      var _props = this.props,
          filterByVehicleCar = _props.filterByVehicleCar,
          filterByVehicleTruck = _props.filterByVehicleTruck,
          filterByVehicleMotorcycle = _props.filterByVehicleMotorcycle,
          filterByVehicleBicycle = _props.filterByVehicleBicycle,
          filterByVehicleSuv = _props.filterByVehicleSuv,
          filterByVehicleBusVan = _props.filterByVehicleBusVan,
          filterByVehicleScooter = _props.filterByVehicleScooter,
          filterByVehicleOther = _props.filterByVehicleOther;


      return _react2.default.createElement(
        'div',
        { className: 'filter-by-type' },
        _react2.default.createElement(
          'ul',
          { className: 'filter-list' },
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'Car',
              id: 'car',
              handleClick: filterByVehicleCar,
              btnSize: 'med',
              isActive: vehicle.car
            })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'Truck',
              id: 'truck',
              handleClick: filterByVehicleTruck,
              btnSize: 'med',
              isActive: vehicle.truck
            })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'Motorcycle/Moped',
              id: 'motorcycle',
              handleClick: filterByVehicleMotorcycle,
              btnSize: 'med',
              isActive: vehicle.motorcycle
            })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'Bicycle',
              id: 'bicycle',
              handleClick: filterByVehicleBicycle,
              btnSize: 'med',
              isActive: vehicle.bicycle
            })
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: 'filter-list' },
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'SUV',
              id: 'cyclist',
              handleClick: filterByVehicleSuv,
              btnSize: 'med',
              isActive: vehicle.suv
            })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'Bus-Van',
              id: 'motorist',
              handleClick: filterByVehicleBusVan,
              btnSize: 'med',
              isActive: vehicle.busvan
            })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'E-Bike-Scoot',
              id: 'pedestrian',
              handleClick: filterByVehicleScooter,
              btnSize: 'med',
              isActive: vehicle.scooter
            })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_FilterButton2.default, {
              label: 'Other / Unspecified',
              id: 'pedestrian',
              handleClick: filterByVehicleOther,
              btnSize: 'med',
              isActive: vehicle.other
            })
          )
        )
      );
    }
  }]);

  return FilterByVehicle;
}(_react.Component);

FilterByVehicle.propTypes = {
  filterByVehicleCar: _react.PropTypes.func.isRequired,
  filterByVehicleTruck: _react.PropTypes.func.isRequired,
  filterByVehicleMotorcycle: _react.PropTypes.func.isRequired,
  filterByVehicleBicycle: _react.PropTypes.func.isRequired,
  filterByVehicleSuv: _react.PropTypes.func.isRequired,
  filterByVehicleBusVan: _react.PropTypes.func.isRequired,
  filterByVehicleScooter: _react.PropTypes.func.isRequired,
  filterByVehicleOther: _react.PropTypes.func.isRequired,
  vehicle: _react.PropTypes.shape({
    car: _react.PropTypes.bool.isRequired,
    truck: _react.PropTypes.bool.isRequired,
    motorcycle: _react.PropTypes.bool.isRequired,
    bicycle: _react.PropTypes.bool.isRequired,
    suv: _react.PropTypes.bool.isRequired,
    busvan: _react.PropTypes.bool.isRequired,
    scooter: _react.PropTypes.bool.isRequired,
    other: _react.PropTypes.bool.isRequired
  }).isRequired
};

exports.default = FilterByVehicle;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _FilterButton = __webpack_require__(67);

var _FilterButton2 = _interopRequireDefault(_FilterButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterOptions = function FooterOptions(props) {
  var openModal = props.openModal;


  return _react2.default.createElement(
    'div',
    { className: 'options-filters-footer' },
    _react2.default.createElement(_FilterButton2.default, {
      label: 'Disclaimer',
      id: 'disclaimer',
      handleClick: openModal,
      btnSize: 'link'
    }),
    _react2.default.createElement(_FilterButton2.default, {
      label: 'About',
      id: 'about',
      handleClick: openModal,
      btnSize: 'link'
    }),
    _react2.default.createElement(_FilterButton2.default, {
      label: 'Copyright',
      id: 'copyright',
      handleClick: openModal,
      btnSize: 'link'
    })
  );
};

FooterOptions.propTypes = {
  openModal: _react.PropTypes.func.isRequired
};

exports.default = FooterOptions;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactMomentProptypes = __webpack_require__(46);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _reactSelect = __webpack_require__(84);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MonthYearSelector = function MonthYearSelector(props) {
  var crashesDateRange = props.crashesDateRange,
      handleChange = props.handleChange,
      years = props.years,
      curYear = props.curYear,
      curMonth = props.curMonth,
      prefix = props.prefix;
  var minDate = crashesDateRange.minDate,
      maxDate = crashesDateRange.maxDate;

  // years are the distinct year values in the dataset

  var yearOptions = years.map(function (year) {
    return {
      value: year,
      label: year
    };
  });

  var monthOptions = _moment2.default.months().map(function (month, i) {
    return {
      value: i + 1,
      label: month
    };
  });

  // minDate and maxDate are loaded async
  if (_moment2.default.isMoment(minDate) && _moment2.default.isMoment(maxDate)) {
    return _react2.default.createElement(
      'div',
      { className: 'month-year-selector' },
      _react2.default.createElement(
        'div',
        { className: 'label-select-group' },
        _react2.default.createElement(
          'label',
          { htmlFor: 'filter-by-year-month' },
          prefix + ' Year'
        ),
        _react2.default.createElement(_reactSelect2.default, {
          className: 'year-selector',
          name: 'filter-by-year-month',
          options: yearOptions,
          onChange: function onChange(y) {
            return handleChange(y.value, curMonth);
          },
          matchPos: 'start',
          clearable: false,
          value: curYear
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'label-select-group' },
        _react2.default.createElement(
          'label',
          { htmlFor: 'filter-by-year-month' },
          prefix + ' Month'
        ),
        _react2.default.createElement(_reactSelect2.default, {
          className: 'month-selector',
          name: 'filter-by-year-month',
          options: monthOptions,
          onChange: function onChange(m) {
            return handleChange(curYear, m.value);
          },
          matchPos: 'start',
          ignoreCase: true,
          clearable: false,
          value: curMonth
        })
      )
    );
  }

  return null;
};

MonthYearSelector.propTypes = {
  crashesDateRange: _react.PropTypes.shape({
    min: _reactMomentProptypes2.default.momentObj,
    max: _reactMomentProptypes2.default.momentObj
  }).isRequired,
  handleChange: _react.PropTypes.func.isRequired,
  years: _react.PropTypes.arrayOf(_react.PropTypes.number).isRequired,
  curYear: _react.PropTypes.number.isRequired,
  curMonth: _react.PropTypes.number.isRequired,
  prefix: _react.PropTypes.string.isRequired
};

exports.default = MonthYearSelector;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactCollapse = __webpack_require__(194);

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

var _classnames = __webpack_require__(55);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionsContainer = function (_Component) {
  _inherits(OptionsContainer, _Component);

  function OptionsContainer(props) {
    _classCallCheck(this, OptionsContainer);

    var _this = _possibleConstructorReturn(this, (OptionsContainer.__proto__ || Object.getPrototypeOf(OptionsContainer)).call(this, props));

    _this.state = {
      opened: props.isOpened
    };
    _this.handleOpenClose = _this.handleOpenClose.bind(_this);
    return _this;
  }

  _createClass(OptionsContainer, [{
    key: 'handleOpenClose',
    value: function handleOpenClose() {
      if (this.props.collapsable) {
        this.setState(function (prevState) {
          return { opened: !prevState.opened };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          collapsable = _props.collapsable,
          collapseHeight = _props.collapseHeight,
          optionsContainerHeight = _props.optionsContainerHeight,
          ruledLine = _props.ruledLine,
          scroll = _props.scroll,
          title = _props.title,
          className = _props.className;
      var opened = this.state.opened;

      var fixedHeight = collapseHeight > 0 ? collapseHeight : undefined;
      var optionsContainerCX = (0, _classnames2.default)(className, {
        'options-container': true,
        collapsable: collapsable,
        opened: opened
      });
      var collapseCX = (0, _classnames2.default)({
        'options-container-collapsable': true,
        scroll: scroll
      });

      return _react2.default.createElement(
        'section',
        { className: optionsContainerCX, style: { height: optionsContainerHeight } },
        _react2.default.createElement(
          'div',
          { className: 'options-container-header', onClick: function onClick() {
              return _this2.handleOpenClose();
            } },
          _react2.default.createElement(
            'h6',
            { className: 'options-container-title' },
            title
          ),
          collapsable && _react2.default.createElement(
            'span',
            { className: 'options-container-collapse-icon' },
            opened ? '–' : '+'
          ),
          ruledLine ? _react2.default.createElement('hr', null) : null
        ),
        _react2.default.createElement(
          _reactCollapse2.default,
          {
            className: collapseCX,
            isOpened: opened,
            fixedHeight: fixedHeight
          },
          children
        )
      );
    }
  }]);

  return OptionsContainer;
}(_react.Component);

OptionsContainer.defaultProps = {
  className: '',
  collapsable: true,
  collapseHeight: 0,
  isOpened: true,
  optionsContainerHeight: null,
  ruledLine: false,
  scroll: false
};

OptionsContainer.propTypes = {
  children: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.array]).isRequired,
  className: _react.PropTypes.string, // additional classname(s) to tack on to section el
  collapsable: _react.PropTypes.bool, // should the content be collapsable?
  collapseHeight: _react.PropTypes.number, // should the collapsable content have a fixed height?
  isOpened: _react.PropTypes.bool,
  optionsContainerHeight: _react.PropTypes.number, // height for the options container
  ruledLine: _react.PropTypes.bool, // add a ruled line under the header?
  scroll: _react.PropTypes.bool, // should the content in Collapse be scrollable?
  title: _react.PropTypes.string.isRequired };

exports.default = OptionsContainer;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _FilterButton = __webpack_require__(67);

var _FilterButton2 = _interopRequireDefault(_FilterButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareOptions = function ShareOptions(props) {
  var openModal = props.openModal;


  return _react2.default.createElement(
    'div',
    { className: 'share-options' },
    _react2.default.createElement(_FilterButton2.default, {
      label: 'URL',
      id: 'share-url',
      handleClick: openModal,
      btnSize: 'auto'
    }),
    _react2.default.createElement(_FilterButton2.default, {
      label: 'Facebook',
      id: 'share-fb',
      handleClick: openModal,
      btnSize: 'auto'
    }),
    _react2.default.createElement(_FilterButton2.default, {
      label: 'Twitter',
      id: 'share-tw',
      handleClick: openModal,
      btnSize: 'auto'
    })
  );
};

ShareOptions.propTypes = {
  openModal: _react.PropTypes.func.isRequired
};

exports.default = ShareOptions;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _OptionsContainer = __webpack_require__(446);

var _OptionsContainer2 = _interopRequireDefault(_OptionsContainer);

var _FilterByAreaConnected = __webpack_require__(457);

var _FilterByAreaConnected2 = _interopRequireDefault(_FilterByAreaConnected);

var _FilterByAreaMessage = __webpack_require__(440);

var _FilterByAreaMessage2 = _interopRequireDefault(_FilterByAreaMessage);

var _FilterByTypeConnected = __webpack_require__(459);

var _FilterByTypeConnected2 = _interopRequireDefault(_FilterByTypeConnected);

var _FilterByVehicleConnected = __webpack_require__(460);

var _FilterByVehicleConnected2 = _interopRequireDefault(_FilterByVehicleConnected);

var _FilterByDateConnected = __webpack_require__(458);

var _FilterByDateConnected2 = _interopRequireDefault(_FilterByDateConnected);

var _DownloadData = __webpack_require__(438);

var _DownloadData2 = _interopRequireDefault(_DownloadData);

var _ShareOptions = __webpack_require__(447);

var _ShareOptions2 = _interopRequireDefault(_ShareOptions);

var _FooterOptions = __webpack_require__(444);

var _FooterOptions2 = _interopRequireDefault(_FooterOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionsFilters = function (_Component) {
  _inherits(OptionsFilters, _Component);

  function OptionsFilters() {
    _classCallCheck(this, OptionsFilters);

    return _possibleConstructorReturn(this, (OptionsFilters.__proto__ || Object.getPrototypeOf(OptionsFilters)).apply(this, arguments));
  }

  _createClass(OptionsFilters, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          height = _props.height,
          maxDate = _props.maxDate,
          openModal = _props.openModal,
          geo = _props.geo;


      return _react2.default.createElement(
        'div',
        { className: 'ui right app-options-filters' },
        _react2.default.createElement(
          _OptionsContainer2.default,
          {
            title: 'MAP OPTIONS',
            collapseHeight: height - 120 - 45,
            className: 'no-padding-bottom',
            ruledLine: true,
            scroll: true
          },
          _react2.default.createElement(
            _OptionsContainer2.default,
            { title: 'Filter by Date Range' },
            _react2.default.createElement(_FilterByDateConnected2.default, null)
          ),
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            _OptionsContainer2.default,
            { title: 'Filter by Boundary' },
            _react2.default.createElement(_FilterByAreaMessage2.default, { geo: geo }),
            _react2.default.createElement(_FilterByAreaConnected2.default, null)
          ),
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            _OptionsContainer2.default,
            { title: 'Filter by Crash Type' },
            _react2.default.createElement(_FilterByTypeConnected2.default, null)
          ),
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            _OptionsContainer2.default,
            { title: 'Filter by Vehicle Type Involved' },
            _react2.default.createElement(_FilterByVehicleConnected2.default, null)
          ),
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            _OptionsContainer2.default,
            { title: 'Data', isOpened: false },
            _react2.default.createElement(_DownloadData2.default, {
              openModal: openModal,
              lastUpdated: maxDate
            })
          )
        ),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(
          _OptionsContainer2.default,
          {
            title: 'Share',
            className: 'no-padding-bottom',
            collapsable: false,
            optionsContainerHeight: 93
          },
          _react2.default.createElement(_ShareOptions2.default, { openModal: openModal })
        ),
        _react2.default.createElement(_FooterOptions2.default, { openModal: openModal })
      );
    }
  }]);

  return OptionsFilters;
}(_react.Component);

OptionsFilters.defaultProps = {
  maxDate: '',
  height: 120
};

OptionsFilters.propTypes = {
  maxDate: _react.PropTypes.string,
  openModal: _react.PropTypes.func.isRequired,
  height: _react.PropTypes.number,
  geo: _react.PropTypes.string.isRequired
};

exports.default = OptionsFilters;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _AboutCopy = __webpack_require__(200);

var _AboutCopy2 = _interopRequireDefault(_AboutCopy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmallDeviceMessage = function SmallDeviceMessage() {
  return _react2.default.createElement(
    'div',
    { className: 'small-device-message' },
    _react2.default.createElement(
      'div',
      { className: 'centered' },
      _react2.default.createElement(
        'h1',
        { className: 'title' },
        'NYC CRASH MAPPER'
      ),
      _react2.default.createElement(
        'h2',
        { style: { marginTop: 10 } },
        'Mobile version under development. Please come back on your laptop!'
      ),
      _react2.default.createElement(_AboutCopy2.default, null)
    )
  );
};

exports.default = SmallDeviceMessage;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContributingFactorsList = function ContributingFactorsList(props) {
  var factors = props.factors;


  var factorsList = function factorsList() {
    return factors.map(function (f) {
      var factor = f.factor,
          count_factor = f.count_factor;


      return _react2.default.createElement(
        "li",
        { key: factor },
        _react2.default.createElement(
          "p",
          { className: "factor-count" },
          count_factor.toLocaleString()
        ),
        _react2.default.createElement(
          "p",
          { className: "factor-type" },
          factor !== '' ? factor.replace(/\//g, ' / ') : 'None Recorded'
        )
      );
    });
  };

  return _react2.default.createElement(
    "div",
    { className: "contributing-factors-list scroll" },
    _react2.default.createElement(
      "ul",
      null,
      factorsList()
    )
  );
};

ContributingFactorsList.defaultProps = {
  factors: []
};

ContributingFactorsList.propTypes = {
  factors: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    count_factor: _react.PropTypes.number,
    factor: _react.PropTypes.string
  }))
};

exports.default = ContributingFactorsList;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateRange = function DateRange(props) {
  var startDate = props.startDate,
      endDate = props.endDate;


  return _react2.default.createElement(
    "div",
    { className: "stats-date-range" },
    _react2.default.createElement(
      "h6",
      { className: "stats-title" },
      "From " + startDate + " \u2013 " + endDate
    )
  );
};

DateRange.propTypes = {
  startDate: _react.PropTypes.string.isRequired,
  endDate: _react.PropTypes.string.isRequired
};

exports.default = DateRange;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    "div",
    { className: "legend-container" },
    _react2.default.createElement(
      "div",
      { className: "legend-crash-types" },
      _react2.default.createElement(
        "ul",
        null,
        _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement("span", { className: "type-fatality" }),
          _react2.default.createElement(
            "p",
            null,
            "Fatality"
          )
        ),
        _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement("span", { className: "type-injury" }),
          _react2.default.createElement(
            "p",
            null,
            "Injury"
          )
        ),
        _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement("span", { className: "type-no-inj-fat" }),
          _react2.default.createElement(
            "p",
            null,
            "None"
          )
        )
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "legend-crash-count" },
      _react2.default.createElement(
        "svg",
        null,
        _react2.default.createElement(
          "g",
          { transform: "translate(20, 0)" },
          _react2.default.createElement(
            "g",
            { className: "legendCells" },
            _react2.default.createElement(
              "g",
              { className: "cell", transform: "translate(0, 25)" },
              _react2.default.createElement(
                "circle",
                { className: "swatch", r: "12.5", style: { r: '12.5px' } },
                _react2.default.createElement(
                  "title",
                  null,
                  "8 or more crashes"
                )
              ),
              _react2.default.createElement(
                "text",
                { className: "label", transform: "translate(15.5,5)" },
                '> 8'
              )
            ),
            _react2.default.createElement(
              "g",
              { className: "cell", transform: "translate(0, 54.33333396911621)" },
              _react2.default.createElement(
                "circle",
                { className: "swatch", r: "9.666666666666666", style: { r: '9.66667px' } },
                _react2.default.createElement(
                  "title",
                  null,
                  "5 or fewer crashes"
                )
              ),
              _react2.default.createElement(
                "text",
                { className: "label", transform: "translate(24.5,5)" },
                "5"
              )
            ),
            _react2.default.createElement(
              "g",
              { className: "cell", transform: "translate(0, 78.00000095367432)" },
              _react2.default.createElement(
                "circle",
                { className: "swatch", r: "6.833333333333333", style: { r: '6.83333px' } },
                _react2.default.createElement(
                  "title",
                  null,
                  "3 or fewer crashes"
                )
              ),
              _react2.default.createElement(
                "text",
                { className: "label", transform: "translate(24.5,5)" },
                "3"
              )
            ),
            _react2.default.createElement(
              "g",
              { className: "cell", transform: "translate(0, 96.00000095367432)" },
              _react2.default.createElement(
                "circle",
                { className: "swatch", r: "4", style: { r: '4px' } },
                _react2.default.createElement(
                  "title",
                  null,
                  "2 or fewer crashes"
                )
              ),
              _react2.default.createElement(
                "text",
                { className: "label", transform: "translate(13.5,5)" },
                '<=2'
              )
            )
          )
        )
      )
    )
  );
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatsCounter = function StatsCounter(props) {
  var cyclist = props.cyclist,
      ped = props.ped,
      driver = props.driver,
      other = props.other,
      total = props.total,
      title = props.title;


  return _react2.default.createElement(
    "div",
    { className: "stats-counter" },
    _react2.default.createElement(
      "h6",
      { className: "stats-title" },
      title
    ),
    _react2.default.createElement(
      "div",
      { className: "count" },
      _react2.default.createElement(
        "p",
        null,
        cyclist.toLocaleString()
      ),
      _react2.default.createElement(
        "p",
        null,
        "Cyclist"
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "count" },
      _react2.default.createElement(
        "p",
        null,
        ped.toLocaleString()
      ),
      _react2.default.createElement(
        "p",
        null,
        "Ped"
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "count" },
      _react2.default.createElement(
        "p",
        null,
        driver.toLocaleString()
      ),
      _react2.default.createElement(
        "p",
        null,
        "Motorist"
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "count" },
      _react2.default.createElement(
        "p",
        null,
        other.toLocaleString()
      ),
      _react2.default.createElement(
        "p",
        null,
        "Unknown"
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "count" },
      _react2.default.createElement(
        "p",
        { className: "roboto-bold" },
        total.toLocaleString()
      ),
      _react2.default.createElement(
        "p",
        { className: "roboto-bold" },
        "Total"
      )
    )
  );
};

StatsCounter.defaultProps = {
  cyclist: 0,
  driver: 0,
  ped: 0,
  other: 0,
  total: 0,
  title: ''
};

StatsCounter.propTypes = {
  cyclist: _react.PropTypes.number,
  driver: _react.PropTypes.number,
  ped: _react.PropTypes.number,
  other: _react.PropTypes.number,
  total: _react.PropTypes.number,
  title: _react.PropTypes.string
};

exports.default = StatsCounter;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TotalCrashCounter = function TotalCrashCounter(props) {
  var totalCount = props.totalCount;

  var crash = totalCount > 1 || totalCount === 0 ? 'Crashes' : 'Crash';

  return _react2.default.createElement(
    'div',
    { className: 'stats-total-crash-counter' },
    _react2.default.createElement(
      'h6',
      { className: 'stats-title' },
      totalCount.toLocaleString() + ' Total ' + crash
    )
  );
};

TotalCrashCounter.defaultProps = {
  totalCount: 0
};

TotalCrashCounter.propTypes = {
  totalCount: _react.PropTypes.number.isRequired
};

exports.default = TotalCrashCounter;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactMomentProptypes = __webpack_require__(46);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _api = __webpack_require__(54);

var _DateRange = __webpack_require__(451);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _TotalCrashCounter = __webpack_require__(454);

var _TotalCrashCounter2 = _interopRequireDefault(_TotalCrashCounter);

var _StatsCounter = __webpack_require__(453);

var _StatsCounter2 = _interopRequireDefault(_StatsCounter);

var _ContributingFactorsList = __webpack_require__(450);

var _ContributingFactorsList2 = _interopRequireDefault(_ContributingFactorsList);

var _LegendContainer = __webpack_require__(452);

var _LegendContainer2 = _interopRequireDefault(_LegendContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StatsLegend = function (_Component) {
  _inherits(StatsLegend, _Component);

  function StatsLegend() {
    _classCallCheck(this, StatsLegend);

    return _possibleConstructorReturn(this, (StatsLegend.__proto__ || Object.getPrototypeOf(StatsLegend)).apply(this, arguments));
  }

  _createClass(StatsLegend, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          startDate = _props.startDate,
          endDate = _props.endDate,
          contributingFactors = _props.contributingFactors,
          cyclist_injured = _props.cyclist_injured,
          cyclist_killed = _props.cyclist_killed,
          motorist_injured = _props.motorist_injured,
          motorist_killed = _props.motorist_killed,
          pedestrian_injured = _props.pedestrian_injured,
          pedestrian_killed = _props.pedestrian_killed,
          other_injured = _props.other_injured,
          other_killed = _props.other_killed,
          persons_injured = _props.persons_injured,
          persons_killed = _props.persons_killed,
          total_crashes = _props.total_crashes;


      return _react2.default.createElement(
        'div',
        { className: 'ui bottom app-stats-legend' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row stats-header' },
            _react2.default.createElement(
              'div',
              { className: 'seven columns' },
              _react2.default.createElement(_DateRange2.default, {
                startDate: startDate.format(_api.dateStringFormatView),
                endDate: endDate.format(_api.dateStringFormatView)
              }),
              _react2.default.createElement(_TotalCrashCounter2.default, { totalCount: total_crashes })
            ),
            _react2.default.createElement(
              'div',
              { className: 'three columns' },
              _react2.default.createElement(
                'h6',
                { className: 'stats-title' },
                'Contributing Factors'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'two columns' },
              _react2.default.createElement(
                'h6',
                { className: 'stats-title', style: { marginLeft: '10px' } },
                'Legend'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row stats-content' },
            _react2.default.createElement(
              'div',
              { className: 'seven columns' },
              _react2.default.createElement(_StatsCounter2.default, {
                title: 'Fatalities',
                cyclist: cyclist_killed,
                driver: motorist_killed,
                ped: pedestrian_killed,
                other: other_killed,
                total: persons_killed
              }),
              _react2.default.createElement(_StatsCounter2.default, {
                title: 'Injuries',
                cyclist: cyclist_injured,
                driver: motorist_injured,
                ped: pedestrian_injured,
                other: other_injured,
                total: persons_injured
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'three columns' },
              _react2.default.createElement(_ContributingFactorsList2.default, { factors: contributingFactors })
            ),
            _react2.default.createElement(
              'div',
              { className: 'two columns' },
              _react2.default.createElement(_LegendContainer2.default, null)
            )
          )
        )
      );
    }
  }]);

  return StatsLegend;
}(_react.Component);

StatsLegend.defaultProps = {
  contributingFactors: [],
  cyclist_injured: 0,
  cyclist_killed: 0,
  motorist_injured: 0,
  motorist_killed: 0,
  pedestrian_injured: 0,
  pedestrian_killed: 0,
  other_injured: 0,
  other_killed: 0,
  persons_injured: 0,
  persons_killed: 0,
  total_crashes: 0,
  identifier: '',
  lngLats: []
};

StatsLegend.propTypes = {
  startDate: _reactMomentProptypes2.default.momentObj.isRequired,
  endDate: _reactMomentProptypes2.default.momentObj.isRequired,
  contributingFactors: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    count_factor: _react.PropTypes.number,
    factor: _react.PropTypes.string
  })),
  cyclist_injured: _react.PropTypes.number,
  cyclist_killed: _react.PropTypes.number,
  motorist_injured: _react.PropTypes.number,
  motorist_killed: _react.PropTypes.number,
  pedestrian_injured: _react.PropTypes.number,
  pedestrian_killed: _react.PropTypes.number,
  other_injured: _react.PropTypes.number,
  other_killed: _react.PropTypes.number,
  persons_injured: _react.PropTypes.number,
  persons_killed: _react.PropTypes.number,
  total_crashes: _react.PropTypes.number,
  filterType: _react.PropTypes.shape({
    fatality: _react.PropTypes.shape({
      cyclist: _react.PropTypes.bool.isRequired,
      motorist: _react.PropTypes.bool.isRequired,
      pedestrian: _react.PropTypes.bool.isRequired
    }).isRequired,
    injury: _react.PropTypes.shape({
      cyclist: _react.PropTypes.bool.isRequired,
      motorist: _react.PropTypes.bool.isRequired,
      pedestrian: _react.PropTypes.bool.isRequired
    }).isRequired,
    noInjuryFatality: _react.PropTypes.bool.isRequired
  }).isRequired,
  geo: _react.PropTypes.string.isRequired,
  identifier: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  lngLats: _react.PropTypes.arrayOf(_react.PropTypes.arrayOf(_react.PropTypes.number))
};

exports.default = StatsLegend;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  /* color values match those ./scss/_variables.scss */\n  @fatality: #f03b20;\n  @injury: #fd8d3c;\n  @nofatinj: #fecc5c;\n\n  #', ' {\n    marker-fill-opacity: 0.9;\n    marker-line-color: #FFFAD5;\n    marker-line-width: 0.7;\n    marker-line-opacity: 1;\n    marker-placement: point;\n    marker-type: ellipse;\n    marker-width: 8;\n    marker-fill: @nofatinj;\n    marker-allow-overlap: true;\n\n    /* sometimes the data will have pedestrain marked as injured but\n     also have persons_injured = 0 (WTF data!!!) */\n    [persons_injured > 0],\n    [cyclist_injured > 0],\n    [pedestrian_injured > 0],\n    [motorist_injured > 0] {\n      marker-fill: @injury;\n    }\n\n    /* same goes for number_of_x_killed */\n    [persons_killed > 0],\n    [cyclist_killed > 0],\n    [pedestrian_killed > 0],\n    [motorist_killed > 0] {\n      marker-fill: @fatality;\n    }\n\n    #', ' [ total_crashes > 8] {\n       marker-width: 24;\n    }\n    #', ' [ total_crashes <= 5] {\n       marker-width: 20;\n    }\n    #', ' [ total_crashes <= 3] {\n       marker-width: 16;\n    }\n    #', ' [ total_crashes <= 2] {\n       marker-width: 12;\n    }\n    #', ' [ total_crashes <= 1] {\n       marker-width: 8;\n    }\n  }\n'], ['\n  /* color values match those ./scss/_variables.scss */\n  @fatality: #f03b20;\n  @injury: #fd8d3c;\n  @nofatinj: #fecc5c;\n\n  #', ' {\n    marker-fill-opacity: 0.9;\n    marker-line-color: #FFFAD5;\n    marker-line-width: 0.7;\n    marker-line-opacity: 1;\n    marker-placement: point;\n    marker-type: ellipse;\n    marker-width: 8;\n    marker-fill: @nofatinj;\n    marker-allow-overlap: true;\n\n    /* sometimes the data will have pedestrain marked as injured but\n     also have persons_injured = 0 (WTF data!!!) */\n    [persons_injured > 0],\n    [cyclist_injured > 0],\n    [pedestrian_injured > 0],\n    [motorist_injured > 0] {\n      marker-fill: @injury;\n    }\n\n    /* same goes for number_of_x_killed */\n    [persons_killed > 0],\n    [cyclist_killed > 0],\n    [pedestrian_killed > 0],\n    [motorist_killed > 0] {\n      marker-fill: @fatality;\n    }\n\n    #', ' [ total_crashes > 8] {\n       marker-width: 24;\n    }\n    #', ' [ total_crashes <= 5] {\n       marker-width: 20;\n    }\n    #', ' [ total_crashes <= 3] {\n       marker-width: 16;\n    }\n    #', ' [ total_crashes <= 2] {\n       marker-width: 12;\n    }\n    #', ' [ total_crashes <= 1] {\n       marker-width: 8;\n    }\n  }\n']);

var _singleLineString = __webpack_require__(100);

var _singleLineString2 = _interopRequireDefault(_singleLineString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// for some reason importing this val from './app_config' isn't working...
var nyc_crashes = 'export2016_07';

var cartocss = (0, _singleLineString2.default)(_templateObject, nyc_crashes, nyc_crashes, nyc_crashes, nyc_crashes, nyc_crashes, nyc_crashes);

exports.default = cartocss;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(21);

var _actions = __webpack_require__(39);

var _FilterByArea = __webpack_require__(439);

var _FilterByArea2 = _interopRequireDefault(_FilterByArea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
  var _ref$filterArea = _ref.filterArea,
      geo = _ref$filterArea.geo,
      identifier = _ref$filterArea.identifier,
      drawEnabeled = _ref$filterArea.drawEnabeled;
  return {
    drawEnabeled: drawEnabeled,
    geo: geo,
    identifier: identifier
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  filterByAreaType: _actions.filterByAreaType,
  filterByAreaIdentifier: _actions.filterByAreaIdentifier,
  filterByAreaCustom: _actions.filterByAreaCustom,
  toggleCustomAreaDraw: _actions.toggleCustomAreaDraw
})(_FilterByArea2.default);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(21);

var _FilterByDate = __webpack_require__(441);

var _FilterByDate2 = _interopRequireDefault(_FilterByDate);

var _actions = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
  var _ref$filterDate = _ref.filterDate,
      startDate = _ref$filterDate.startDate,
      endDate = _ref$filterDate.endDate,
      yearRange = _ref.yearRange,
      crashesDateRange = _ref.crashesDateRange;
  return {
    startDate: startDate,
    endDate: endDate,
    crashesDateRange: crashesDateRange,
    years: yearRange.years || []
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  startDateChange: _actions.startDateChange,
  endDateChange: _actions.endDateChange
})(_FilterByDate2.default);

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(21);

var _actions = __webpack_require__(39);

var _FilterByType = __webpack_require__(442);

var _FilterByType2 = _interopRequireDefault(_FilterByType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
  var filterType = _ref.filterType;
  var injury = filterType.injury,
      fatality = filterType.fatality,
      noInjuryFatality = filterType.noInjuryFatality;

  return {
    injury: injury,
    fatality: fatality,
    noInjuryFatality: noInjuryFatality
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  filterByTypeFatality: _actions.filterByTypeFatality,
  filterByTypeInjury: _actions.filterByTypeInjury,
  filterByNoInjFat: _actions.filterByNoInjFat
})(_FilterByType2.default);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(21);

var _actions = __webpack_require__(39);

var _FilterByVehicle = __webpack_require__(443);

var _FilterByVehicle2 = _interopRequireDefault(_FilterByVehicle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
  var filterVehicle = _ref.filterVehicle;
  var vehicle = filterVehicle.vehicle;

  return {
    vehicle: vehicle
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  filterByVehicleCar: _actions.filterByVehicleCar,
  filterByVehicleTruck: _actions.filterByVehicleTruck,
  filterByVehicleMotorcycle: _actions.filterByVehicleMotorcycle,
  filterByVehicleBicycle: _actions.filterByVehicleBicycle,
  filterByVehicleSuv: _actions.filterByVehicleSuv,
  filterByVehicleBusVan: _actions.filterByVehicleBusVan,
  filterByVehicleScooter: _actions.filterByVehicleScooter,
  filterByVehicleOther: _actions.filterByVehicleOther
})(_FilterByVehicle2.default);

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(21);

var _actions = __webpack_require__(39);

var _LeafletMap = __webpack_require__(425);

var _LeafletMap2 = _interopRequireDefault(_LeafletMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref, ownProps) {
  var filterDate = _ref.filterDate,
      filterType = _ref.filterType,
      filterVehicle = _ref.filterVehicle,
      filterArea = _ref.filterArea;
  var startDate = filterDate.startDate,
      endDate = filterDate.endDate;
  var query = ownProps.location.query;
  var lat = query.lat,
      lng = query.lng,
      zoom = query.zoom;
  var geo = filterArea.geo,
      geojson = filterArea.geojson,
      identifier = filterArea.identifier,
      lngLats = filterArea.lngLats,
      drawEnabeled = filterArea.drawEnabeled;

  return {
    zoom: zoom ? Number(zoom) : undefined,
    lat: lat ? Number(lat) : undefined,
    lng: lng ? Number(lng) : undefined,
    startDate: startDate,
    endDate: endDate,
    filterType: filterType,
    filterVehicle: filterVehicle,
    drawEnabeled: drawEnabeled,
    geo: geo,
    geojson: geojson,
    identifier: identifier,
    lngLats: lngLats
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  filterByAreaIdentifier: _actions.filterByAreaIdentifier,
  filterByAreaCustom: _actions.filterByAreaCustom,
  fetchGeoPolygons: _actions.fetchGeoPolygons
})(_LeafletMap2.default);

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(21);

var _api = __webpack_require__(54);

var _actions = __webpack_require__(39);

var _Menu = __webpack_require__(427);

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
  var filterDate = _ref.filterDate,
      filterArea = _ref.filterArea,
      filterType = _ref.filterType,
      filterVehicle = _ref.filterVehicle;
  var startDate = filterDate.startDate,
      endDate = filterDate.endDate;
  var geo = filterArea.geo,
      identifier = filterArea.identifier,
      lngLats = filterArea.lngLats;
  var injury = filterType.injury,
      fatality = filterType.fatality;

  // these props are used to create the query params when linking to the chart view app

  return {
    p1start: startDate.format(_api.dateStringFormatModel),
    p1end: endDate.format(_api.dateStringFormatModel),
    geo: geo,
    lngLats: encodeURIComponent(JSON.stringify(lngLats)),
    primary: identifier,
    pinj: injury.pedestrian,
    pfat: fatality.pedestrian,
    cinj: injury.cyclist,
    cfat: fatality.cyclist,
    minj: injury.motorist,
    mfat: fatality.motorist,
    vcar: filterVehicle.vehicle.car,
    vtruck: filterVehicle.vehicle.truck,
    vmotorcycle: filterVehicle.vehicle.motorcycle,
    vbicycle: filterVehicle.vehicle.bicycle,
    vsuv: filterVehicle.vehicle.suv,
    vbusvan: filterVehicle.vehicle.busvan,
    vscooter: filterVehicle.vehicle.scooter,
    vother: filterVehicle.vehicle.other
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  openModal: _actions.openModal
})(_Menu2.default);

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(21);

var _actions = __webpack_require__(39);

var _Modal = __webpack_require__(437);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
  var modal = _ref.modal,
      filterType = _ref.filterType,
      filterArea = _ref.filterArea,
      filterVehicle = _ref.filterVehicle,
      filterDate = _ref.filterDate;
  var showModal = modal.showModal,
      modalType = modal.modalType;
  var startDate = filterDate.startDate,
      endDate = filterDate.endDate;

  return {
    showModal: showModal,
    modalType: modalType,
    filterArea: filterArea,
    filterType: filterType,
    filterVehicle: filterVehicle,
    startDate: startDate,
    endDate: endDate
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  closeModal: _actions.closeModal
})(_Modal2.default);

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(21);

var _actions = __webpack_require__(39);

var _OptionsFilters = __webpack_require__(448);

var _OptionsFilters2 = _interopRequireDefault(_OptionsFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
  var browser = _ref.browser,
      maxDate = _ref.crashesMaxDate.maxDate,
      filterArea = _ref.filterArea;
  var height = browser.height;
  var geo = filterArea.geo;

  return {
    geo: geo,
    height: height,
    maxDate: maxDate ? maxDate.format('MM/DD/YYYY') : ''
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  openModal: _actions.openModal
})(_OptionsFilters2.default);

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = __webpack_require__(21);

var _StatsLegend = __webpack_require__(455);

var _StatsLegend2 = _interopRequireDefault(_StatsLegend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var filterDate = state.filterDate,
      crashStats = state.crashStats,
      contributingFactors = state.contributingFactors,
      filterType = state.filterType,
      filterArea = state.filterArea;
  var startDate = filterDate.startDate,
      endDate = filterDate.endDate;
  var typeStats = crashStats.typeStats;
  var factors = contributingFactors.factors;
  var identifier = filterArea.identifier,
      geo = filterArea.geo,
      lngLats = filterArea.lngLats;

  return _extends({
    startDate: startDate,
    endDate: endDate
  }, typeStats, {
    contributingFactors: factors,
    filterType: filterType,
    identifier: identifier,
    geo: geo,
    lngLats: lngLats
  });
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(_StatsLegend2.default);

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxThunk = __webpack_require__(199);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = __webpack_require__(198);

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var middleware = [_reduxThunk2.default];

if (typeof window !== 'undefined' && "production" !== 'production') {
  // redux-logger only works in a browser environment
  middleware.push((0, _reduxLogger2.default)());
}

exports.default = middleware;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__(15);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _action_types.CRASHES_ALL_REQUEST:
      return _extends({}, state, {
        _fetchingCrashStatsTypes: true,
        typeStats: undefined
      });
    case _action_types.CRASHES_ALL_SUCCESS:
      return _extends({}, state, {
        _fetchingCrashStatsTypes: false,
        typeStats: action.json
      });
    case _action_types.CRASHES_ALL_ERROR:
      return _extends({}, state, {
        _fetchingCrashStatsTypes: false,
        error: action.error,
        typeStats: undefined
      });
    default:
      return state;
  }
};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__(15);

var _api = __webpack_require__(54);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _action_types.CRASHES_DATE_RANGE_REQUEST:
      return _extends({}, state, {
        _fetchingCrashesDateRange: true
      });

    case _action_types.CRASHES_DATE_RANGE_SUCCESS:
      return _extends({}, state, {
        _fetchingCrashesDateRange: false,
        minDate: (0, _api.momentize)(action.json[0].min),
        maxDate: (0, _api.momentize)(action.json[0].max)
      });

    case _action_types.CRASHES_DATE_RANGE_ERROR:
      return _extends({}, state, {
        _fetchingCrashesDateRange: false,
        error: action.error
      });

    default:
      return state;
  }
};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _action_types = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _action_types.CRASHES_MAX_DATE_REQUEST:
      return _extends({}, state, {
        _fetchingCrashesMaxDate: true
      });

    case _action_types.CRASHES_MAX_DATE_RESPONSE:
      return _extends({}, state, {
        _fetchingCrashesMaxDate: false,
        maxDate: (0, _moment2.default)(action.json[0].max_date, 'YYYY-MM-DDTHH:mm:ssZ', true)
      });

    case _action_types.CRASHES_MAX_DATE_ERROR:
      return _extends({}, state, {
        _fetchingCrashesMaxDate: false,
        error: action.error
      });

    default:
      return state;
  }
};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__(15);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _action_types.START_DATE_CHANGE:
      return _extends({}, state, {
        startDate: action.startDate
      });
    case _action_types.END_DATE_CHANGE:
      return _extends({}, state, {
        endDate: action.endDate
      });
    default:
      return state;
  }
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__(15);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = {
  injury: {
    cyclist: false,
    motorist: false,
    pedestrian: false
  },
  fatality: {
    cyclist: false,
    motorist: false,
    pedestrian: false
  },
  noInjuryFatality: false
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];
  var personType = action.personType;
  var injury = state.injury,
      fatality = state.fatality;


  switch (action.type) {
    case _action_types.FILTER_BY_TYPE_INJURY:
      return _extends({}, state, {
        injury: _extends({}, injury, _defineProperty({}, personType, !injury[personType])),
        noInjuryFatality: false
      });
    case _action_types.FILTER_BY_TYPE_FATALITY:
      return _extends({}, state, {
        fatality: _extends({}, fatality, _defineProperty({}, personType, !fatality[personType])),
        noInjuryFatality: false
      });
    case _action_types.FILTER_BY_NO_INJURY_FATALITY:
      return _extends({}, defaultState, {
        noInjuryFatality: !state.noInjuryFatality
      });
    default:
      return state;
  }
};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__(15);

var defaultState = {
  vehicle: {
    car: false,
    truck: false,
    motorcycle: false,
    bicycle: false,
    suv: false,
    busvan: false,
    scooter: false,
    other: false
  }
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];
  var vehicle = state.vehicle;


  switch (action.type) {
    case _action_types.FILTER_BY_VEHICLE_CAR:
      return _extends({}, state, {
        vehicle: _extends({}, vehicle, {
          car: !vehicle.car
        })
      });
    case _action_types.FILTER_BY_VEHICLE_TRUCK:
      return _extends({}, state, {
        vehicle: _extends({}, vehicle, {
          truck: !vehicle.truck
        })
      });
    case _action_types.FILTER_BY_VEHICLE_MOTORCYCLE:
      return _extends({}, state, {
        vehicle: _extends({}, vehicle, {
          motorcycle: !vehicle.motorcycle
        })
      });
    case _action_types.FILTER_BY_VEHICLE_BICYCLE:
      return _extends({}, state, {
        vehicle: _extends({}, vehicle, {
          bicycle: !vehicle.bicycle
        })
      });
    case _action_types.FILTER_BY_VEHICLE_SUV:
      return _extends({}, state, {
        vehicle: _extends({}, vehicle, {
          suv: !vehicle.suv
        })
      });
    case _action_types.FILTER_BY_VEHICLE_BUSVAN:
      return _extends({}, state, {
        vehicle: _extends({}, vehicle, {
          busvan: !vehicle.busvan
        })
      });
    case _action_types.FILTER_BY_VEHICLE_SCOOTER:
      return _extends({}, state, {
        vehicle: _extends({}, vehicle, {
          scooter: !vehicle.scooter
        })
      });
    case _action_types.FILTER_BY_VEHICLE_OTHER:
      return _extends({}, state, {
        vehicle: _extends({}, vehicle, {
          other: !vehicle.other
        })
      });
    default:
      return state;
  }
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _action_types = __webpack_require__(15);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ALL';
  var action = arguments[1];

  switch (action.type) {
    case _action_types.FILTER_BY_CONTRIBUTING_FACTOR:
      return action.factor;
    default:
      return state;
  }
};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(99);

var _reduxResponsive = __webpack_require__(85);

var _reactRouterRedux = __webpack_require__(101);

var _filter_by_date = __webpack_require__(470);

var _filter_by_date2 = _interopRequireDefault(_filter_by_date);

var _filter_by_area_reducer = __webpack_require__(201);

var _filter_by_area_reducer2 = _interopRequireDefault(_filter_by_area_reducer);

var _filter_by_type_reducer = __webpack_require__(471);

var _filter_by_type_reducer2 = _interopRequireDefault(_filter_by_type_reducer);

var _filter_by_vehicle_reducer = __webpack_require__(472);

var _filter_by_vehicle_reducer2 = _interopRequireDefault(_filter_by_vehicle_reducer);

var _filter_contributing_factor_reducer = __webpack_require__(473);

var _filter_contributing_factor_reducer2 = _interopRequireDefault(_filter_contributing_factor_reducer);

var _stats_contributing_factors_reducer = __webpack_require__(476);

var _stats_contributing_factors_reducer2 = _interopRequireDefault(_stats_contributing_factors_reducer);

var _year_range_reducer = __webpack_require__(477);

var _year_range_reducer2 = _interopRequireDefault(_year_range_reducer);

var _crashes_date_range_reducer = __webpack_require__(468);

var _crashes_date_range_reducer2 = _interopRequireDefault(_crashes_date_range_reducer);

var _crashes_max_date_reducer = __webpack_require__(469);

var _crashes_max_date_reducer2 = _interopRequireDefault(_crashes_max_date_reducer);

var _crash_stats_reducer = __webpack_require__(467);

var _crash_stats_reducer2 = _interopRequireDefault(_crash_stats_reducer);

var _modal_reducer = __webpack_require__(475);

var _modal_reducer2 = _interopRequireDefault(_modal_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// breakpoints for redux-responsive store
// taken from scss/skeleton/base/variables
var browser = (0, _reduxResponsive.createResponsiveStateReducer)({
  extraSmall: 400,
  small: 550,
  medium: 750,
  large: 1000,
  extraLarge: 1200
}, {
  extraFields: function extraFields() {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }
});

var rootReducer = (0, _redux.combineReducers)({
  browser: browser,
  contributingFactors: _stats_contributing_factors_reducer2.default,
  crashesDateRange: _crashes_date_range_reducer2.default,
  crashesMaxDate: _crashes_max_date_reducer2.default,
  crashStats: _crash_stats_reducer2.default,
  filterDate: _filter_by_date2.default,
  filterArea: _filter_by_area_reducer2.default,
  filterContributingFactor: _filter_contributing_factor_reducer2.default,
  filterType: _filter_by_type_reducer2.default,
  filterVehicle: _filter_by_vehicle_reducer2.default,
  modal: _modal_reducer2.default,
  routing: _reactRouterRedux.routerReducer,
  yearRange: _year_range_reducer2.default
});

exports.default = rootReducer;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__(15);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _action_types.MODAL_OPENED:
      return _extends({}, state, {
        modalType: action.modalType,
        showModal: true
      });

    case _action_types.MODAL_CLOSED:
      return _extends({}, state, {
        modalType: '',
        showModal: false
      });

    default:
      return state;
  }
};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__(15);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _action_types.CONTRIBUTING_FACTORS_REQUEST:
      return _extends({}, state, {
        _fetchingContributingFactors: true
      });
    case _action_types.CONTRIBUTING_FACTORS_SUCCESS:
      return _extends({}, state, {
        _fetchingContributingFactors: false,
        factors: action.json
      });
    case _action_types.CONTRIBUTING_FACTORS_ERROR:
      return _extends({}, state, {
        _fetchingContributingFactors: false,
        error: action.error
      });
    default:
      return state;
  }
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__(15);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _action_types.CRASHES_YEAR_RANGE_REQUEST:
      return _extends({}, state, {
        _fetchingCrashesYearRange: true
      });

    case _action_types.CRASHES_YEAR_RANGE_SUCCESS:
      return _extends({}, state, {
        _fetchingCrashesYearRange: false,
        years: action.json.map(function (obj) {
          return obj.year;
        })
      });

    case _action_types.CRASHES_YEAR_RANGE_ERROR:
      return _extends({}, state, {
        _fetchingCrashesYearRange: false,
        error: action.error
      });

    default:
      return state;
  }
};

/***/ }),
/* 478 */,
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(488);
module.exports = __webpack_require__(40).RegExp.escape;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9)
  , isArray  = __webpack_require__(138)
  , SPECIES  = __webpack_require__(10)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(480);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject    = __webpack_require__(4)
  , toPrimitive = __webpack_require__(36)
  , NUMBER      = 'number';

module.exports = function(hint){
  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(60)
  , gOPS    = __webpack_require__(110)
  , pIE     = __webpack_require__(88);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(60)
  , toIObject = __webpack_require__(26);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path      = __webpack_require__(486)
  , invoke    = __webpack_require__(106)
  , aFunction = __webpack_require__(22);
module.exports = function(/* ...pargs */){
  var fn     = aFunction(this)
    , length = arguments.length
    , pargs  = Array(length)
    , i      = 0
    , _      = path._
    , holder = false;
  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
  return function(/* ...args */){
    var that = this
      , aLen = arguments.length
      , j = 0, k = 0, args;
    if(!holder && !aLen)return invoke(fn, pargs, that);
    args = pargs.slice();
    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
    while(aLen > k)args.push(arguments[k++]);
    return invoke(fn, args, that);
  };
};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = function(regExp, replace){
  var replacer = replace === Object(replace) ? function(part){
    return replace[part];
  } : replace;
  return function(it){
    return String(it).replace(regExp, replacer);
  };
};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0)
  , $re     = __webpack_require__(487)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', {copyWithin: __webpack_require__(203)});

__webpack_require__(69)('copyWithin');

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $every  = __webpack_require__(34)(4);

$export($export.P + $export.F * !__webpack_require__(31)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */){
    return $every(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', {fill: __webpack_require__(130)});

__webpack_require__(69)('fill');

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $filter = __webpack_require__(34)(2);

$export($export.P + $export.F * !__webpack_require__(31)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */){
    return $filter(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0)
  , $find   = __webpack_require__(34)(6)
  , KEY     = 'findIndex'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(69)(KEY);

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0)
  , $find   = __webpack_require__(34)(5)
  , KEY     = 'find'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(69)(KEY);

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export  = __webpack_require__(0)
  , $forEach = __webpack_require__(34)(0)
  , STRICT   = __webpack_require__(31)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */){
    return $forEach(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(41)
  , $export        = __webpack_require__(0)
  , toObject       = __webpack_require__(17)
  , call           = __webpack_require__(212)
  , isArrayIter    = __webpack_require__(137)
  , toLength       = __webpack_require__(16)
  , createProperty = __webpack_require__(131)
  , getIterFn      = __webpack_require__(154);

$export($export.S + $export.F * !__webpack_require__(108)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export       = __webpack_require__(0)
  , $indexOf      = __webpack_require__(102)(false)
  , $native       = [].indexOf
  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(31)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', {isArray: __webpack_require__(138)});

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export   = __webpack_require__(0)
  , toIObject = __webpack_require__(26)
  , arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(87) != Object || !__webpack_require__(31)(arrayJoin)), 'Array', {
  join: function join(separator){
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export       = __webpack_require__(0)
  , toIObject     = __webpack_require__(26)
  , toInteger     = __webpack_require__(49)
  , toLength      = __webpack_require__(16)
  , $native       = [].lastIndexOf
  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(31)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
    // convert -0 to +0
    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
    var O      = toIObject(this)
      , length = toLength(O.length)
      , index  = length - 1;
    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
    if(index < 0)index = length + index;
    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
    return -1;
  }
});

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $map    = __webpack_require__(34)(1);

$export($export.P + $export.F * !__webpack_require__(31)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */){
    return $map(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export        = __webpack_require__(0)
  , createProperty = __webpack_require__(131);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(7)(function(){
  function F(){}
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */){
    var index  = 0
      , aLen   = arguments.length
      , result = new (typeof this == 'function' ? this : Array)(aLen);
    while(aLen > index)createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $reduce = __webpack_require__(205);

$export($export.P + $export.F * !__webpack_require__(31)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */){
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $reduce = __webpack_require__(205);

$export($export.P + $export.F * !__webpack_require__(31)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */){
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export    = __webpack_require__(0)
  , html       = __webpack_require__(135)
  , cof        = __webpack_require__(29)
  , toIndex    = __webpack_require__(63)
  , toLength   = __webpack_require__(16)
  , arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(7)(function(){
  if(html)arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end){
    var len   = toLength(this.length)
      , klass = cof(this);
    end = end === undefined ? len : end;
    if(klass == 'Array')return arraySlice.call(this, begin, end);
    var start  = toIndex(begin, len)
      , upTo   = toIndex(end, len)
      , size   = toLength(upTo - start)
      , cloned = Array(size)
      , i      = 0;
    for(; i < size; i++)cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $some   = __webpack_require__(34)(3);

$export($export.P + $export.F * !__webpack_require__(31)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */){
    return $some(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export   = __webpack_require__(0)
  , aFunction = __webpack_require__(22)
  , toObject  = __webpack_require__(17)
  , fails     = __webpack_require__(7)
  , $sort     = [].sort
  , test      = [1, 2, 3];

$export($export.P + $export.F * (fails(function(){
  // IE8-
  test.sort(undefined);
}) || !fails(function(){
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(31)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn){
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(62)('Array');

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0)
  , fails   = __webpack_require__(7)
  , getTime = Date.prototype.getTime;

var lz = function(num){
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (fails(function(){
  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
}) || !fails(function(){
  new Date(NaN).toISOString();
})), 'Date', {
  toISOString: function toISOString(){
    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
    var d = this
      , y = d.getUTCFullYear()
      , m = d.getUTCMilliseconds()
      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
  }
});

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export     = __webpack_require__(0)
  , toObject    = __webpack_require__(17)
  , toPrimitive = __webpack_require__(36);

$export($export.P + $export.F * __webpack_require__(7)(function(){
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
}), 'Date', {
  toJSON: function toJSON(key){
    var O  = toObject(this)
      , pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(10)('toPrimitive')
  , proto        = Date.prototype;

if(!(TO_PRIMITIVE in proto))__webpack_require__(23)(proto, TO_PRIMITIVE, __webpack_require__(482));

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto    = Date.prototype
  , INVALID_DATE = 'Invalid Date'
  , TO_STRING    = 'toString'
  , $toString    = DateProto[TO_STRING]
  , getTime      = DateProto.getTime;
if(new Date(NaN) + '' != INVALID_DATE){
  __webpack_require__(24)(DateProto, TO_STRING, function toString(){
    var value = getTime.call(this);
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', {bind: __webpack_require__(206)});

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject       = __webpack_require__(9)
  , getPrototypeOf = __webpack_require__(28)
  , HAS_INSTANCE   = __webpack_require__(10)('hasInstance')
  , FunctionProto  = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(13).f(FunctionProto, HAS_INSTANCE, {value: function(O){
  if(typeof this != 'function' || !isObject(O))return false;
  if(!isObject(this.prototype))return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
  return false;
}});

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(13).f
  , createDesc = __webpack_require__(48)
  , has        = __webpack_require__(19)
  , FProto     = Function.prototype
  , nameRE     = /^\s*function ([^ (]*)/
  , NAME       = 'name';

var isExtensible = Object.isExtensible || function(){
  return true;
};

// 19.2.4.2 name
NAME in FProto || __webpack_require__(12) && dP(FProto, NAME, {
  configurable: true,
  get: function(){
    try {
      var that = this
        , name = ('' + that).match(nameRE)[1];
      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
      return name;
    } catch(e){
      return '';
    }
  }
});

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0)
  , log1p   = __webpack_require__(214)
  , sqrt    = Math.sqrt
  , $acosh  = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x){
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0)
  , $asinh  = Math.asinh;

function asinh(x){
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0 
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0)
  , $atanh  = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0 
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x){
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0)
  , sign    = __webpack_require__(142);

$export($export.S, 'Math', {
  cbrt: function cbrt(x){
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x){
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x){
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0)
  , $expm1  = __webpack_require__(141);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export   = __webpack_require__(0)
  , sign      = __webpack_require__(142)
  , pow       = Math.pow
  , EPSILON   = pow(2, -52)
  , EPSILON32 = pow(2, -23)
  , MAX32     = pow(2, 127) * (2 - EPSILON32)
  , MIN32     = pow(2, -126);

var roundTiesToEven = function(n){
  return n + 1 / EPSILON - 1 / EPSILON;
};


$export($export.S, 'Math', {
  fround: function fround(x){
    var $abs  = Math.abs(x)
      , $sign = sign(x)
      , a, result;
    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs);
    if(result > MAX32 || result != result)return $sign * Infinity;
    return $sign * result;
  }
});

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0)
  , abs     = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
    var sum  = 0
      , i    = 0
      , aLen = arguments.length
      , larg = 0
      , arg, div;
    while(i < aLen){
      arg = abs(arguments[i++]);
      if(larg < arg){
        div  = larg / arg;
        sum  = sum * div * div + 1;
        larg = arg;
      } else if(arg > 0){
        div  = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0)
  , $imul   = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(7)(function(){
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y){
    var UINT16 = 0xffff
      , xn = +x
      , yn = +y
      , xl = UINT16 & xn
      , yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x){
    return Math.log(x) / Math.LN10;
  }
});

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {log1p: __webpack_require__(214)});

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x){
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {sign: __webpack_require__(142)});

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0)
  , expm1   = __webpack_require__(141)
  , exp     = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(7)(function(){
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x){
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0)
  , expm1   = __webpack_require__(141)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x){
    var a = expm1(x = +x)
      , b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it){
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global            = __webpack_require__(5)
  , has               = __webpack_require__(19)
  , cof               = __webpack_require__(29)
  , inheritIfRequired = __webpack_require__(136)
  , toPrimitive       = __webpack_require__(36)
  , fails             = __webpack_require__(7)
  , gOPN              = __webpack_require__(59).f
  , gOPD              = __webpack_require__(27).f
  , dP                = __webpack_require__(13).f
  , $trim             = __webpack_require__(73).trim
  , NUMBER            = 'Number'
  , $Number           = global[NUMBER]
  , Base              = $Number
  , proto             = $Number.prototype
  // Opera ~12 has broken Object#toString
  , BROKEN_COF        = cof(__webpack_require__(58)(proto)) == NUMBER
  , TRIM              = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function(argument){
  var it = toPrimitive(argument, false);
  if(typeof it == 'string' && it.length > 2){
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0)
      , third, radix, maxCode;
    if(first === 43 || first === 45){
      third = it.charCodeAt(2);
      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if(first === 48){
      switch(it.charCodeAt(1)){
        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default : return +it;
      }
      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if(code < 48 || code > maxCode)return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
  $Number = function Number(value){
    var it = arguments.length < 1 ? 0 : value
      , that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for(var keys = __webpack_require__(12) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++){
    if(has(Base, key = keys[j]) && !has($Number, key)){
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(24)(global, NUMBER, $Number);
}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export   = __webpack_require__(0)
  , _isFinite = __webpack_require__(5).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it){
    return typeof it == 'number' && _isFinite(it);
  }
});

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {isInteger: __webpack_require__(211)});

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number){
    return number != number;
  }
});

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export   = __webpack_require__(0)
  , isInteger = __webpack_require__(211)
  , abs       = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number){
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var $export     = __webpack_require__(0)
  , $parseFloat = __webpack_require__(221);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(0)
  , $parseInt = __webpack_require__(222);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export      = __webpack_require__(0)
  , toInteger    = __webpack_require__(49)
  , aNumberValue = __webpack_require__(202)
  , repeat       = __webpack_require__(149)
  , $toFixed     = 1..toFixed
  , floor        = Math.floor
  , data         = [0, 0, 0, 0, 0, 0]
  , ERROR        = 'Number.toFixed: incorrect invocation!'
  , ZERO         = '0';

var multiply = function(n, c){
  var i  = -1
    , c2 = c;
  while(++i < 6){
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function(n){
  var i = 6
    , c = 0;
  while(--i >= 0){
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function(){
  var i = 6
    , s = '';
  while(--i >= 0){
    if(s !== '' || i === 0 || data[i] !== 0){
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function(x, n, acc){
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function(x){
  var n  = 0
    , x2 = x;
  while(x2 >= 4096){
    n += 12;
    x2 /= 4096;
  }
  while(x2 >= 2){
    n  += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128..toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(7)(function(){
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits){
    var x = aNumberValue(this, ERROR)
      , f = toInteger(fractionDigits)
      , s = ''
      , m = ZERO
      , e, z, j, k;
    if(f < 0 || f > 20)throw RangeError(ERROR);
    if(x != x)return 'NaN';
    if(x <= -1e21 || x >= 1e21)return String(x);
    if(x < 0){
      s = '-';
      x = -x;
    }
    if(x > 1e-21){
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if(e > 0){
        multiply(0, z);
        j = f;
        while(j >= 7){
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while(j >= 23){
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if(f > 0){
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export      = __webpack_require__(0)
  , $fails       = __webpack_require__(7)
  , aNumberValue = __webpack_require__(202)
  , $toPrecision = 1..toPrecision;

$export($export.P + $export.F * ($fails(function(){
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function(){
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision){
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
  }
});

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(215)});

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(58)});

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(12), 'Object', {defineProperties: __webpack_require__(216)});

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(12), 'Object', {defineProperty: __webpack_require__(13).f});

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(9)
  , meta     = __webpack_require__(47).onFreeze;

__webpack_require__(35)('freeze', function($freeze){
  return function freeze(it){
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject                 = __webpack_require__(26)
  , $getOwnPropertyDescriptor = __webpack_require__(27).f;

__webpack_require__(35)('getOwnPropertyDescriptor', function(){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(35)('getOwnPropertyNames', function(){
  return __webpack_require__(217).f;
});

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(17)
  , $getPrototypeOf = __webpack_require__(28);

__webpack_require__(35)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(9);

__webpack_require__(35)('isExtensible', function($isExtensible){
  return function isExtensible(it){
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(9);

__webpack_require__(35)('isFrozen', function($isFrozen){
  return function isFrozen(it){
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(9);

__webpack_require__(35)('isSealed', function($isSealed){
  return function isSealed(it){
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', {is: __webpack_require__(223)});

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(17)
  , $keys    = __webpack_require__(60);

__webpack_require__(35)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(9)
  , meta     = __webpack_require__(47).onFreeze;

__webpack_require__(35)('preventExtensions', function($preventExtensions){
  return function preventExtensions(it){
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(9)
  , meta     = __webpack_require__(47).onFreeze;

__webpack_require__(35)('seal', function($seal){
  return function seal(it){
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(144).set});

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(86)
  , test    = {};
test[__webpack_require__(10)('toStringTag')] = 'z';
if(test + '' != '[object z]'){
  __webpack_require__(24)(Object.prototype, 'toString', function toString(){
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var $export     = __webpack_require__(0)
  , $parseFloat = __webpack_require__(221);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(0)
  , $parseInt = __webpack_require__(222);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__(57)
  , global             = __webpack_require__(5)
  , ctx                = __webpack_require__(41)
  , classof            = __webpack_require__(86)
  , $export            = __webpack_require__(0)
  , isObject           = __webpack_require__(9)
  , aFunction          = __webpack_require__(22)
  , anInstance         = __webpack_require__(56)
  , forOf              = __webpack_require__(70)
  , speciesConstructor = __webpack_require__(146)
  , task               = __webpack_require__(151).set
  , microtask          = __webpack_require__(143)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(10)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(61)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(72)($Promise, PROMISE);
__webpack_require__(62)(PROMISE);
Wrapper = __webpack_require__(40)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(108)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export   = __webpack_require__(0)
  , aFunction = __webpack_require__(22)
  , anObject  = __webpack_require__(4)
  , rApply    = (__webpack_require__(5).Reflect || {}).apply
  , fApply    = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(7)(function(){
  rApply(function(){});
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList){
    var T = aFunction(target)
      , L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export    = __webpack_require__(0)
  , create     = __webpack_require__(58)
  , aFunction  = __webpack_require__(22)
  , anObject   = __webpack_require__(4)
  , isObject   = __webpack_require__(9)
  , fails      = __webpack_require__(7)
  , bind       = __webpack_require__(206)
  , rConstruct = (__webpack_require__(5).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function(){
  function F(){}
  return !(rConstruct(function(){}, [], F) instanceof F);
});
var ARGS_BUG = !fails(function(){
  rConstruct(function(){});
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /*, newTarget*/){
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
    if(Target == newTarget){
      // w/o altered newTarget, optimization for 0-4 arguments
      switch(args.length){
        case 0: return new Target;
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args));
    }
    // with altered newTarget, not support built-in constructors
    var proto    = newTarget.prototype
      , instance = create(isObject(proto) ? proto : Object.prototype)
      , result   = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP          = __webpack_require__(13)
  , $export     = __webpack_require__(0)
  , anObject    = __webpack_require__(4)
  , toPrimitive = __webpack_require__(36);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(7)(function(){
  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes){
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export  = __webpack_require__(0)
  , gOPD     = __webpack_require__(27).f
  , anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey){
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export  = __webpack_require__(0)
  , anObject = __webpack_require__(4);
var Enumerate = function(iterated){
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = []       // keys
    , key;
  for(key in iterated)keys.push(key);
};
__webpack_require__(139)(Enumerate, 'Object', function(){
  var that = this
    , keys = that._k
    , key;
  do {
    if(that._i >= keys.length)return {value: undefined, done: true};
  } while(!((key = keys[that._i++]) in that._t));
  return {value: key, done: false};
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target){
    return new Enumerate(target);
  }
});

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD     = __webpack_require__(27)
  , $export  = __webpack_require__(0)
  , anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
    return gOPD.f(anObject(target), propertyKey);
  }
});

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export  = __webpack_require__(0)
  , getProto = __webpack_require__(28)
  , anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target){
    return getProto(anObject(target));
  }
});

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD           = __webpack_require__(27)
  , getPrototypeOf = __webpack_require__(28)
  , has            = __webpack_require__(19)
  , $export        = __webpack_require__(0)
  , isObject       = __webpack_require__(9)
  , anObject       = __webpack_require__(4);

function get(target, propertyKey/*, receiver*/){
  var receiver = arguments.length < 3 ? target : arguments[2]
    , desc, proto;
  if(anObject(target) === receiver)return target[propertyKey];
  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', {get: get});

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey){
    return propertyKey in target;
  }
});

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export       = __webpack_require__(0)
  , anObject      = __webpack_require__(4)
  , $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target){
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {ownKeys: __webpack_require__(220)});

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export            = __webpack_require__(0)
  , anObject           = __webpack_require__(4)
  , $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target){
    anObject(target);
    try {
      if($preventExtensions)$preventExtensions(target);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export  = __webpack_require__(0)
  , setProto = __webpack_require__(144);

if(setProto)$export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto){
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP             = __webpack_require__(13)
  , gOPD           = __webpack_require__(27)
  , getPrototypeOf = __webpack_require__(28)
  , has            = __webpack_require__(19)
  , $export        = __webpack_require__(0)
  , createDesc     = __webpack_require__(48)
  , anObject       = __webpack_require__(4)
  , isObject       = __webpack_require__(9);

function set(target, propertyKey, V/*, receiver*/){
  var receiver = arguments.length < 4 ? target : arguments[3]
    , ownDesc  = gOPD.f(anObject(target), propertyKey)
    , existingDescriptor, proto;
  if(!ownDesc){
    if(isObject(proto = getPrototypeOf(target))){
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if(has(ownDesc, 'value')){
    if(ownDesc.writable === false || !isObject(receiver))return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', {set: set});

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var global            = __webpack_require__(5)
  , inheritIfRequired = __webpack_require__(136)
  , dP                = __webpack_require__(13).f
  , gOPN              = __webpack_require__(59).f
  , isRegExp          = __webpack_require__(107)
  , $flags            = __webpack_require__(105)
  , $RegExp           = global.RegExp
  , Base              = $RegExp
  , proto             = $RegExp.prototype
  , re1               = /a/g
  , re2               = /a/g
  // "new" creates a new object, old webkit buggy here
  , CORRECT_NEW       = new $RegExp(re1) !== re1;

if(__webpack_require__(12) && (!CORRECT_NEW || __webpack_require__(7)(function(){
  re2[__webpack_require__(10)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))){
  $RegExp = function RegExp(p, f){
    var tiRE = this instanceof $RegExp
      , piRE = isRegExp(p)
      , fiU  = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function(key){
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function(){ return Base[key]; },
      set: function(it){ Base[key] = it; }
    });
  };
  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(24)(global, 'RegExp', $RegExp);
}

__webpack_require__(62)('RegExp');

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(104)('match', 1, function(defined, MATCH, $match){
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(104)('replace', 2, function(defined, REPLACE, $replace){
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue){
    'use strict';
    var O  = defined(this)
      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(104)('search', 1, function(defined, SEARCH, $search){
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(104)('split', 2, function(defined, SPLIT, $split){
  'use strict';
  var isRegExp   = __webpack_require__(107)
    , _split     = $split
    , $push      = [].push
    , $SPLIT     = 'split'
    , LENGTH     = 'length'
    , LAST_INDEX = 'lastIndex';
  if(
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ){
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function(separator, limit){
      var string = String(this);
      if(separator === undefined && limit === 0)return [];
      // If `separator` is not a regex, use native split
      if(!isRegExp(separator))return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while(match = separatorCopy.exec(string)){
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if(lastIndex > lastLastIndex){
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
          });
          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if(output[LENGTH] >= splitLimit)break;
        }
        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if(lastLastIndex === string[LENGTH]){
        if(lastLength || !separatorCopy.test(''))output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
    $split = function(separator, limit){
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit){
    var O  = defined(this)
      , fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(227);
var anObject    = __webpack_require__(4)
  , $flags      = __webpack_require__(105)
  , DESCRIPTORS = __webpack_require__(12)
  , TO_STRING   = 'toString'
  , $toString   = /./[TO_STRING];

var define = function(fn){
  __webpack_require__(24)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if(__webpack_require__(7)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
  define(function toString(){
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if($toString.name != TO_STRING){
  define(function toString(){
    return $toString.call(this);
  });
}

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(25)('anchor', function(createHTML){
  return function anchor(name){
    return createHTML(this, 'a', 'name', name);
  }
});

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(25)('big', function(createHTML){
  return function big(){
    return createHTML(this, 'big', '', '');
  }
});

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(25)('blink', function(createHTML){
  return function blink(){
    return createHTML(this, 'blink', '', '');
  }
});

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(25)('bold', function(createHTML){
  return function bold(){
    return createHTML(this, 'b', '', '');
  }
});

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $at     = __webpack_require__(147)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos){
    return $at(this, pos);
  }
});

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export   = __webpack_require__(0)
  , toLength  = __webpack_require__(16)
  , context   = __webpack_require__(148)
  , ENDS_WITH = 'endsWith'
  , $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(134)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /*, endPosition = @length */){
    var that = context(this, searchString, ENDS_WITH)
      , endPosition = arguments.length > 1 ? arguments[1] : undefined
      , len    = toLength(that.length)
      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
      , search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(25)('fixed', function(createHTML){
  return function fixed(){
    return createHTML(this, 'tt', '', '');
  }
});

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(25)('fontcolor', function(createHTML){
  return function fontcolor(color){
    return createHTML(this, 'font', 'color', color);
  }
});

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(25)('fontsize', function(createHTML){
  return function fontsize(size){
    return createHTML(this, 'font', 'size', size);
  }
});

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var $export        = __webpack_require__(0)
  , toIndex        = __webpack_require__(63)
  , fromCharCode   = String.fromCharCode
  , $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
    var res  = []
      , aLen = arguments.length
      , i    = 0
      , code;
    while(aLen > i){
      code = +arguments[i++];
      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export  = __webpack_require__(0)
  , context  = __webpack_require__(148)
  , INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(134)(INCLUDES), 'String', {
  includes: function includes(searchString /*, position = 0 */){
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(25)('italics', function(createHTML){
  return function italics(){
    return createHTML(this, 'i', '', '');
  }
});

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(147)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(140)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(25)('link', function(createHTML){
  return function link(url){
    return createHTML(this, 'a', 'href', url);
  }
});

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(0)
  , toIObject = __webpack_require__(26)
  , toLength  = __webpack_require__(16);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite){
    var tpl  = toIObject(callSite.raw)
      , len  = toLength(tpl.length)
      , aLen = arguments.length
      , res  = []
      , i    = 0;
    while(len > i){
      res.push(String(tpl[i++]));
      if(i < aLen)res.push(String(arguments[i]));
    } return res.join('');
  }
});

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(149)
});

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(25)('small', function(createHTML){
  return function small(){
    return createHTML(this, 'small', '', '');
  }
});

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export     = __webpack_require__(0)
  , toLength    = __webpack_require__(16)
  , context     = __webpack_require__(148)
  , STARTS_WITH = 'startsWith'
  , $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(134)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /*, position = 0 */){
    var that   = context(this, searchString, STARTS_WITH)
      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
      , search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(25)('strike', function(createHTML){
  return function strike(){
    return createHTML(this, 'strike', '', '');
  }
});

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(25)('sub', function(createHTML){
  return function sub(){
    return createHTML(this, 'sub', '', '');
  }
});

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(25)('sup', function(createHTML){
  return function sup(){
    return createHTML(this, 'sup', '', '');
  }
});

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(73)('trim', function($trim){
  return function trim(){
    return $trim(this, 3);
  };
});

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(5)
  , has            = __webpack_require__(19)
  , DESCRIPTORS    = __webpack_require__(12)
  , $export        = __webpack_require__(0)
  , redefine       = __webpack_require__(24)
  , META           = __webpack_require__(47).KEY
  , $fails         = __webpack_require__(7)
  , shared         = __webpack_require__(111)
  , setToStringTag = __webpack_require__(72)
  , uid            = __webpack_require__(64)
  , wks            = __webpack_require__(10)
  , wksExt         = __webpack_require__(225)
  , wksDefine      = __webpack_require__(153)
  , keyOf          = __webpack_require__(484)
  , enumKeys       = __webpack_require__(483)
  , isArray        = __webpack_require__(138)
  , anObject       = __webpack_require__(4)
  , toIObject      = __webpack_require__(26)
  , toPrimitive    = __webpack_require__(36)
  , createDesc     = __webpack_require__(48)
  , _create        = __webpack_require__(58)
  , gOPNExt        = __webpack_require__(217)
  , $GOPD          = __webpack_require__(27)
  , $DP            = __webpack_require__(13)
  , $keys          = __webpack_require__(60)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(59).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(88).f  = $propertyIsEnumerable;
  __webpack_require__(110).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(57)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(23)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export      = __webpack_require__(0)
  , $typed       = __webpack_require__(112)
  , buffer       = __webpack_require__(152)
  , anObject     = __webpack_require__(4)
  , toIndex      = __webpack_require__(63)
  , toLength     = __webpack_require__(16)
  , isObject     = __webpack_require__(9)
  , ArrayBuffer  = __webpack_require__(5).ArrayBuffer
  , speciesConstructor = __webpack_require__(146)
  , $ArrayBuffer = buffer.ArrayBuffer
  , $DataView    = buffer.DataView
  , $isView      = $typed.ABV && ArrayBuffer.isView
  , $slice       = $ArrayBuffer.prototype.slice
  , VIEW         = $typed.VIEW
  , ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it){
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(7)(function(){
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end){
    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
    var len    = anObject(this).byteLength
      , first  = toIndex(start, len)
      , final  = toIndex(end === undefined ? len : end, len)
      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
      , viewS  = new $DataView(this)
      , viewT  = new $DataView(result)
      , index  = 0;
    while(first < final){
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(62)(ARRAY_BUFFER);

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(112).ABV, {
  DataView: __webpack_require__(152).DataView
});

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Float32', 4, function(init){
  return function Float32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Float64', 8, function(init){
  return function Float64Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Int16', 2, function(init){
  return function Int16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Int32', 4, function(init){
  return function Int32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Int8', 1, function(init){
  return function Int8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Uint16', 2, function(init){
  return function Uint16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Uint32', 4, function(init){
  return function Uint32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Uint8', 1, function(init){
  return function Uint8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Uint8', 1, function(init){
  return function Uint8ClampedArray(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
}, true);

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(209);

// 23.4 WeakSet Objects
__webpack_require__(103)('WeakSet', function(get){
  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value){
    return weak.def(this, value, true);
  }
}, weak, false, true);

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export   = __webpack_require__(0)
  , $includes = __webpack_require__(102)(true);

$export($export.P, 'Array', {
  includes: function includes(el /*, fromIndex = 0 */){
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(69)('includes');

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export   = __webpack_require__(0)
  , microtask = __webpack_require__(143)()
  , process   = __webpack_require__(5).process
  , isNode    = __webpack_require__(29)(process) == 'process';

$export($export.G, {
  asap: function asap(fn){
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0)
  , cof     = __webpack_require__(29);

$export($export.S, 'Error', {
  isError: function isError(it){
    return cof(it) === 'Error';
  }
});

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(0);

$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(208)('Map')});

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1){
    var $x0 = x0 >>> 0
      , $x1 = x1 >>> 0
      , $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v){
    var UINT16 = 0xffff
      , $u = +u
      , $v = +v
      , u0 = $u & UINT16
      , v0 = $v & UINT16
      , u1 = $u >> 16
      , v1 = $v >> 16
      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1){
    var $x0 = x0 >>> 0
      , $x1 = x1 >>> 0
      , $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v){
    var UINT16 = 0xffff
      , $u = +u
      , $v = +v
      , u0 = $u & UINT16
      , v0 = $v & UINT16
      , u1 = $u >>> 16
      , v1 = $v >>> 16
      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export         = __webpack_require__(0)
  , toObject        = __webpack_require__(17)
  , aFunction       = __webpack_require__(22)
  , $defineProperty = __webpack_require__(13);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(12) && $export($export.P + __webpack_require__(109), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter){
    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
  }
});

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export         = __webpack_require__(0)
  , toObject        = __webpack_require__(17)
  , aFunction       = __webpack_require__(22)
  , $defineProperty = __webpack_require__(13);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(12) && $export($export.P + __webpack_require__(109), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter){
    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
  }
});

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export  = __webpack_require__(0)
  , $entries = __webpack_require__(219)(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export        = __webpack_require__(0)
  , ownKeys        = __webpack_require__(220)
  , toIObject      = __webpack_require__(26)
  , gOPD           = __webpack_require__(27)
  , createProperty = __webpack_require__(131);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
    var O       = toIObject(object)
      , getDesc = gOPD.f
      , keys    = ownKeys(O)
      , result  = {}
      , i       = 0
      , key;
    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
    return result;
  }
});

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export                  = __webpack_require__(0)
  , toObject                 = __webpack_require__(17)
  , toPrimitive              = __webpack_require__(36)
  , getPrototypeOf           = __webpack_require__(28)
  , getOwnPropertyDescriptor = __webpack_require__(27).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(12) && $export($export.P + __webpack_require__(109), 'Object', {
  __lookupGetter__: function __lookupGetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.get;
    } while(O = getPrototypeOf(O));
  }
});

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export                  = __webpack_require__(0)
  , toObject                 = __webpack_require__(17)
  , toPrimitive              = __webpack_require__(36)
  , getPrototypeOf           = __webpack_require__(28)
  , getOwnPropertyDescriptor = __webpack_require__(27).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(12) && $export($export.P + __webpack_require__(109), 'Object', {
  __lookupSetter__: function __lookupSetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.set;
    } while(O = getPrototypeOf(O));
  }
});

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0)
  , $values = __webpack_require__(219)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export     = __webpack_require__(0)
  , global      = __webpack_require__(5)
  , core        = __webpack_require__(40)
  , microtask   = __webpack_require__(143)()
  , OBSERVABLE  = __webpack_require__(10)('observable')
  , aFunction   = __webpack_require__(22)
  , anObject    = __webpack_require__(4)
  , anInstance  = __webpack_require__(56)
  , redefineAll = __webpack_require__(61)
  , hide        = __webpack_require__(23)
  , forOf       = __webpack_require__(70)
  , RETURN      = forOf.RETURN;

var getMethod = function(fn){
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function(subscription){
  var cleanup = subscription._c;
  if(cleanup){
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function(subscription){
  return subscription._o === undefined;
};

var closeSubscription = function(subscription){
  if(!subscriptionClosed(subscription)){
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function(observer, subscriber){
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup      = subscriber(observer)
      , subscription = cleanup;
    if(cleanup != null){
      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch(e){
    observer.error(e);
    return;
  } if(subscriptionClosed(this))cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe(){ closeSubscription(this); }
});

var SubscriptionObserver = function(subscription){
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value){
    var subscription = this._s;
    if(!subscriptionClosed(subscription)){
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if(m)return m.call(observer, value);
      } catch(e){
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value){
    var subscription = this._s;
    if(subscriptionClosed(subscription))throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if(!m)throw value;
      value = m.call(observer, value);
    } catch(e){
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value){
    var subscription = this._s;
    if(!subscriptionClosed(subscription)){
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch(e){
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber){
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer){
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn){
    var that = this;
    return new (core.Promise || global.Promise)(function(resolve, reject){
      aFunction(fn);
      var subscription = that.subscribe({
        next : function(value){
          try {
            return fn(value);
          } catch(e){
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x){
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if(method){
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function(observer){
        return observable.subscribe(observer);
      });
    }
    return new C(function(observer){
      var done = false;
      microtask(function(){
        if(!done){
          try {
            if(forOf(x, false, function(it){
              observer.next(it);
              if(done)return RETURN;
            }) === RETURN)return;
          } catch(e){
            if(done)throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function(){ done = true; };
    });
  },
  of: function of(){
    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function(observer){
      var done = false;
      microtask(function(){
        if(!done){
          for(var i = 0; i < items.length; ++i){
            observer.next(items[i]);
            if(done)return;
          } observer.complete();
        }
      });
      return function(){ done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function(){ return this; });

$export($export.G, {Observable: $Observable});

__webpack_require__(62)('Observable');

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var metadata                  = __webpack_require__(42)
  , anObject                  = __webpack_require__(4)
  , toMetaKey                 = metadata.key
  , ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
}});

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(42)
  , anObject               = __webpack_require__(4)
  , toMetaKey              = metadata.key
  , getOrCreateMetadataMap = metadata.map
  , store                  = metadata.store;

metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
  if(metadataMap.size)return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
}});

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var Set                     = __webpack_require__(228)
  , from                    = __webpack_require__(204)
  , metadata                = __webpack_require__(42)
  , anObject                = __webpack_require__(4)
  , getPrototypeOf          = __webpack_require__(28)
  , ordinaryOwnMetadataKeys = metadata.keys
  , toMetaKey               = metadata.key;

var ordinaryMetadataKeys = function(O, P){
  var oKeys  = ordinaryOwnMetadataKeys(O, P)
    , parent = getPrototypeOf(O);
  if(parent === null)return oKeys;
  var pKeys  = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
}});

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(42)
  , anObject               = __webpack_require__(4)
  , getPrototypeOf         = __webpack_require__(28)
  , ordinaryHasOwnMetadata = metadata.has
  , ordinaryGetOwnMetadata = metadata.get
  , toMetaKey              = metadata.key;

var ordinaryGetMetadata = function(MetadataKey, O, P){
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var metadata                = __webpack_require__(42)
  , anObject                = __webpack_require__(4)
  , ordinaryOwnMetadataKeys = metadata.keys
  , toMetaKey               = metadata.key;

metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
}});

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(42)
  , anObject               = __webpack_require__(4)
  , ordinaryGetOwnMetadata = metadata.get
  , toMetaKey              = metadata.key;

metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(42)
  , anObject               = __webpack_require__(4)
  , getPrototypeOf         = __webpack_require__(28)
  , ordinaryHasOwnMetadata = metadata.has
  , toMetaKey              = metadata.key;

var ordinaryHasMetadata = function(MetadataKey, O, P){
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if(hasOwn)return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(42)
  , anObject               = __webpack_require__(4)
  , ordinaryHasOwnMetadata = metadata.has
  , toMetaKey              = metadata.key;

metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var metadata                  = __webpack_require__(42)
  , anObject                  = __webpack_require__(4)
  , aFunction                 = __webpack_require__(22)
  , toMetaKey                 = metadata.key
  , ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({metadata: function metadata(metadataKey, metadataValue){
  return function decorator(target, targetKey){
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
}});

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(0);

$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(208)('Set')});

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0)
  , $at     = __webpack_require__(147)(true);

$export($export.P, 'String', {
  at: function at(pos){
    return $at(this, pos);
  }
});

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export     = __webpack_require__(0)
  , defined     = __webpack_require__(30)
  , toLength    = __webpack_require__(16)
  , isRegExp    = __webpack_require__(107)
  , getFlags    = __webpack_require__(105)
  , RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function(regexp, string){
  this._r = regexp;
  this._s = string;
};

__webpack_require__(139)($RegExpStringIterator, 'RegExp String', function next(){
  var match = this._r.exec(this._s);
  return {value: match, done: match === null};
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp){
    defined(this);
    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
    var S     = String(this)
      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0)
  , $pad    = __webpack_require__(224);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0)
  , $pad    = __webpack_require__(224);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(73)('trimLeft', function($trim){
  return function trimLeft(){
    return $trim(this, 1);
  };
}, 'trimStart');

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(73)('trimRight', function($trim){
  return function trimRight(){
    return $trim(this, 2);
  };
}, 'trimEnd');

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153)('asyncIterator');

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153)('observable');

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', {global: __webpack_require__(5)});

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators    = __webpack_require__(155)
  , redefine      = __webpack_require__(24)
  , global        = __webpack_require__(5)
  , hide          = __webpack_require__(23)
  , Iterators     = __webpack_require__(71)
  , wks           = __webpack_require__(10)
  , ITERATOR      = wks('iterator')
  , TO_STRING_TAG = wks('toStringTag')
  , ArrayValues   = Iterators.Array;

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype
    , key;
  if(proto){
    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
  }
}

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0)
  , $task   = __webpack_require__(151);
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global     = __webpack_require__(5)
  , $export    = __webpack_require__(0)
  , invoke     = __webpack_require__(106)
  , partial    = __webpack_require__(485)
  , navigator  = global.navigator
  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function(set){
  return MSIE ? function(fn, time /*, ...args */){
    return set(invoke(
      partial,
      [].slice.call(arguments, 2),
      typeof fn == 'function' ? fn : Function(fn)
    ), time);
  } : set;
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout:  wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(608);
__webpack_require__(547);
__webpack_require__(549);
__webpack_require__(548);
__webpack_require__(551);
__webpack_require__(553);
__webpack_require__(558);
__webpack_require__(552);
__webpack_require__(550);
__webpack_require__(560);
__webpack_require__(559);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(554);
__webpack_require__(546);
__webpack_require__(557);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(514);
__webpack_require__(516);
__webpack_require__(515);
__webpack_require__(564);
__webpack_require__(563);
__webpack_require__(534);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(595);
__webpack_require__(600);
__webpack_require__(607);
__webpack_require__(598);
__webpack_require__(590);
__webpack_require__(591);
__webpack_require__(596);
__webpack_require__(601);
__webpack_require__(603);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(588);
__webpack_require__(589);
__webpack_require__(592);
__webpack_require__(593);
__webpack_require__(594);
__webpack_require__(597);
__webpack_require__(599);
__webpack_require__(602);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(509);
__webpack_require__(511);
__webpack_require__(510);
__webpack_require__(513);
__webpack_require__(512);
__webpack_require__(498);
__webpack_require__(496);
__webpack_require__(502);
__webpack_require__(499);
__webpack_require__(505);
__webpack_require__(507);
__webpack_require__(495);
__webpack_require__(501);
__webpack_require__(492);
__webpack_require__(506);
__webpack_require__(490);
__webpack_require__(504);
__webpack_require__(503);
__webpack_require__(497);
__webpack_require__(500);
__webpack_require__(489);
__webpack_require__(491);
__webpack_require__(494);
__webpack_require__(493);
__webpack_require__(508);
__webpack_require__(155);
__webpack_require__(580);
__webpack_require__(585);
__webpack_require__(227);
__webpack_require__(581);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(584);
__webpack_require__(565);
__webpack_require__(226);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(620);
__webpack_require__(609);
__webpack_require__(610);
__webpack_require__(615);
__webpack_require__(618);
__webpack_require__(619);
__webpack_require__(613);
__webpack_require__(616);
__webpack_require__(614);
__webpack_require__(617);
__webpack_require__(611);
__webpack_require__(612);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(573);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(579);
__webpack_require__(578);
__webpack_require__(621);
__webpack_require__(647);
__webpack_require__(650);
__webpack_require__(649);
__webpack_require__(651);
__webpack_require__(652);
__webpack_require__(648);
__webpack_require__(653);
__webpack_require__(654);
__webpack_require__(632);
__webpack_require__(635);
__webpack_require__(631);
__webpack_require__(629);
__webpack_require__(630);
__webpack_require__(633);
__webpack_require__(634);
__webpack_require__(624);
__webpack_require__(646);
__webpack_require__(655);
__webpack_require__(623);
__webpack_require__(625);
__webpack_require__(627);
__webpack_require__(626);
__webpack_require__(628);
__webpack_require__(637);
__webpack_require__(638);
__webpack_require__(640);
__webpack_require__(639);
__webpack_require__(642);
__webpack_require__(641);
__webpack_require__(643);
__webpack_require__(644);
__webpack_require__(645);
__webpack_require__(622);
__webpack_require__(636);
__webpack_require__(658);
__webpack_require__(657);
__webpack_require__(656);
module.exports = __webpack_require__(40);

/***/ }),
/* 660 */,
/* 661 */,
/* 662 */
/***/ (function(module, exports) {

module.exports = function(opts) {
  return new ElementClass(opts)
}

function indexOf(arr, prop) {
  if (arr.indexOf) return arr.indexOf(prop)
  for (var i = 0, len = arr.length; i < len; i++)
    if (arr[i] === prop) return i
  return -1
}

function ElementClass(opts) {
  if (!(this instanceof ElementClass)) return new ElementClass(opts)
  var self = this
  if (!opts) opts = {}

  // similar doing instanceof HTMLElement but works in IE8
  if (opts.nodeType) opts = {el: opts}

  this.opts = opts
  this.el = opts.el || document.body
  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
}

ElementClass.prototype.add = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return el.className = className
  var classes = el.className.split(' ')
  if (indexOf(classes, className) > -1) return classes
  classes.push(className)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.remove = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return
  var classes = el.className.split(' ')
  var idx = indexOf(classes, className)
  if (idx > -1) classes.splice(idx, 1)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.has = function(className) {
  var el = this.el
  if (!el) return
  var classes = el.className.split(' ')
  return indexOf(classes, className) > -1
}

ElementClass.prototype.toggle = function(className) {
  var el = this.el
  if (!el) return
  if (this.has(className)) this.remove(className)
  else this.add(className)
}


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(75),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(721),
    hashDelete = __webpack_require__(722),
    hashGet = __webpack_require__(723),
    hashHas = __webpack_require__(724),
    hashSet = __webpack_require__(725);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(75),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(75),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(239),
    setCacheAdd = __webpack_require__(745),
    setCacheHas = __webpack_require__(746);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(116),
    stackClear = __webpack_require__(748),
    stackDelete = __webpack_require__(749),
    stackGet = __webpack_require__(750),
    stackHas = __webpack_require__(751),
    stackSet = __webpack_require__(752);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(37);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(75),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 699 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(710),
    isArguments = __webpack_require__(753),
    isArray = __webpack_require__(163),
    isBuffer = __webpack_require__(244),
    isIndex = __webpack_require__(726),
    isTypedArray = __webpack_require__(247);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 701 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 702 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(701),
    isArray = __webpack_require__(163);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(90),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(706),
    isObjectLike = __webpack_require__(91);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(696),
    equalArrays = __webpack_require__(240),
    equalByTag = __webpack_require__(714),
    equalObjects = __webpack_require__(715),
    getTag = __webpack_require__(719),
    isArray = __webpack_require__(163),
    isBuffer = __webpack_require__(244),
    isTypedArray = __webpack_require__(247);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(245),
    isMasked = __webpack_require__(728),
    isObject = __webpack_require__(120),
    toSource = __webpack_require__(242);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(90),
    isLength = __webpack_require__(246),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(729),
    nativeKeys = __webpack_require__(741);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 710 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 711 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 712 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(37);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(162),
    Uint8Array = __webpack_require__(697),
    eq = __webpack_require__(243),
    equalArrays = __webpack_require__(240),
    mapToArray = __webpack_require__(740),
    setToArray = __webpack_require__(747);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(716);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(703),
    getSymbols = __webpack_require__(718),
    keys = __webpack_require__(757);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(162);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(699),
    stubArray = __webpack_require__(759);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(691),
    Map = __webpack_require__(161),
    Promise = __webpack_require__(693),
    Set = __webpack_require__(694),
    WeakMap = __webpack_require__(698),
    baseGetTag = __webpack_require__(90),
    toSource = __webpack_require__(242);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 720 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 722 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 726 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 727 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(713);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 729 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 730 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(117);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(117);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(117);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(117);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(692),
    ListCache = __webpack_require__(116),
    Map = __webpack_require__(161);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(118);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(118);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(118);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(118);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 740 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(744);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(241);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)(module)))

/***/ }),
/* 743 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 744 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 745 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 746 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 747 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(116);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 749 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 750 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 751 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(116),
    Map = __webpack_require__(161),
    MapCache = __webpack_require__(239);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(704),
    isObjectLike = __webpack_require__(91);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(245),
    isLength = __webpack_require__(246);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(705);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(90),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(700),
    baseKeys = __webpack_require__(709),
    isArrayLike = __webpack_require__(754);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(37);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 759 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 760 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(120),
    isSymbol = __webpack_require__(756);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(2);
var ReactDOM = __webpack_require__(66);
var ExecutionEnvironment = __webpack_require__(663);
var ModalPortal = React.createFactory(__webpack_require__(832));
var ariaAppHider = __webpack_require__(833);
var elementClass = __webpack_require__(662);
var renderSubtreeIntoContainer = __webpack_require__(66).unstable_renderSubtreeIntoContainer;
var Assign = __webpack_require__(238);

var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = React.createClass({

  displayName: 'Modal',
  statics: {
    setAppElement: function(element) {
        AppElement = ariaAppHider.setElement(element);
    },
    injectCSS: function() {
      "production" !== "production"
        && console.warn('React-Modal: injectCSS has been deprecated ' +
                        'and no longer has any effect. It will be removed in a later version');
    }
  },

  propTypes: {
    isOpen: React.PropTypes.bool.isRequired,
    style: React.PropTypes.shape({
      content: React.PropTypes.object,
      overlay: React.PropTypes.object
    }),
    portalClassName: React.PropTypes.string,
    appElement: React.PropTypes.instanceOf(SafeHTMLElement),
    onAfterOpen: React.PropTypes.func,
    onRequestClose: React.PropTypes.func,
    closeTimeoutMS: React.PropTypes.number,
    ariaHideApp: React.PropTypes.bool,
    shouldCloseOnOverlayClick: React.PropTypes.bool,
    parentSelector: React.PropTypes.func,
    role: React.PropTypes.string,
    contentLabel: React.PropTypes.string.isRequired
  },

  getDefaultProps: function () {
    return {
      isOpen: false,
      portalClassName: 'ReactModalPortal',
      ariaHideApp: true,
      closeTimeoutMS: 0,
      shouldCloseOnOverlayClick: true,
      parentSelector: function () { return document.body; }
    };
  },

  componentDidMount: function() {
    this.node = document.createElement('div');
    this.node.className = this.props.portalClassName;

    var parent = getParentElement(this.props.parentSelector);
    parent.appendChild(this.node);
    this.renderPortal(this.props);
  },

  componentWillReceiveProps: function(newProps) {
    var currentParent = getParentElement(this.props.parentSelector);
    var newParent = getParentElement(newProps.parentSelector);

    if(newParent !== currentParent) {
      currentParent.removeChild(this.node);
      newParent.appendChild(this.node);
    }

    this.renderPortal(newProps);
  },

  componentWillUnmount: function() {
    if (this.props.ariaHideApp) {
      ariaAppHider.show(this.props.appElement);
    }

    var state = this.portal.state;
    var now = Date.now();
    var closesAt = state.isOpen && this.props.closeTimeoutMS
      && (state.closesAt
        || now + this.props.closeTimeoutMS);

    if (closesAt) {
      if (!state.beforeClose) {
        this.portal.closeWithTimeout();
      }

      var that = this;
      setTimeout(function() { that.removePortal(); }, closesAt - now);
    } else {
      this.removePortal();
    }
  },

  removePortal: function() {
    ReactDOM.unmountComponentAtNode(this.node);
    var parent = getParentElement(this.props.parentSelector);
    parent.removeChild(this.node);
    elementClass(document.body).remove('ReactModal__Body--open');
  },

  renderPortal: function(props) {
    if (props.isOpen) {
      elementClass(document.body).add('ReactModal__Body--open');
    } else {
      elementClass(document.body).remove('ReactModal__Body--open');
    }

    if (props.ariaHideApp) {
      ariaAppHider.toggle(props.isOpen, props.appElement);
    }

    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
  },

  render: function () {
    return React.DOM.noscript();
  }
});

Modal.defaultStyles = {
  overlay: {
    position        : 'fixed',
    top             : 0,
    left            : 0,
    right           : 0,
    bottom          : 0,
    backgroundColor : 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position                : 'absolute',
    top                     : '40px',
    left                    : '40px',
    right                   : '40px',
    bottom                  : '40px',
    border                  : '1px solid #ccc',
    background              : '#fff',
    overflow                : 'auto',
    WebkitOverflowScrolling : 'touch',
    borderRadius            : '4px',
    outline                 : 'none',
    padding                 : '20px'
  }
}

module.exports = Modal


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(2);
var div = React.DOM.div;
var focusManager = __webpack_require__(834);
var scopeTab = __webpack_require__(835);
var Assign = __webpack_require__(238);

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: {
    base: 'ReactModal__Overlay',
    afterOpen: 'ReactModal__Overlay--after-open',
    beforeClose: 'ReactModal__Overlay--before-close'
  },
  content: {
    base: 'ReactModal__Content',
    afterOpen: 'ReactModal__Content--after-open',
    beforeClose: 'ReactModal__Content--before-close'
  }
};

var ModalPortal = module.exports = React.createClass({

  displayName: 'ModalPortal',
  shouldClose: null,

  getDefaultProps: function() {
    return {
      style: {
        overlay: {},
        content: {}
      }
    };
  },

  getInitialState: function() {
    return {
      afterOpen: false,
      beforeClose: false
    };
  },

  componentDidMount: function() {
    // Focus needs to be set when mounting and already open
    if (this.props.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    }
  },

  componentWillUnmount: function() {
    clearTimeout(this.closeTimer);
  },

  componentWillReceiveProps: function(newProps) {
    // Focus only needs to be set once when the modal is being opened
    if (!this.props.isOpen && newProps.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    } else if (this.props.isOpen && !newProps.isOpen) {
      this.close();
    }
  },

  componentDidUpdate: function () {
    if (this.focusAfterRender) {
      this.focusContent();
      this.setFocusAfterRender(false);
    }
  },

  setFocusAfterRender: function (focus) {
    this.focusAfterRender = focus;
  },

  afterClose: function () {
    focusManager.returnFocus();
    focusManager.teardownScopedFocus();
  },

  open: function () {
    if (this.state.afterOpen && this.state.beforeClose) {
      clearTimeout(this.closeTimer);
      this.setState({ beforeClose: false });
    } else {
      focusManager.setupScopedFocus(this.node);
      focusManager.markForFocusLater();
      this.setState({isOpen: true}, function() {
        this.setState({afterOpen: true});

        if (this.props.isOpen && this.props.onAfterOpen) {
          this.props.onAfterOpen();
        }
      }.bind(this));
    }
  },

  close: function() {
    if (this.props.closeTimeoutMS > 0)
      this.closeWithTimeout();
    else
      this.closeWithoutTimeout();
  },

  focusContent: function() {
    // Don't steal focus from inner elements
    if (!this.contentHasFocus()) {
      this.refs.content.focus();
    }
  },

  closeWithTimeout: function() {
    var closesAt = Date.now() + this.props.closeTimeoutMS;
    this.setState({beforeClose: true, closesAt: closesAt}, function() {
      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.state.closesAt - Date.now());
    }.bind(this));
  },

  closeWithoutTimeout: function() {
    this.setState({
      beforeClose: false,
      isOpen: false,
      afterOpen: false,
      closesAt: null
    }, this.afterClose);
  },

  handleKeyDown: function(event) {
    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
    if (event.keyCode == 27 /*esc*/) {
      event.preventDefault();
      this.requestClose(event);
    }
  },

  handleOverlayOnClick: function (event) {
    if (this.shouldClose === null) {
      this.shouldClose = true;
    }

    if (this.shouldClose && this.props.shouldCloseOnOverlayClick) {
      if (this.ownerHandlesClose())
        this.requestClose(event);
      else
        this.focusContent();
    }
    this.shouldClose = null;
  },

  handleContentOnClick: function () {
    this.shouldClose = false;
  },

  requestClose: function(event) {
    if (this.ownerHandlesClose())
      this.props.onRequestClose(event);
  },

  ownerHandlesClose: function() {
    return this.props.onRequestClose;
  },

  shouldBeClosed: function() {
    return !this.state.isOpen && !this.state.beforeClose;
  },

  contentHasFocus: function() {
    return document.activeElement === this.refs.content || this.refs.content.contains(document.activeElement);
  },

  buildClassName: function(which, additional) {
    var className = CLASS_NAMES[which].base;
    if (this.state.afterOpen)
      className += ' '+CLASS_NAMES[which].afterOpen;
    if (this.state.beforeClose)
      className += ' '+CLASS_NAMES[which].beforeClose;
    return additional ? className + ' ' + additional : className;
  },

  render: function() {
    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;

    return this.shouldBeClosed() ? div() : (
      div({
        ref: "overlay",
        className: this.buildClassName('overlay', this.props.overlayClassName),
        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
        onClick: this.handleOverlayOnClick
      },
        div({
          ref: "content",
          style: Assign({}, contentStyles, this.props.style.content || {}),
          className: this.buildClassName('content', this.props.className),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        },
          this.props.children
        )
      )
    );
  }
});


/***/ }),
/* 833 */
/***/ (function(module, exports) {

var _element = typeof document !== 'undefined' ? document.body : null;

function setElement(element) {
  if (typeof element === 'string') {
    var el = document.querySelectorAll(element);
    element = 'length' in el ? el[0] : el;
  }
  _element = element || _element;
  return _element;
}

function hide(appElement) {
  validateElement(appElement);
  (appElement || _element).setAttribute('aria-hidden', 'true');
}

function show(appElement) {
  validateElement(appElement);
  (appElement || _element).removeAttribute('aria-hidden');
}

function toggle(shouldHide, appElement) {
  if (shouldHide)
    hide(appElement);
  else
    show(appElement);
}

function validateElement(appElement) {
  if (!appElement && !_element)
    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
}

function resetForTesting() {
  _element = document.body;
}

exports.toggle = toggle;
exports.setElement = setElement;
exports.show = show;
exports.hide = hide;
exports.resetForTesting = resetForTesting;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var findTabbable = __webpack_require__(376);
var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur(event) {
  needToFocus = true;
}

function handleFocus(event) {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function() {
      if (modalElement.contains(document.activeElement))
        return;
      var el = (findTabbable(modalElement)[0] || modalElement);
      el.focus();
    }, 0);
  }
}

exports.markForFocusLater = function() {
  focusLaterElements.push(document.activeElement);
};

exports.returnFocus = function() {
  var toFocus = null;
  try {
    toFocus = focusLaterElements.pop();
    toFocus.focus();
    return;
  }
  catch (e) {
    console.warn('You tried to return focus to '+toFocus+' but it is not in the DOM anymore');
  }
};

exports.setupScopedFocus = function(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener('blur', handleBlur, false);
    document.addEventListener('focus', handleFocus, true);
  } else {
    window.attachEvent('onBlur', handleBlur);
    document.attachEvent('onFocus', handleFocus);
  }
};

exports.teardownScopedFocus = function() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener('blur', handleBlur);
    document.removeEventListener('focus', handleFocus);
  } else {
    window.detachEvent('onBlur', handleBlur);
    document.detachEvent('onFocus', handleFocus);
  }
};


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var findTabbable = __webpack_require__(376);

module.exports = function(node, event) {
  var tabbable = findTabbable(node);
  if (!tabbable.length) {
      event.preventDefault();
      return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = (
    finalTabbable === document.activeElement ||
    // handle immediate shift+tab after opening with mouse
    node === document.activeElement
  );
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
};


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(831);



/***/ }),
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof process === "object" && process.domain) {
      invoke = process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53), __webpack_require__(92)))

/***/ }),
/* 897 */
/***/ (function(module, exports) {

//fgnass.github.com/spin.js#v1.2.5
/**
 * Copyright (c) 2011 Felix Gnass [fgnass at neteye dot de]
 * Licensed under the MIT license
 */

var prefixes = ['webkit', 'Moz', 'ms', 'O']; /* Vendor prefixes */
var animations = {}; /* Animation rules keyed by their name */
var useCssAnimations;

/**
 * Utility function to create elements. If no tag name is given,
 * a DIV is created. Optionally properties can be passed.
 */
function createEl(tag, prop) {
  var el = document.createElement(tag || 'div');
  var n;

  for(n in prop) {
    el[n] = prop[n];
  }
  return el;
}

/**
 * Appends children and returns the parent.
 */
function ins(parent /* child1, child2, ...*/) {
  for (var i=1, n=arguments.length; i<n; i++) {
    parent.appendChild(arguments[i]);
  }
  return parent;
}

/**
 * Insert a new stylesheet to hold the @keyframe or VML rules.
 */
var sheet = function() {
  var el = createEl('style');
  ins(document.getElementsByTagName('head')[0], el);
  return el.sheet || el.styleSheet;
}();

/**
 * Creates an opacity keyframe animation rule and returns its name.
 * Since most mobile Webkits have timing issues with animation-delay,
 * we create separate rules for each line/segment.
 */
function addAnimation(alpha, trail, i, lines) {
  var name = ['opacity', trail, ~~(alpha*100), i, lines].join('-');
  var start = 0.01 + i/lines*100;
  var z = Math.max(1-(1-alpha)/trail*(100-start) , alpha);
  var prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase();
  var pre = prefix && '-'+prefix+'-' || '';

  if (!animations[name]) {
    sheet.insertRule(
      '@' + pre + 'keyframes ' + name + '{' +
      '0%{opacity:'+z+'}' +
      start + '%{opacity:'+ alpha + '}' +
      (start+0.01) + '%{opacity:1}' +
      (start+trail)%100 + '%{opacity:'+ alpha + '}' +
      '100%{opacity:'+ z + '}' +
      '}', 0);
    animations[name] = 1;
  }
  return name;
}

/**
 * Tries various vendor prefixes and returns the first supported property.
 **/
function vendor(el, prop) {
  var s = el.style;
  var pp;
  var i;

  if(s[prop] !== undefined) return prop;
  prop = prop.charAt(0).toUpperCase() + prop.slice(1);
  for(i=0; i<prefixes.length; i++) {
    pp = prefixes[i]+prop;
    if(s[pp] !== undefined) return pp;
  }
}

/**
 * Sets multiple style properties at once.
 */
function css(el, prop) {
  for (var n in prop) {
    el.style[vendor(el, n)||n] = prop[n];
  }
  return el;
}

/**
 * Fills in default values.
 */
function merge(obj) {
  for (var i=1; i < arguments.length; i++) {
    var def = arguments[i];
    for (var n in def) {
      if (obj[n] === undefined) obj[n] = def[n];
    }
  }
  return obj;
}

/**
 * Returns the absolute page-offset of the given element.
 */
function pos(el) {
  var o = {x:el.offsetLeft, y:el.offsetTop};
  while((el = el.offsetParent)) {
    o.x+=el.offsetLeft;
    o.y+=el.offsetTop;
  }
  return o;
}

var defaults = {
  lines: 12,            // The number of lines to draw
  length: 7,            // The length of each line
  width: 5,             // The line thickness
  radius: 10,           // The radius of the inner circle
  rotate: 0,            // rotation offset
  color: '#000',        // #rgb or #rrggbb
  speed: 1,             // Rounds per second
  trail: 100,           // Afterglow percentage
  opacity: 1/4,         // Opacity of the lines
  fps: 20,              // Frames per second when using setTimeout()
  zIndex: 2e9,          // Use a high z-index by default
  className: 'spinner', // CSS class to assign to the element
  top: 'auto',          // center vertically
  left: 'auto'          // center horizontally
};

/** The constructor */
var Spinner = function Spinner(o) {
  if (!this.spin) return new Spinner(o);
  this.opts = merge(o || {}, Spinner.defaults, defaults);
};

Spinner.defaults = {};
merge(Spinner.prototype, {
  spin: function(target) {
    this.stop();
    var self = this;
    var o = self.opts;
    var el = self.el = css(createEl(0, {className: o.className}), {position: 'relative', zIndex: o.zIndex});
    var mid = o.radius+o.length+o.width;
    var ep; // element position
    var tp; // target position

    if (target) {
      target.insertBefore(el, target.firstChild||null);
      tp = pos(target);
      ep = pos(el);
      css(el, {
        left: (o.left == 'auto' ? tp.x-ep.x + (target.offsetWidth >> 1) : o.left+mid) + 'px',
        top: (o.top == 'auto' ? tp.y-ep.y + (target.offsetHeight >> 1) : o.top+mid)  + 'px'
      });
    }

    el.setAttribute('aria-role', 'progressbar');
    self.lines(el, self.opts);

    if (!useCssAnimations) {
      // No CSS animation support, use setTimeout() instead
      var i = 0;
      var fps = o.fps;
      var f = fps/o.speed;
      var ostep = (1-o.opacity)/(f*o.trail / 100);
      var astep = f/o.lines;

      !function anim() {
        i++;
        for (var s=o.lines; s; s--) {
          var alpha = Math.max(1-(i+s*astep)%f * ostep, o.opacity);
          self.opacity(el, o.lines-s, alpha, o);
        }
        self.timeout = self.el && setTimeout(anim, ~~(1000/fps));
      }();
    }
    return self;
  },
  stop: function() {
    var el = this.el;
    if (el) {
      clearTimeout(this.timeout);
      if (el.parentNode) el.parentNode.removeChild(el);
      this.el = undefined;
    }
    return this;
  },
  lines: function(el, o) {
    var i = 0;
    var seg;

    function fill(color, shadow) {
      return css(createEl(), {
        position: 'absolute',
        width: (o.length+o.width) + 'px',
        height: o.width + 'px',
        background: color,
        boxShadow: shadow,
        transformOrigin: 'left',
        transform: 'rotate(' + ~~(360/o.lines*i+o.rotate) + 'deg) translate(' + o.radius+'px' +',0)',
        borderRadius: (o.width>>1) + 'px'
      });
    }
    for (; i < o.lines; i++) {
      seg = css(createEl(), {
        position: 'absolute',
        top: 1+~(o.width/2) + 'px',
        transform: o.hwaccel ? 'translate3d(0,0,0)' : '',
        opacity: o.opacity,
        animation: useCssAnimations && addAnimation(o.opacity, o.trail, i, o.lines) + ' ' + 1/o.speed + 's linear infinite'
      });
      if (o.shadow) ins(seg, css(fill('#000', '0 0 4px ' + '#000'), {top: 2+'px'}));
      ins(el, ins(seg, fill(o.color, '0 0 1px rgba(0,0,0,.1)')));
    }
    return el;
  },
  opacity: function(el, i, val) {
    if (i < el.childNodes.length) el.childNodes[i].style.opacity = val;
  }
});

/////////////////////////////////////////////////////////////////////////
// VML rendering for IE
/////////////////////////////////////////////////////////////////////////

/**
 * Check and init VML support
 */
!function() {

  function vml(tag, attr) {
    return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr);
  }

  var s = css(createEl('group'), {behavior: 'url(#default#VML)'});

  if (!vendor(s, 'transform') && s.adj) {

    // VML support detected. Insert CSS rule ...
    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)');

    Spinner.prototype.lines = function(el, o) {
      var r = o.length+o.width;
      var s = 2*r;

      function grp() {
        return css(vml('group', {coordsize: s +' '+s, coordorigin: -r +' '+-r}), {width: s, height: s});
      }

      var margin = -(o.width+o.length)*2+'px';
      var g = css(grp(), {position: 'absolute', top: margin, left: margin});

      var i;

      function seg(i, dx, filter) {
        ins(g,
          ins(css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx}),
            ins(css(vml('roundrect', {arcsize: 1}), {
                width: r,
                height: o.width,
                left: o.radius,
                top: -o.width>>1,
                filter: filter
              }),
              vml('fill', {color: o.color, opacity: o.opacity}),
              vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
            )
          )
        );
      }

      if (o.shadow) {
        for (i = 1; i <= o.lines; i++) {
          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)');
        }
      }
      for (i = 1; i <= o.lines; i++) seg(i);
      return ins(el, g);
    };
    Spinner.prototype.opacity = function(el, i, val, o) {
      var c = el.firstChild;
      o = o.shadow && o.lines || 0;
      if (c && i+o < c.childNodes.length) {
        c = c.childNodes[i+o]; c = c && c.firstChild; c = c && c.firstChild;
        if (c) c.opacity = val;
      }
    };
  }
  else {
    useCssAnimations = vendor(s, 'animation');
  }
}();

module.exports = Spinner;


/***/ }),
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(408);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(66);

var _reactRouter = __webpack_require__(128);

var _reactRedux = __webpack_require__(21);

var _reduxResponsive = __webpack_require__(85);

var _reactRouterRedux = __webpack_require__(101);

var _debounce = __webpack_require__(412);

var _debounce2 = _interopRequireDefault(_debounce);

var _store = __webpack_require__(407);

var _store2 = _interopRequireDefault(_store);

var _api = __webpack_require__(54);

var _AppConnected = __webpack_require__(406);

var _AppConnected2 = _interopRequireDefault(_AppConnected);

__webpack_require__(410);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = (0, _api.makeDefaultState)();
var store = (0, _store2.default)(state);
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.hashHistory, store);

// fire redux-responsive on window resize event
window.addEventListener('resize', (0, _debounce2.default)(function () {
  return store.dispatch((0, _reduxResponsive.calculateResponsiveState)(window));
}, 250));

(0, _reactDom.render)(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store },
  _react2.default.createElement(
    _reactRouter.Router,
    { history: history },
    _react2.default.createElement(
      _reactRouter.Route,
      { path: '/', component: _AppConnected2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _AppConnected2.default })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _AppConnected2.default })
  )
), document.getElementById('root'));

/***/ })
],[904]);


// WEBPACK FOOTER //
// bundle.17497adb31da2f43d66b.js